<template>
  <div>
    <loading v-show="showLoader" />

    <div class="ib-main-section">
      <div class="container">
        <div class="row">
          <div class="col-md-6 pl-0">
<!--            <div class="d2c-class-container" style="padding-top: 77px;" v-show="nav_step == 1">-->
<!--              &lt;!&ndash; Nav tabs &ndash;&gt;-->
<!--              <ul class="nav nav-tabs ib-nav-tabs" role="tablist">-->
<!--                <li class="nav-item" v-for="(subClass, index) in subClasses" :key="index" v-if="!hasCategory">-->
<!--                  <a class="nav-link class-box" :class="(selectedSubclassId == subClass.subclass_id) ? 'active' : ''" @click="getQuotationStepOneForm(subClass.subclass_id)">-->
<!--                    <img alt="icon" :src="subClass.logo" />-->
<!--                    <h4 class="class-name class-buy">{{ subClass.name }}</h4>-->
<!--                  </a>-->
<!--                </li>-->
<!--                <li class="nav-item" v-for="(category, index) in categories" :key="index" v-if="hasCategory">-->
<!--                  <a class="nav-link class-box" :class="(selectedCategoryId == category.id) ? 'active' : ''" @click="selectCategory(category.id)">-->
<!--                    <img alt="icon" :src="category.image" />-->
<!--                    <h4 class="class-name class-buy">{{ category.name }}</h4>-->
<!--                  </a>-->
<!--                </li>-->
<!--              </ul>-->
<!--            </div>-->
            <div class="col-md-6 pl-0" v-show="nav_step > 1">
              <div class="" style="padding-top: 77px;">
                <h2 class="listing-page-title" v-if="mainClasses.length > 0">{{ mainClasses.filter(x => x.id == selectedClassId)[0].name }}</h2>
                <div class="d-flex">
                  <div class="listing-page-subclass" v-if="selectedSubclassId != '' && subClasses.length > 0">{{ subClasses.filter(x => x.subclass_id == selectedSubclassId)[0].name }}</div>
                  <div class="listing-page-subclass" v-if="selectedCategoryId != '' && categories.length > 0">{{ categories.filter(x => x.id == selectedCategoryId)[0].name }}</div>
                </div>
                <p class="listing-page-desc" v-if="nav_step == 2 && chooseProductStep == 1">Choose Insurance Plan</p>
                <p class="listing-page-desc" v-if="nav_step == 2 && chooseProductStep > 1">Plan Detail</p>
                <p class="listing-page-desc" v-if="nav_step == 3 && uploadInformationStep == 1">Upload Information</p>
                <p class="listing-page-desc" v-if="nav_step == 3 && uploadInformationStep > 1">Upload Documents</p>
                <p class="listing-page-desc" v-if="nav_step == 4">Choose Payment Method</p>
                <p class="listing-page-desc" v-if="nav_step == 5">Summary</p>
              </div>
            </div>
          </div>
          <div class="col-md-6 d-none d-md-block in-page-infographic">
            <img class="img-fluid" alt="icon" :src="require('@/assets/images/select-class-vehicle.svg')" />
          </div>
        </div>
      </div>

      <div class="container-fluid ib-acquisition-bg">
        <div class="container ib-p-0">
          <!-- Tab panes -->
          <div>
            <div v-if="!showSubmitted" class="container multistep-box">
              <!-- flower for box -->
              <img class="img-fluid in-flower-for-box" alt="icon" :src="require('@/assets/images/flower-for-box.svg')" />
              <!-- flower for box -->
              <!-- MultiStep Form -->
              <div class="container-fluid ib-p-0">
                <div class="row">
                  <div class="col-md-12">
                    <div class="main-form-div py-4">
                      <!-- flex-column -->
                      <div class="ib-form-nav">
                        <img class="img-fluid" v-if="nav_step == 1" :src="require('@/assets/images/acq-form-1.png')">
                        <img class="img-fluid" v-if="nav_step == 2" :src="require('@/assets/images/acq-form-2.png')">
                        <img class="img-fluid" v-if="nav_step == 3" :src="require('@/assets/images/acq-form-3.png')">
                        <img class="img-fluid" v-if="nav_step == 4" :src="require('@/assets/images/acq-form-4.png')">
                        <img class="img-fluid" v-if="nav_step == 5" :src="require('@/assets/images/acq-form-5.png')">
                      </div>
                      <hr class="ib-dotted-hr">
<!--                      <div class="d2c-class-container travel-plans" v-if="hasCategory && nav_step == 1">-->
<!--                        <ul class="nav nav-tabs ib-nav-tabs" role="tablist">-->
<!--                          <li class="nav-item" v-for="(subClass, index) in subClasses" :key="index">-->
<!--                            <a class="nav-link class-box" :class="(selectedSubclassId == subClass.subclass_id) ? 'active' : ''" @click="getQuotationStepOneForm(subClass.subclass_id)">-->
<!--                              <img alt="icon" :src="subClass.logo" />-->
<!--                              <h4 class="class-name class-buy">{{ subClass.name }}</h4>-->
<!--                            </a>-->
<!--                          </li>-->
<!--                        </ul>-->
<!--                      </div>-->
                      <div>
                        <div class="ib-totalcard-price" v-if="nav_step > 1 && chooseProductStep > 1">
                          <div class="d-md-flex align-items-md-center">
                            <div class="d-flex align-items-center" style="flex:1; padding: 1px; flex-flow:row wrap;">
                              <div class="ib-totalcard-img">
                                <img class="img-fluid" :src="selectedProduct.company_logo">
                              </div>
                              <div class="mr-2">
                                <div class="ib-total-company">{{selectedProduct.company_name}}</div>
                                <div class="ib-total-plan" style="max-width: calc(340px - -90px);">
                                  <span>{{ selectedProduct.product_name }}</span>
                                  <div class="ib-card-plan" v-if="selectedProduct.plan_name != ''">{{ selectedProduct.plan_name }}</div>
                                </div>
                              </div>
                              <div>
                                <div class="ib-total-amount">Premium Amount</div>
                                <div class="ib-total-rupees">{{selectedProduct.currency}} {{priceFormatter(selectedProduct.price)}}</div>
                              </div>
                              <div v-if="calculatedAddonsPrice > 0">
                                <div class="ib-total-amount">Addon's</div>
                                <div class="ib-total-rupees">
                                  {{selectedProduct.currency}} {{priceFormatter(calculatedAddonsPrice)}}
                                </div>
                              </div>
                              <div class="mr-2" v-if="classType == 'motor'">
                                <div class="ib-total-amount">Tracker:</div>
                                <div class="ib-total-rupees" v-if="trackerRequired">Included</div>
                                <div class="ib-total-rupees" v-else>Not Included</div>
                              </div>
                              <div class="mr-2" v-else>
                                <div class="ib-total-amount">Cover Limit</div>
                                <div class="ib-total-rupees">
                                  {{selectedProduct.sum_insured_currency}} {{priceFormatter(selectedProduct.sum_insured_value)}}
                                </div>
                              </div>
                              <div v-if="showWithHoldingTaxData">
                                <div class="ib-total-amount">Withholding Tax</div>
                                <div class="ib-total-rupees" v-if="withHoldingTaxAmount > 0">
                                  {{selectedProduct.currency}} {{priceFormatter(withHoldingTaxAmount)}}
                                </div>
                                <div class="ib-total-rupees" v-else>
                                  {{selectedProduct.currency}} 0
                                </div>
                              </div>
                              <div v-if="promoCodeApplied">
                                <div class="ib-total-amount">Discount</div>
                                <div class="ib-total-rupees" v-if="promoCodeDiscountType == 'percentage'">
                                  {{promoCodeDiscount}}% off
                                </div>
                                <div class="ib-total-rupees" v-else>
                                  {{selectedProduct.currency}} {{promoCodeDiscount}} off
                                </div>
                              </div>
                            </div>
                            <div class="ib-total-final" v-if="!promoCodeApplied">
                              <div class="ib-total-text">
                                Total
                              </div>
                              <div class="ib-total-number">
                                {{selectedProduct.currency}}&nbsp;{{priceFormatter(calculatedProductPrice)}}
                              </div>
                            </div>
                            <div class="ib-total-final" v-else>
                              <div class="ib-total-text">
                                Total &nbsp; <span class="discount-span">{{selectedProduct.currency}}&nbsp;{{priceFormatter(calculatedProductPrice)}}</span>
                              </div>
                              <div class="ib-total-number">
                                {{selectedProduct.currency}}&nbsp;{{priceFormatter(calculatedProductPriceWithDiscount)}}
                              </div>
                            </div>
                          </div>
                        </div>
                        <!-- Acquisition step 1  -->
                        <div v-show="nav_step == 1" id="stepOne">
                          <div class="container" :style="nav_step == 1 ? { display: 'block', opacity: 1 } : {}">
                            <form @submit.prevent="" id="acquisitionStageOne">
                              <div v-for="(section, index) in stepOneSections" :key="index" class="row">
                                <div v-for="(field, index) in section.custom_fields" :key="index" class="col-md-6 px-0 px-sm-3">
                                  <div class="ib-dropdown-error" v-if="field.type.toLowerCase() == 'dropdown'">
                                    <div>
                                      <label>{{field.field_hint ? field.label + ' ' + field.field_hint : field.label}}<span v-if="field.required">*</span></label>
                                      <select style="width: 100% !important;" disabled class="floating-select" :name="field.field_name" v-model="stepOneDynamicFields[field.field_name]" @change="getStepOneChildData(field)">
                                        <option value="">{{field.label.length < 40 ? field.label : 'Select'}}</option>
                                        <option v-for="(value, index) in field.default_values" :value="value.id" :key="index">{{value.text}}</option>
                                      </select>
                                      <span class="highlight"></span>
                                      <div class="ib-custom-select"></div>
                                    </div>

                                    <div v-if="stepOneErrors.filter(x => x.field == field.field_name).length > 0">
                                      <div>
                                        <small class="text-danger">{{stepOneErrors.filter(x => x.field == field.field_name)[0].message}}</small>
                                      </div>
                                    </div>
                                  </div>

                                  <div class="" v-else-if="field.type.toLowerCase() == 'textbox'">
                                    <div v-if="field.inputType.toLowerCase() === 'number'">
                                      <label>{{field.field_hint ? field.label + ' ' + field.field_hint : field.label}}<span v-if="field.required">*</span></label>
                                      <div class="jbl-field">
                                        <input class="jbl-dynamic-input" :readonly="field.field_name == 'vehicle_value' ? false : true" @change="verifyStepOneNumbers($event, field.field_name)" type="text" :name="field.field_name"
                                               v-model="stepOneDynamicFields[field.field_name]" :placeholder="field.label.length < 40 ? 'Enter '+ field.label : 'Enter Details'">
                                      </div>

                                      <div v-if="stepOneErrors.filter(x => x.field == field.field_name).length > 0">
                                        <div>
                                          <small class="text-danger">{{stepOneErrors.filter(x => x.field == field.field_name)[0].message}}</small>
                                        </div>
                                      </div>
                                    </div>
                                    <div v-else-if="field.inputType.toLowerCase() === 'mobile'">
                                      <label>{{field.field_hint ? field.label + ' ' + field.field_hint : field.label}}<span v-if="field.required">*</span></label>
                                      <div class="jbl-field">
                                        <input class="jbl-dynamic-input" :readonly="field.field_name == 'vehicle_value' ? false : true" @change="validateStepOneMobileNo($event, field.field_name)" type="text" :name="field.field_name" v-mask="'+92##########'"
                                               v-model="stepOneDynamicFields[field.field_name]" :placeholder="field.label.length < 40 ? 'Enter '+ field.label : 'Enter Details'">
                                      </div>

                                      <div v-if="stepOneErrors.filter(x => x.field == field.field_name).length > 0">
                                        <div>
                                          <small class="text-danger">{{stepOneErrors.filter(x => x.field == field.field_name)[0].message}}</small>
                                        </div>
                                      </div>
                                    </div>
                                    <div v-else-if="field.inputType.toLowerCase() === 'email'">
                                      <label>{{field.field_hint ? field.label + ' ' + field.field_hint : field.label}}<span v-if="field.required">*</span></label>
                                      <div class="jbl-field">
                                        <input class="jbl-dynamic-input" :readonly="field.field_name == 'vehicle_value' ? false : true" @change="verifyStepOneEmail($event, field.field_name)" type="email" :name="field.field_name"
                                               v-model="stepOneDynamicFields[field.field_name]" :placeholder="field.label.length < 40 ? 'Enter '+ field.label : 'Enter Details'">
                                      </div>

                                      <div v-if="stepOneErrors.filter(x => x.field == field.field_name).length > 0">
                                        <div>
                                          <small class="text-danger">{{stepOneErrors.filter(x => x.field == field.field_name)[0].message}}</small>
                                        </div>
                                      </div>
                                    </div>
                                    <div v-else-if="field.inputType.toLowerCase() === 'cnic'">
                                      <label>{{field.field_hint ? field.label + ' ' + field.field_hint : field.label}}<span v-if="field.required">*</span></label>
                                      <div class="jbl-field">
                                        <input class="jbl-dynamic-input" :readonly="field.field_name == 'vehicle_value' ? false : true" type="text" :name="field.field_name" v-mask="'#####-#######-#'"
                                               v-model="stepOneDynamicFields[field.field_name]" :placeholder="field.label.length < 40 ? 'Enter '+ field.label : 'Enter Details'">
                                      </div>

                                      <div v-if="stepOneErrors.filter(x => x.field == field.field_name).length > 0">
                                        <div>
                                          <small class="text-danger">{{stepOneErrors.filter(x => x.field == field.field_name)[0].message}}</small>
                                        </div>
                                      </div>
                                    </div>
                                    <div v-else>
                                      <label>{{field.field_hint ? field.label + ' ' + field.field_hint : field.label}}<span v-if="field.required">*</span></label>
                                      <div class="jbl-field">
                                        <input class="jbl-dynamic-input" :readonly="field.field_name == 'vehicle_value' ? false : true" :type="field.type" :name="field.field_name" v-model="stepOneDynamicFields[field.field_name]" :placeholder="field.label.length < 40 ? 'Enter '+ field.label : 'Enter Details'">
                                      </div>

                                      <div v-if="stepOneErrors.filter(x => x.field == field.field_name).length > 0">
                                        <div>
                                          <small class="text-danger">{{stepOneErrors.filter(x => x.field == field.field_name)[0].message}}</small>
                                        </div>
                                      </div>
                                    </div>
                                  </div>

                                  <div v-else-if="field.type.toLowerCase() == 'radiobutton'">
                                    <label>{{field.field_hint ? field.label + ' ' + field.field_hint : field.label}}</label>
                                    <div class="list-inline" style="padding-left:7px;">
                                      <div class="list-inline-item mr-5" v-for="(value, index) in field.default_values" :key="index" :for="field.field_name + value.id" style="font-size:14px !important; color:gray;">
                                        <span style="position: relative; left: 2px;">{{value.text}}</span>
                                        <!-- padding-left: 25px; -->
                                        <label class="ib-radio-container" :for="field.field_name + value.id" style="font-size:14px !important; padding-top: 2px;">
                                          <!-- {{value.text}} -->
                                          <input class="" :value="value.id" disabled type="radio" :name="field.field_name" :id="field.field_name + value.id" v-model="stepOneDynamicFields[field.field_name]">
                                          <span class="radio-checkmark"></span>
                                        </label>
                                      </div>
                                    </div>

                                    <div v-if="stepOneErrors.filter(x => x.field == field.field_name).length > 0">
                                      <div style="position:relative; top:28px;">
                                        <small class="text-danger">{{stepOneErrors.filter(x => x.field == field.field_name)[0].message}}</small>
                                      </div>
                                    </div>
                                  </div>

                                  <div class="" v-else-if="field.type.toLowerCase() == 'checkbox'">
                                    <label>{{field.field_hint ? field.label + ' ' + field.field_hint : field.label}}</label>
                                    <div v-for="(value, index) in field.default_values" :key="index">
                                      <input class="" :value="value.id" disabled type="checkbox" :name="field.field_name" :id="field.field_name + value.id" v-model="stepOneDynamicFields[field.field_name]">
                                      <label :for="field.field_name + value.id">{{value.text}}</label>
                                    </div>

                                    <div v-if="stepOneErrors.filter(x => x.field == field.field_name).length > 0">
                                      <div>
                                        <small class="text-danger">{{stepOneErrors.filter(x => x.field == field.field_name)[0].message}}</small>
                                      </div>
                                    </div>
                                  </div>

                                  <div class="" v-else-if="field.type.toLowerCase() == 'datetime'">
                                    <label>{{field.field_hint ? field.label + ' ' + field.field_hint : field.label}}<span v-if="field.required">*</span></label>
                                    <div class="jbl-field">
                                      <datepicker initial-view="year" class="jbl-dynamic-input" disabled :name="field.field_name" v-model="stepOneDynamicFields[field.field_name]" format="dd-MMM-yyyy" placeholder="DD-MM-YYYY" input-class="jbl-generated-input" calendar-class="jbl-calendar"></datepicker>
                                    </div>

                                    <div v-if="stepOneErrors.filter(x => x.field == field.field_name).length > 0">
                                      <div>
                                        <small class="text-danger">{{stepOneErrors.filter(x => x.field == field.field_name)[0].message}}</small>
                                      </div>
                                    </div>
                                  </div>

                                  <div class="" v-else-if="field.type.toLowerCase() == 'date'">
                                    <label>{{field.field_hint ? field.label + ' ' + field.field_hint : field.label}}<span v-if="field.required">*</span></label>
                                    <div class="jbl-field">
                                      <datepicker initial-view="year" class="jbl-dynamic-input" disabled :name="field.field_name" v-model="stepOneDynamicFields[field.field_name]" format="dd-MMM-yyyy" placeholder="DD-MM-YYYY" input-class="jbl-generated-input" calendar-class="jbl-calendar"></datepicker>
                                    </div>

                                    <div v-if="stepOneErrors.filter(x => x.field == field.field_name).length > 0">
                                      <div>
                                        <small class="text-danger">{{stepOneErrors.filter(x => x.field == field.field_name)[0].message}}</small>
                                      </div>
                                    </div>
                                  </div>

                                  <div v-else-if="field.type.toLowerCase() == 'textarea'">
                                    <label>{{field.field_hint ? field.label + ' ' + field.field_hint : field.label}}<span v-if="field.required">*</span></label>
                                    <div class="jbl-field">
                                      <textarea class="jbl-dynamic-input" :readonly="field.field_name == 'vehicle_value' ? false : true" v-model="stepOneDynamicFields[field.field_name]" :name="field.field_name" :placeholder="field.label.length < 40 ? 'Enter '+ field.label : 'Enter Details'"></textarea>
                                    </div>

                                    <div v-if="stepOneErrors.filter(x => x.field == field.field_name).length > 0">
                                      <div>
                                        <small class="text-danger">{{stepOneErrors.filter(x => x.field == field.field_name)[0].message}}</small>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </form>
                            <button class="ib-btn-primary ib-btn-width ib-btn-hover btn-fixed-centered" @click="continueStageOneFrom()" v-if="Object.keys(stepOneSections).length > 0">Next</button>
                          </div>
                        </div>
                        <!-- Acquisition step 2  -->
                        <div v-show="nav_step == 2" id="chooseProduct">
                          <fieldset v-if="chooseProductStep == 1" :style="nav_step == 2 ? { display: 'block', opacity: 1 } : {}">
                            <div class="container-fluid ib-p-0">
                              <div class="row">
                                <div class="col-lg-2 px-sm-0">
                                  <div v-if="showProductComparison">
                                    <h4 class="ib-compare-plans">Compare Plans</h4>
                                    <div class="ib-remove-plans" v-for="(product, index) in comparingProducts" :key="index">
                                      <div class="d-flex align-items-center">
                                        <div class="ib-remove-logo">
                                          <img class="img-fluid" :src="product.company_logo" alt="Logo Icon" />
                                        </div>
                                        <div>
                                          <div class="ib-remove-title">{{product.product_name}}</div>
                                        </div>
                                        <img class="img-fluid ib-x-icon ib-x-icon3" :src="require('@/assets/images/jbl-m-x-icon.png')" alt="x icon" @click="removeComparingProduct(product)"/>
                                      </div>
                                    </div>

                                    <div class="text-center" v-show="comparingProducts.length > 1">
                                      <button class="ib-btn-primary ib-btn-hover" data-toggle="modal" data-target="#productCompareModal" @click="showComparePlansModal()">Compare&nbsp;Plans</button>
                                    </div>

                                    <hr class="ib-dotted-hr" style="width:100% !important;">
                                  </div>

                                  <h4 class="ib-compare-plans">Sort by Premium Amount</h4>
                                  <div class="ib-filter-label">
                                    <div style="width:100%;">
                                      <label class="ib-radio-container ib-compare-filter" for="lowtohigh">
                                        Lowest to Highest
                                        <input type="radio" name="radio" v-model="sortByPremium" value="low to high" id="lowtohigh">
                                        <span class="radio-checkmark"></span>
                                      </label>
                                    </div>
                                  </div>
                                  <div class="ib-filter-label">
                                    <div style="width:100%;">
                                      <label class="ib-radio-container ib-compare-filter" for="hightolow">
                                        Highest to Lowest
                                        <input type="radio" name="radio" v-model="sortByPremium" value="high to low" id="hightolow">
                                        <span class="radio-checkmark"></span>
                                      </label>
                                    </div>
                                  </div>
                                  <hr class="ib-dotted-hr" style="width:100% !important;">
                                  <h4 class="ib-compare-plans">Filter&nbsp;by&nbsp;Company</h4>
                                  <div class="ib-filter-label" v-for="(company, index) in productsCompanies" :key="'filteredcompanies' + index">
                                    <div class="ib-compare-filter" style="text-transform: capitalize;">{{ company }}</div>
                                    <div style="margin-left:auto; margin-top: 4px;">
                                      <label class="ib-checkbox-wrapper ib-required-label remember-forgot-text" style="text-align:left !important;" :for="'filteredcompaniesbox' + index">
                                        <!-- Remember Me -->
                                        <input value="true" type="checkbox" :value="company" v-model="selectedFilteringProductsCompanies" :id="'filteredcompaniesbox' + index">
                                        <span class="checkmark-box compare-checkbox"></span>
                                      </label>
                                    </div>
                                  </div>
                                  <hr class="ib-dotted-hr" style="width:100% !important;">
                                  <h4 class="ib-compare-plans">Filter by Product</h4>
                                  <div class="ib-filter-label" v-for="(name, index) in productsNames" :key="'filteredproductsname' + index">
                                    <div class="ib-compare-filter" style="text-transform: capitalize;">{{ name }}</div>
                                    <div style="margin-left:auto; margin-top: 4px;">
                                      <label class="ib-checkbox-wrapper ib-required-label remember-forgot-text" style="text-align:left !important;" :for="'filteredproductsnamebox' + index">
                                        <input value="true" type="checkbox" :value="name" v-model="selectedFilteringProductsNames" :id="'filteredproductsnamebox' + index">
                                        <span class="checkmark-box compare-checkbox"></span>
                                      </label>
                                    </div>
                                  </div>
                                </div>
                                <div class="col-lg-10" v-if="filteredProducts.length > 0">
                                  <div class="container ib-p-0">
                                    <div class="row">
                                      <div v-for="(product, index) in filteredProducts" :key="'filteredproducts' + index" class="col-lg-6 col-xl-4">
                                        <div class="ib-card" :class="product.plan_name != '' ? '' : 'in-plan-height'">
                                          <div v-if="Object.keys(user).length > 0">
                                            <div class="add-wish-text" @click="addToWishlist(product)" v-if="wishlist.indexOf(product.plan_id) == -1">
                                              <i class="fa fa-heart"></i> &nbsp;Add to Wishlist</div>
                                            <div class="add-wish-text2" @click="addToWishlist(product)" v-if="wishlist.indexOf(product.plan_id) != -1">
                                              <i class="fa fa-heart"></i> &nbsp;Added to Wishlist</div>
                                          </div>
                                          <div class="d-flex align-items-center mb-3">
                                            <div class="ib-card-logo">
                                              <img class="img-fluid" :src="product.company_logo">
                                            </div>
                                            <div class="in-flex-1">
                                              <div class="ib-card-title">{{product.company_name}}</div>
                                            </div>
                                          </div>
                                            <div class="ib-card-subtitle">{{product.product_name}}</div>
                                            <div class="ib-card-plan" style="width: max-content !important;" v-if="product.plan_name != ''">{{product.plan_name}}</div>
                                          <div class="d-flex align-items-baseline">
                                            <div style="width:60%;">
                                              <div class="d-flex w-100">
                                                <div class="ib-card-td1 w-50" style="position: relative; top: 2px;">Validity:</div>
                                                <div class="ib-card-subtitle w-50">{{product.validity}}</div>
                                              </div>
                                              <div class="d-flex w-100" v-if="classType == 'motor'">
                                                <div class="ib-card-td1 w-50">Tracker:</div>
                                                <div class="ib-card-subtitle w-50" v-if="trackerRequired">Included</div>
                                                <div class="ib-card-subtitle w-50" v-else>Not&nbsp;Included</div>
                                              </div>

                                            </div>
                                            <div v-if="classType == 'motor'" style="margin-left:auto !important;">
                                              <div class="ib-card-td1">Rate:</div>
                                              <div class="ib-card-subtitle">{{product.net_premium_rate}}%</div>
                                            </div>
                                            <div v-else>
                                              <div class="ib-card-td1">Cover Limit:</div>
                                              <div class="ib-card-subtitle" style="width: max-content;">{{product.sum_insured_currency}} {{priceFormatter(product.sum_insured_value)}}</div>
                                            </div>
                                          </div>
                                          <div style="margin-top:10px;">
                                            <span class="ib-card-subtitle">Premium Amount: </span> <br><span class="ib-card-currency">{{product.currency}}</span>&nbsp
                                            <span class="ib-card-price">{{priceFormatter(product.price)}}</span>
                                          </div>
                                          <div class="ib-card-plan ib-default-flex" style="width: max-content !important;" v-if="product.is_promo_applicable">
                                            <img class="img-fluid" style="margin-right:5px; width: 14px;" :src="require('@/assets/images/promo-code-icon.svg')" alt="icon">
                                            Promo Code Applicable</div>
                                          <div class="d-flex" :class="product.plan_name != '' ? '' : 'in-plan-btn'">
                                            <div class="pr-1">
                                              <button class="ib-btn-primary ib-btn-hover" @click="selectProduct(product)">Buy&nbsp;Now</button>
                                            </div>
                                            <div v-if="showProductComparison">
                                              <div class="pl-1" v-if="comparingProducts.length > 0 && comparingProducts.filter(x => x.id == product.id).length > 0">
                                                <button class="ib-btn-outline ib-btn-hover" @click="removeComparingProduct(product)">Remove</button>
                                              </div>
                                              <div class="pl-1" v-else>
                                                <button class="ib-btn-outline ib-btn-hover" @click="addComparingProduct(product)">Compare</button>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <button class="ib-btn-primary ib-btn-width ib-btn-hover ml-3 btn-fixed-centered" @click="updateStep(-1)">Back</button>
                                </div>
                                <div class="col-lg-10" v-else>
                                  <div class="row">
                                    <div class="col-12 text-center mt-2 mt-lg-4">
                                      <img class="img-fluid" :src="require('@/assets/images/product-not-found.svg')" alt="icon">
                                      <div class="not-found-title">Product Not Found</div>
                                      <div class="not-found-desc">Nothing Found, Please Try With Another Search Criteria</div>
                                      <div class="or-text">OR</div>
                                        <div class="representative-text">
                                          <a href="tel:03000146666">Call Our Representative</a>
                                        </div>
                                      <div class="in-mt-30">
                                        <button class="ib-btn-primary ib-btn-width" @click="updateStep(-1)">GO BACK</button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </fieldset>
                          <fieldset v-if="chooseProductStep == 2" :style="nav_step == 2 ? { display: 'block', opacity: 1 } : {}">
                            <div class="mt-5" v-if="selectedProduct.add_ons.length > 0">
                              <button class="ib-addon-btn" data-toggle="collapse" data-target="#collapseAddons" aria-expanded="true"
                                      aria-controls="collapseAddons" @click="showAddonDropped = !showAddonDropped">Additional Add Ons:
                                <span class="ib-addon-icon"><i class="fa" :class="showAddonDropped ? 'fa-minus' : 'fa-plus'"></i></span>
                              </button>

                              <div class="collapse" :class="showAddonDropped ? 'show' : ''">
                                <div class="container jbl-media-container px-0" :class="selectedAddonCovers.filter(x => x.id == cover.id).length > 0 ? 'active' : ''"
                                     v-for="(cover, index) in selectedProduct.add_ons" :key="index">
                                  <div class="row">
                                    <div class="col-md-6">
                                      <div class="ib-addon-card">
                                        <div class="d-flex mb-2">
                                          <div class="jbl-addon-media">
                                            <!-- <img class="img-fluid" :src="cover.logo" alt="Image"> -->
                                            <h4 class="addon-card-title">{{cover.cover}}</h4>
                                          </div>
                                          <div class="w-100 ib-btn-position">
                                            <button class="ib-btn-primary ib-btn-hover float-right addon-btn-wh" @click="checkUncheck(cover.id)" v-if="selectedAddonCovers.filter(x => x.id == cover.id).length <= 0">Add +</button>
                                            <button class="ib-btn-outline ib-btn-remove ib-btn-hover float-right addon-btn-wh" style="padding: 5px 23px !important;" @click="checkUncheck(cover.id)" v-if="selectedAddonCovers.filter(x => x.id == cover.id).length > 0">Remove</button>
                                          </div>
                                        </div>
                                        <div class="d-flex">
                                          <div class="">
                                            <h6 class="addon-td-title">Cover Value:</h6>
                                            <div class="d-flex w-100">
                                              <h4 class="addon-td-desc">{{cover.cover_limit}}</h4>
                                            </div>
                                          </div>
                                          <div class="pl-5">
                                            <h6 class="addon-td-title">Premium/Year</h6>
                                            <div class="d-flex w-100">
                                              <h4 class="addon-td-desc">{{selectedProduct.currency}} {{ priceFormatter(cover.cover_limit_amount) }}</h4>
                                            </div>
                                          </div>
                                        </div>
                                        <div class="addon-cover-desc">
                                            {{cover.description}}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="ib-action-btns">
<!--                              <button class="ib-btn-outline ib-btn-width ib-btn-hover mr-3" @click="chooseProductStep = chooseProductStep - 1">Back</button>-->
                              <button class="ib-btn-outline ib-btn-width ib-btn-hover mr-3" @click="updateStep(-1)">Back</button>
                              <button class="ib-btn-primary ib-btn-width ib-btn-hover" @click="chooseProductStep = chooseProductStep + 1">Continue</button>
                            </div>
                          </fieldset>
                          <fieldset v-if="chooseProductStep == 3" :style="nav_step == 2 ? { display: 'block', opacity: 1 } : {}">
                            <div class="container">
                              <div class="row">
                                <div class="col-lg-8">
                                  <h2 class="ib-acq-subheading animate__animated animate__fadeInRight">Plan Details</h2>
                                  <div class="row">
                                    <div class="col-6 col-md-3">
                                      <!-- Product Modal -->
                                      <div class="jbl-modal-link" data-toggle="modal" data-target="#productDescriptionModal">
                                        <img class="img-fluid hero-img" :src="require('@/assets/images/ib-product-m.svg')" alt="icon">
                                        <p>Product Details</p>
                                      </div>
                                      <!-- Modal -->
                                      <div class="modal fade" id="productDescriptionModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                                        <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                                          <div class="modal-content">
                                            <div class="jbl-m-inner">
                                              <div class="modal-header">
                                                <h5 class="jbl-m-title" id="productDescriptionModalTitle">Product Detail</h5>
                                                <span class="ib-m-close ib-x-icon" data-dismiss="modal" aria-label="Close">
                                                  <!-- &times; -->
                                                  <img class="img-fluid" :src="require('@/assets/images/jbl-m-x-icon.png')" alt="Close" />
                                                </span>
                                              </div>
                                              <div class="modal-body">
                                                <p class="jbl-m-list">{{selectedProduct.product_description}}</p>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>

                                    <div class="col-6 col-md-3" v-if="selectedProduct.things_to_note">
                                      <!-- Things To Note Modal -->
                                      <div class="jbl-modal-link" data-toggle="modal" data-target="#thingsToNoteModal">
                                        <img class="img-fluid hero-img" :src="require('@/assets/images/ib-note-m.svg')" alt="icon">
                                        <p>Things To Note</p>
                                      </div>
                                      <!-- Modal -->
                                      <div class="modal fade" id="thingsToNoteModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                                        <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                                          <div class="modal-content">
                                            <div class="jbl-m-inner">
                                              <div class="modal-header">
                                                <h5 class="jbl-m-title" id="thingsToNoteModalTitle">Things To Note</h5>
                                                <span class="ib-m-close ib-x-icon" data-dismiss="modal" aria-label="Close">
                                                  <!-- &times; -->
                                                  <img class="img-fluid" :src="require('@/assets/images/jbl-m-x-icon.png')" alt="Close" />
                                                </span>
                                              </div>
                                              <div class="modal-body">
                                                <div class="jbl-m-inner">
                                                  <p class="jbl-m-list">{{selectedProduct.things_to_note}}</p>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>

                                    <div class="col-6 col-md-3" v-if="selectedProduct.why_buy">
                                      <!-- Why Buy Modal -->
                                      <div class="jbl-modal-link" data-toggle="modal" data-target="#whyBuyModal">
                                        <img class="img-fluid hero-img" :src="require('@/assets/images/ib-whybuy-m.svg')" alt="icon">
                                        <p>Why Buy</p>
                                      </div>
                                      <!-- Modal -->
                                      <div class="modal fade" id="whyBuyModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                                        <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                                          <div class="modal-content">
                                            <div class="jbl-m-inner">
                                              <div class="modal-header">
                                                <h5 class="jbl-m-title" id="whyBuyModalTitle">Why Buy</h5>
                                                <span class="ib-m-close ib-x-icon" data-dismiss="modal" aria-label="Close">
                                                  <!-- &times; -->
                                                  <img class="img-fluid" :src="require('@/assets/images/jbl-m-x-icon.png')" alt="Close" />
                                                </span>
                                              </div>
                                              <div class="modal-body">
                                                <p class="jbl-m-list">{{selectedProduct.why_buy}}</p>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>

                                    <div class="col-6 col-md-3">
                                      <!-- Coverages Modal -->
                                      <div class="jbl-modal-link" data-toggle="modal" data-target="#coveragesModal">
                                        <img class="img-fluid hero-img" :src="require('@/assets/images/ib-coverages-m.svg')" alt="icon">
                                        <p>Coverages</p>
                                      </div>
                                      <!-- Modal -->
                                      <div class="modal fade" id="coveragesModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                                        <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                                          <div class="modal-content">
                                            <div class="jbl-m-inner">
                                              <div class="modal-header">
                                                <h5 class="jbl-m-title" id="coveragesModalTitle">Coverages</h5>
                                                <span class="ib-m-close ib-x-icon" data-dismiss="modal" aria-label="Close">
                                                  <!-- &times; -->
                                                  <img class="img-fluid" :src="require('@/assets/images/jbl-m-x-icon.png')" alt="Close" />
                                                </span>
                                              </div>
                                              <div class="modal-body">
                                                <div id="accordion">
                                                  <div class="card" v-for="(cover, index) in selectedProduct.covers" :key="index">
                                                    <div class="in-accordion-link" :id="'heading'+index">
                                                      <a class="jbl-card-header" data-toggle="collapse" :data-target="'#collapse'+index" aria-expanded="false" :aria-controls="'collapse'+index">
                                                          <img :src="cover.logo" alt="logo" style="width: 35px; height: 35px; margin-right:15px;">
                                                          <div class="in-collapse-text">{{cover.cover}}</div>
                                                        <span class="plus-icon">&plus;</span>
                                                        <span class="minus-icon">&minus;</span>
                                                      </a>
                                                    </div>

                                                    <div :id="'collapse'+index" class="collapse" :class="index == 0 ? 'show' : ''" :aria-labelledby="'heading'+index" data-parent="#accordion">
                                                      <div class="jbl-accordion-body">
                                                        <div v-if="cover.description != null">
                                                          <p class="jbl-summary-price jbl-m-list in-accordion-desc">Description</p>
                                                          <p>{{cover.description}}</p>
                                                        </div>
                                                        <br v-if="cover.description != null && cover.cover_limit != null">
                                                        <div v-if="cover.cover_limit != null">
                                                          <p class="jbl-summary-price jbl-m-list in-accordion-desc">Cover Limit</p>
                                                          <p>{{cover.cover_limit}}</p>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                  <h4 v-if="selectedAddonCovers.length > 0">Add-ons</h4>
                                                  <div class="card" v-for="(cover, index) in selectedAddonCovers" :key="index">
                                                    <div class="in-accordion-link" :id="'heading1'+index">
                                                      <a class="jbl-card-header" data-toggle="collapse" :data-target="'#collapse1'+index" aria-expanded="false" :aria-controls="'collapse1'+index">
                                                        <img :src="cover.logo" alt="logo" style="width: 35px; height: 35px; margin-right:15px;">
                                                        <div class="in-collapse-text">{{cover.cover}}</div>
                                                        <span class="plus-icon">&plus;</span>
                                                        <span class="minus-icon">&minus;</span>
                                                      </a>
                                                    </div>

                                                    <div :id="'collapse1'+index" class="collapse" :class="index == 0 ? 'show' : ''" :aria-labelledby="'heading1'+index" data-parent="#accordion">
                                                      <div class="jbl-accordion-body">
                                                        <div v-if="cover.description != null">
                                                          <p class="jbl-summary-price jbl-m-list in-accordion-desc">Description</p>
                                                          <p>{{cover.description}}</p>
                                                        </div>
                                                        <br v-if="cover.description != null && cover.cover_limit != null">
                                                        <div v-if="cover.cover_limit != null">
                                                          <p class="jbl-summary-price jbl-m-list in-accordion-desc">Cover Limit</p>
                                                          <p>{{cover.cover_limit}}</p>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  <!-- </div>
                                  <div class="row"> -->
                                    <div class="col-6 col-md-3" v-if="selectedProduct.exclusions">
                                      <!-- Exclusions Modal -->
                                      <div class="jbl-modal-link" data-toggle="modal" data-target="#exclusionsModal">
                                        <img class="img-fluid hero-img" :src="require('@/assets/images/ib-exclusion-m.svg')" alt="icon">
                                        <p>Exclusions</p>
                                      </div>
                                      <!-- Modal -->
                                      <div class="modal fade" id="exclusionsModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                                        <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                                          <div class="modal-content">
                                            <div class="jbl-m-inner">
                                              <div class="modal-header">
                                                <h5 class="jbl-m-title" id="exclusionsModalTitle">Exclusions</h5>
                                                <span class="ib-m-close ib-x-icon" data-dismiss="modal" aria-label="Close">
                                                    <!-- &times; -->
                                                  <img class="img-fluid" :src="require('@/assets/images/jbl-m-x-icon.png')" alt="Close"/>
                                                </span>
                                              </div>
                                              <div class="modal-body">
                                                <p class="jbl-m-list">{{selectedProduct.exclusions}}</p>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>

                                    <div class="col-6 col-md-3" v-if="selectedProduct.brochure">
                                      <a :href="selectedProduct.brochure" target="_blank">
                                        <div class="jbl-modal-link">
                                          <img class="img-fluid hero-img" :src="require('@/assets/images/ib-brochure-m.svg')" alt="icon">
                                          <p>Brochure</p>
                                        </div>
                                      </a>
                                    </div>

                                    <div class="col-6 col-md-3" v-if="selectedProduct.claim_example">
                                      <!-- Claim Examples Modal -->
                                      <a class="jbl-modal-link" :href="selectedProduct.claim_example" target="_blank">
                                        <img class="img-fluid hero-img" :src="require('@/assets/images/ib-claim-examples-m.svg')" alt="icon">
                                        <p>Policy Wording</p>
                                      </a>
                                      <!-- Modal -->
                                      <div class="modal fade" id="claimExampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                                        <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                                          <div class="modal-content">
                                            <div class="jbl-m-inner">
                                              <div class="modal-header">
                                                <h5 class="jbl-m-title" id="claimExampleModalTitle">Claim Examples</h5>
                                                <span class="ib-m-close ib-x-icon" data-dismiss="modal" aria-label="Close">
                                                  <!-- &times; -->
                                                  <img class="img-fluid" :src="require('@/assets/images/jbl-m-x-icon.png')" alt="Close" />
                                                </span>
                                              </div>
                                              <div class="modal-body">
                                                <p class="jbl-m-list">{{selectedProduct.claim_example}}</p>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>

                                    <div class="col-6 col-md-3" v-if="selectedProduct.glossary">
                                      <a :href="selectedProduct.glossary" target="_blank">
                                        <div class="jbl-modal-link">
                                          <img class="img-fluid hero-img" :src="require('@/assets/images/ib-glossary-m.svg')" alt="icon">
                                          <p>Glossary</p>
                                        </div>
                                      </a>
                                    </div>
                                  </div>
                                </div>
                                <div class="col-lg-4">
                                  <div class=" animate__animated animate__fadeInRight">
                                    <h2 class="ib-acq-subheading animate__animated animate__fadeInRight">Summary Details</h2>
                                    <div class="summary-right-box">
                                      <div class="d-flex">
                                        <div class="w-40 td-left">Package: </div>
                                        <div class="w-60 td-right">
                                          <span>{{ selectedProduct.product_name }}</span>
                                          <span class="ib-card-plan" v-if="selectedProduct.plan_name != ''">{{ selectedProduct.plan_name }}</span>
                                        </div>
                                      </div>
                                      <div class="d-flex" v-if="classType == 'motor'">
                                        <div class="w-40 td-left">Rate: </div>
                                        <div class="w-60 td-right"><span>{{ selectedProduct.net_premium_rate }}%</span></div>
                                      </div>
                                      <div class="d-flex" v-else>
                                        <div class="w-40 td-left">Cover Limit:</div>
                                        <div class="w-60 td-right"><span>{{selectedProduct.sum_insured_currency}} {{priceFormatter(selectedProduct.sum_insured_value)}}</span></div>
                                      </div>
                                      <div class="d-flex">
                                        <div class="w-40 td-left">Premium Amount: </div>
                                        <div class="w-60 td-right"><span>{{selectedProduct.currency}} {{ priceFormatter(selectedProduct.price) }}</span></div>
                                      </div>
                                      <div class="d-flex" v-if="Object.keys(selectedProduct).length > 0 && selectedProduct.add_ons.length > 0">
                                        <div class="w-40 td-left">Add-On Covers: </div>
                                        <div class="w-60 td-right"><span>{{selectedProduct.currency}} {{ priceFormatter(calculatedAddonsPrice) }}</span></div>
                                      </div>
                                      <div class="w-100 total-box">
                                        <span class="td-left">Total: </span>
                                        <span class="td-right">{{selectedProduct.currency}} {{ priceFormatter(calculatedProductPrice) }}</span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div v-if="selectedAddonCovers.length > 0">
                              <h2 class="ib-acq-subheading animate__animated animate__fadeInRight">Selected Add Ons</h2>
                              <div class="container jbl-media-container px-0 animate__animated animate__fadeInUp" v-for="(cover, index) in selectedAddonCovers" :key="index">
                                <div class="row">
                                  <div class="col-md-6">
                                    <div class="ib-addon-card">
                                    <div class="d-flex mb-2">
                                      <div class="jbl-addon-media">
                                        <h4 class="addon-card-title">{{cover.cover}}</h4>
                                      </div>
                                    </div>
                                    <div class="d-flex">
                                      <div class="">
                                        <h6 class="addon-td-title">Cover Value:</h6>
                                        <div class="d-flex w-100">
                                          <h4 class="addon-td-desc">{{cover.cover_limit}}</h4>
                                        </div>
                                      </div>
                                      <div class="pl-5">
                                        <h6 class="addon-td-title">Premium/Year</h6>
                                        <div class="d-flex w-100">
                                          <h4 class="addon-td-desc">{{selectedProduct.currency}} {{ priceFormatter(cover.cover_limit_amount) }}</h4>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="addon-cover-desc">
                                      {{cover.description}}
                                    </div>
                                  </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="ib-action-btns">
                              <button class="ib-btn-outline ib-btn-width ib-btn-hover mr-3" @click="chooseProductStep = chooseProductStep - 1" v-if="selectedProduct.add_ons.length > 0">Back</button>
<!--                              <button class="ib-btn-outline ib-btn-width ib-btn-hover mr-3" @click="chooseProductStep = chooseProductStep - 2" v-if="selectedProduct.add_ons.length < 1">Back</button>-->
                              <button class="ib-btn-outline ib-btn-width ib-btn-hover mr-3" @click="updateStep(-1)" v-if="selectedProduct.add_ons.length < 1">Back</button>
                              <button class="ib-btn-primary ib-btn-width ib-btn-hover" @click="checkAUth()">Next</button>
                            </div>
                          </fieldset>
                        </div>
                        <!-- Acquisition step 3  -->
                        <div v-show="nav_step == 3" id="UploadInformationAndDocuments">
                          <fieldset v-show="uploadInformationStep == 1" :style="uploadInformationStep == 1 && nav_step == 3 ? { display: 'block', opacity: 1 } : {}">
                            <nav>
                              <!-- nav nav-tabs   -->
                              <div class="nav nav-tabs ib-acq-navtab" id="nav-tab" role="tablist">
                                <a v-for="(section, name, index) in stepThreeSections" class="nav-item nav-link acq-nav-btn" :class="index == 0 ? 'active' : ''" :id="'nav-'+name+'-tab'" data-toggle="tab" :href="'#nav-'+name" role="tab" :aria-controls="'nav-'+name" aria-selected="true">{{name.replace(/_/g,' ')}}</a>
                                <a class="nav-item nav-link acq-nav-btn" id="nav-family-tab" data-toggle="tab" href="#nav-family" role="tab" aria-controls="nav-family" aria-selected="false" v-if="showFamily">Family Detail</a>
                                <a class="nav-item nav-link acq-nav-btn" id="nav-beneficiary-tab" data-toggle="tab" href="#nav-beneficiary" role="tab" aria-controls="nav-beneficiary" aria-selected="false" v-if="showBeneficiary">Beneficiary Detail</a>
                              </div>
                            </nav>
                            <div class="tab-content" id="nav-tabContent">
                              <div class="tab-pane fade" :class="index == 0 ? 'active show' : ''" :id="'nav-'+name" role="tabpanel" :aria-labelledby="'nav-'+name+'-tab'" v-for="(section, name, index) in stepThreeSections" :key="index" >
                                <div class="container">
                                  <form @submit.prevent="" id="acquisitionStageThree">
                                    <div class="row">
                                      <h3 class="col-12 ib-form-subheading">{{name.replace(/_/g,' ')}}</h3>
                                      <div v-for="(field, index) in section.custom_fields" :key="index" class="col-md-6 px-0 px-sm-3">
                                        <div class="">
                                          <div class="ib-dropdown-error" v-if="field.type.toLowerCase() == 'dropdown'">
                                            <div>
                                              <label>{{field.field_hint ? field.label + ' ' + field.field_hint : field.label}}<span v-if="field.required">*</span></label>
                                              <select style="width: 100% !important;" class="floating-select" :name="field.field_name" v-model="stepThreeDynamicFields[field.field_name]" @change="getStepThreeChildData(field)">
                                                <option value="">{{field.label.length < 40 ? 'Select '+ field.label : 'Select'}}</option>
                                                <option v-for="(value, index) in field.default_values" :value="value.id" :key="index">{{value.text}}</option>
                                              </select>
                                              <span class="highlight"></span>
                                              <div class="ib-custom-select"></div>
                                            </div>

                                            <div v-if="stepThreeErrors.filter(x => x.field == field.field_name).length > 0">
                                              <div>
                                                <small class="text-danger">{{stepThreeErrors.filter(x => x.field == field.field_name)[0].message}}</small>
                                              </div>
                                            </div>
                                          </div>
                                          <div class="" v-else-if="field.type.toLowerCase() == 'textbox'">
                                            <div v-if="field.inputType.toLowerCase() === 'number'">
                                              <label>{{field.field_hint ? field.label + ' ' + field.field_hint : field.label}}<span v-if="field.required">*</span></label>
                                              <div class="jbl-field">
                                                <input class="jbl-dynamic-input" @change="verifyStepThreeNumbers($event, field.field_name)" type="text" :name="field.field_name"
                                                       v-model="stepThreeDynamicFields[field.field_name]" :placeholder="field.label.length < 40 ? 'Enter '+ field.label : 'Enter Details'">
                                              </div>

                                              <div v-if="stepThreeErrors.filter(x => x.field == field.field_name).length > 0">
                                                <div>
                                                  <small class="text-danger">{{stepThreeErrors.filter(x => x.field == field.field_name)[0].message}}</small>
                                                </div>
                                              </div>
                                            </div>
                                            <div v-else-if="field.inputType.toLowerCase() === 'mobile'">
                                              <label>{{field.field_hint ? field.label + ' ' + field.field_hint : field.label}}<span v-if="field.required">*</span></label>
                                              <div class="jbl-field">
                                                <input class="jbl-dynamic-input" @change="validateStepThreeMobileNo($event, field.field_name)" type="text" :name="field.field_name" v-mask="'+92##########'"
                                                       v-model="stepThreeDynamicFields[field.field_name]" :placeholder="field.label.length < 40 ? 'Enter '+ field.label : 'Enter Details'">
                                              </div>

                                              <div v-if="stepThreeErrors.filter(x => x.field == field.field_name).length > 0">
                                                <div>
                                                  <small class="text-danger">{{stepThreeErrors.filter(x => x.field == field.field_name)[0].message}}</small>
                                                </div>
                                              </div>
                                            </div>
                                            <div v-else-if="field.inputType.toLowerCase() === 'email'">
                                              <label>{{field.field_hint ? field.label + ' ' + field.field_hint : field.label}}<span v-if="field.required">*</span></label>
                                              <div class="jbl-field">
                                                <input class="jbl-dynamic-input" @change="verifyStepThreeEmail($event, field.field_name)" type="email" :name="field.field_name"
                                                       v-model="stepThreeDynamicFields[field.field_name]" :placeholder="field.label.length < 40 ? 'Enter '+ field.label : 'Enter Details'">
                                              </div>

                                              <div v-if="stepThreeErrors.filter(x => x.field == field.field_name).length > 0">
                                                <div>
                                                  <small class="text-danger">{{stepThreeErrors.filter(x => x.field == field.field_name)[0].message}}</small>
                                                </div>
                                              </div>
                                            </div>
                                            <div v-else-if="field.inputType.toLowerCase() === 'cnic'">
                                              <label>{{field.field_hint ? field.label + ' ' + field.field_hint : field.label}}<span v-if="field.required">*</span></label>
                                              <div class="jbl-field">
                                                <input class="jbl-dynamic-input" type="text" :name="field.field_name" v-mask="'#####-#######-#'" @change="validateTax(field.field_name)"
                                                       v-model="stepThreeDynamicFields[field.field_name]" :placeholder="field.label.length < 40 ? 'Enter '+ field.label : 'Enter Details'">
                                              </div>

                                              <div v-if="showWithHoldingTaxData">
                                                <small class="text-danger" v-if="withHoldingTaxAmount > 0">Non-filer - You will be charged {{withHoldingTaxPercentage}}% Withholding Tax</small>
                                                <small class="text-danger" v-if="withHoldingTaxAmount < 1">Filer - You will not be charged Withholding Tax</small>
                                              </div>

                                              <div v-if="stepThreeErrors.filter(x => x.field == field.field_name).length > 0">
                                                <div>
                                                  <small class="text-danger">{{stepThreeErrors.filter(x => x.field == field.field_name)[0].message}}</small>
                                                </div>
                                              </div>
                                            </div>
                                            <div v-else>
                                              <label>{{field.field_hint ? field.label + ' ' + field.field_hint : field.label}}<span v-if="field.required">*</span></label>
                                              <div class="jbl-field">
                                                <input class="jbl-dynamic-input" :type="field.type" :name="field.field_name" v-model="stepThreeDynamicFields[field.field_name]" :placeholder="field.label.length < 40 ? 'Enter '+ field.label : 'Enter Details'">
                                              </div>

                                              <div v-if="stepThreeErrors.filter(x => x.field == field.field_name).length > 0">
                                                <div>
                                                  <small class="text-danger">{{stepThreeErrors.filter(x => x.field == field.field_name)[0].message}}</small>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          <div v-else-if="field.type.toLowerCase() == 'radiobutton'">
                                            <label>{{field.field_hint ? field.label + ' ' + field.field_hint : field.label}}</label>
                                            <div class="list-inline" style="padding-left:7px;">
                                              <div class="list-inline-item mr-5" v-for="(value, index) in field.default_values" :key="index" style="font-size:14px !important; color:gray;">
                                                <span style="position: relative; left: 2px;">{{value.text}}</span>
                                                <label class="ib-radio-container" :for="field.field_name + value.id" style="font-size:14px !important; padding-top: 2px;">
                                                  <input class="" :value="value.id" type="radio" :name="field.field_name" :id="field.field_name + value.id" v-model="stepThreeDynamicFields[field.field_name]">
                                                  <span class="radio-checkmark"></span>
                                                </label>
                                              </div>
                                            </div>

                                            <div  v-if="stepThreeErrors.filter(x => x.field == field.field_name).length > 0">
                                              <div style="position:relative; top:28px;">
                                                <small class="text-danger">{{stepThreeErrors.filter(x => x.field == field.field_name)[0].message}}</small>
                                              </div>
                                            </div>
                                          </div>
                                          <div class="" v-else-if="field.type.toLowerCase() == 'checkbox'">
                                            <label>{{field.field_hint ? field.label + ' ' + field.field_hint : field.label}}</label>
                                            <div v-for="(value, index) in field.default_values" :key="index">
                                              <input :value="value.id" type="checkbox" :name="field.field_name" :id="field.field_name + value.id" v-model="stepThreeDynamicFields[field.field_name]">
                                              <label :for="field.field_name + value.id">{{value.text}}</label>
                                            </div>

                                            <div v-if="stepThreeErrors.filter(x => x.field == field.field_name).length > 0">
                                              <div>
                                                <small class="text-danger">{{stepThreeErrors.filter(x => x.field == field.field_name)[0].message}}</small>
                                              </div>
                                            </div>
                                          </div>
                                          <div class="" v-else-if="field.type.toLowerCase() == 'datetime'">
                                            <label>{{field.field_hint ? field.label + ' ' + field.field_hint : field.label}}<span v-if="field.required">*</span></label>
                                            <div class="jbl-field">
                                              <datepicker initial-view="year" class="jbl-dynamic-input" :name="field.field_name" v-model="stepThreeDynamicFields[field.field_name]" format="dd-MMM-yyyy" placeholder="DD-MM-YYYY" input-class="jbl-generated-input" calendar-class="jbl-calendar"></datepicker>
                                            </div>

                                            <div v-if="stepThreeErrors.filter(x => x.field == field.field_name).length > 0">
                                              <div>
                                                <small class="text-danger">{{stepThreeErrors.filter(x => x.field == field.field_name)[0].message}}</small>
                                              </div>
                                            </div>
                                          </div>
                                          <div class="" v-else-if="field.type.toLowerCase() == 'date'">
                                            <label>{{field.field_hint ? field.label + ' ' + field.field_hint : field.label}}<span v-if="field.required">*</span></label>
                                            <div class="jbl-field">
                                              <datepicker initial-view="year" class="jbl-dynamic-input" :name="field.field_name" v-model="stepThreeDynamicFields[field.field_name]" format="dd-MMM-yyyy" placeholder="DD-MM-YYYY" input-class="jbl-generated-input" calendar-class="jbl-calendar"></datepicker>
                                            </div>

                                            <div v-if="stepThreeErrors.filter(x => x.field == field.field_name).length > 0">
                                              <div>
                                                <small class="text-danger">{{stepThreeErrors.filter(x => x.field == field.field_name)[0].message}}</small>
                                              </div>
                                            </div>
                                          </div>
                                          <div v-else-if="field.type.toLowerCase() == 'textarea'">
                                            <label>{{field.field_hint ? field.label + ' ' + field.field_hint : field.label}}<span v-if="field.required">*</span></label>
                                            <div class="jbl-field">
                                              <textarea class="jbl-dynamic-input" v-model="stepThreeDynamicFields[field.field_name]" :name="field.field_name" :placeholder="field.label.length < 40 ? 'Enter '+ field.label : 'Enter Details'"></textarea>
                                            </div>

                                            <div v-if="stepThreeErrors.filter(x => x.field == field.field_name).length > 0">
                                              <div>
                                                <small class="text-danger">{{stepThreeErrors.filter(x => x.field == field.field_name)[0].message}}</small>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </form>
                                </div>
                              </div>
                              <div class="tab-pane fade" id="nav-family" role="tabpanel" aria-labelledby="nav-family-tab" v-if="showFamily">
                                <div class="w-75 mx-auto pt-5">
                                  <div class="row">
                                    <div class="col-12 text-center" v-if="submitFamily.spouse.filter(x => x.is_deleted == false).length < 1 && submitFamily.child.filter(x => x.is_deleted == false).length < 1">
                                      <div class="family-image">
                                        <img class="img-fluid" :src="require('@/assets/images/add-family-graphic.svg')" alt="" @click="showAddFamily()">
                                        <div>
                                          <button class="ib-btn-dashed ib-btn-hover ib-inline-flex" @click="showAddFamily()">
                                            <img class="img-fluid mb-0" :src="require('@/assets/images/plus-circle.svg')" alt="">
                                            Add Family</button>
                                        </div>
                                      </div>
                                    </div>
                                    <div v-if="submitFamily.spouse.filter(x => x.is_deleted == false).length > 0 || submitFamily.child.filter(x => x.is_deleted == false).length > 0" class="col-md-6 offset-md-6 text-right">
                                      <button class="ib-btn-outline ib-btn-width-2 ib-btn-hover" @click="showAddFamily()">Add Family</button>
                                    </div>
                                    <div class="col-md-6 pl-0 pl-sm-3" v-for="(spouse, index) in submitFamily.spouse.filter(x => x.is_deleted == false)" :key="'spouse' + index">
                                      <div class="family-label">Spouse <span>*</span></div>
                                      <div class="jbl-beneficiary">
                                        <div class="edit-delete-box">
                                          <div>
                                            <p>{{ spouse.name }}</p>
                                          </div>
                                          <div>
                                            <a @click="showUpdateFamily(spouse.id, 'spouse')" class="ib-edit-btn"><i class="fa fa-edit"></i></a>
                                            <a @click="removeFamily(spouse.id, 'spouse')" class="ib-delete-btn"><i class="fa fa-trash"></i></a>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="col-md-6 pl-0 pl-sm-3" v-for="(child, index) in submitFamily.child.filter(x => x.is_deleted == false)" :key="'child' + index">
                                      <div class="family-label">Child {{index + 1}} <span>*</span></div>
                                      <div class="jbl-beneficiary">
                                        <div class="edit-delete-box">
                                          <div>
                                            <p>{{ child.name }}</p>
                                          </div>
                                          <div>
                                            <a @click="showUpdateFamily(child.id, 'child')" class="ib-edit-btn"><i class="fa fa-edit"></i></a>
                                            <a @click="removeFamily(child.id, 'child')" class="ib-delete-btn"><i class="fa fa-trash"></i></a>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="tab-pane fade" id="nav-beneficiary" role="tabpanel" aria-labelledby="nav-beneficiary-tab" v-if="showBeneficiary">
                                <div class="w-75 mx-auto pt-5">
                                  <div class="row">
                                    <div class="col-12 text-center" v-if="submitBeneficiary.filter(x => x.is_deleted == false).length < 1">
                                      <div class="family-image">
                                        <img class="img-fluid" :src="require('@/assets/images/add-beneficiary-graphic.svg')" alt="" @click="showAddBeneficiary()">
                                        <div>
                                          <button class="ib-btn-dashed ib-btn-hover ib-inline-flex" @click="showAddBeneficiary()">
                                            <img class="img-fluid mb-0" :src="require('@/assets/images/plus-circle.svg')" alt="">
                                            Add Beneficiary</button>
                                        </div>
                                      </div>
                                    </div>
                                    <div v-if="submitBeneficiary.filter(x => x.is_deleted == false).length > 0" class="col-md-6 offset-md-6 text-right">
                                      <button class="ib-btn-outline ib-btn-width-2 ib-btn-hover" @click="showAddBeneficiary()">Add Beneficiary</button>
                                    </div>
                                    <div class="col-md-6 pl-0 pl-sm-3" v-for="(beneficiary, index) in submitBeneficiary.filter(x => x.is_deleted == false)" :key="'beneficiary' + index">
                                      <div class="family-label">Beneficiary {{index + 1}}<span>*</span></div>
                                      <div class="jbl-beneficiary">
                                        <div class="edit-delete-box">
                                          <div>
                                            <p>{{ beneficiary.first_name }} {{ beneficiary.last_name }}</p>
                                          </div>
                                          <div>
                                            <a @click="showUpdateBeneficiary(beneficiary.id)" class="ib-edit-btn"><i class="fa fa-edit"></i></a>
                                            <a @click="removeBeneficiary(beneficiary.id)" class="ib-delete-btn"><i class="fa fa-trash"></i></a>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div v-if="!showDocuments && !requireSelfInspectionImages">
                              <hr>
                              <div class="ib-label-detail">
                                <div class="in-checkbox-wrapper">
                                  <input value="true" type="checkbox" v-model="declaration.things_to_note" id="things_to_note"/>
                                  <label for="things_to_note">I verify points mentioned under <span class="in-text-color">"Things to note"</span> tab.</label>
                                </div>
                                <div class="in-checkbox-wrapper">
                                  <input value="true" type="checkbox" v-model="declaration.right_information" id="right_info"/>
                                  <label for="right_info">The information provided is to the best of my knowledge and misinformation provided can lead to partial or complete
                                    forfeiture by InsuranceBazaar of any premium payment made by me.</label>
                                </div>
                              </div>
                            </div>
                            <div class="ib-action-btns">
                              <button class="ib-btn-outline ib-btn-width ib-btn-hover mr-3" @click="updateStep(-1)">Back</button>
                              <button class="ib-btn-primary ib-btn-width ib-btn-hover" @click="continueStageThreeFrom()">Continue</button>
                            </div>
                          </fieldset>
                          <fieldset v-show="uploadInformationStep == 2" :style="uploadInformationStep == 2 && nav_step == 3 ? { display: 'block', opacity: 1 } : {}">
                            <div class="container mt-5">
                              <h2 class="upload-title">Upload Images</h2>
                              <div class="nav nav-tabs second-navtab mb-3" id="nav-tab1" role="tablist" v-show="classType != 'motor'">
                                <a v-for="(section, index) in selfInspectionSections" :key="'imgnav-'+index" class="nav-item nav-link acq-nav-btn"
                                   :id="'img-nav-tab'+index" data-toggle="tab" :href="'#img-nav'+index" :class="index == 0 ? 'active' : ''"
                                   role="tab" :aria-controls="'img-nav'+index" :aria-selected="index == 0 ? true : false">{{ section.label }}
                                  <div class="nav-img-div"><img class="img-fluid" :src="section.selected_icon" alt=""></div>
                                </a>
                              </div>

                              <div class="tab-content" id="nav-tabContent1">
                                <div class="tab-pane fade" :class="index1 == 0 ? 'active show' : ''" v-for="(section, index1) in selfInspectionSections" :key="'imgtab-'+index1"
                                     :id="'img-nav'+index1" role="tabpanel" :aria-labelledby="'img-nav-tab'+index1">
                                  <div class="row" v-if="selfInspectionDynamicDocuments[section.field_name].length < 1 && section.image_type != 'car'">
                                    <div class="col-12 text-center">
                                      <img class="img-fluid my-3 py-2" :src="require('@/assets/images/add-room.svg')" alt="icon">
                                    </div>
                                  </div>
                                  <div class="row py-5" v-if="section.image_type == 'car'">
                                    <div class="col-md-7 order-2 order-md-1 pt-4 pt-md-0">
                                      <div class="image-gallery">
                                        <div class="image-gallery-row">
                                          <div>
                                            <div class="image-gallery-box">
                                              <img class="img-fluid img-preview"  id="_front_right" :src="stepThreeMotorImagesPath['front_right'][0]" alt="">
                                            </div>
                                            <div v-if="stepThreeMotorImagesErrors.filter(x => x.field == 'front_right').length > 0" class="mt-3 pl-2">
                                              <div>
                                                <small class="text-danger">{{stepThreeMotorImagesErrors.filter(x => x.field == 'front_right')[0].message}}</small>
                                              </div>
                                            </div>
                                          </div>
                                          <div>
                                            <div class="image-gallery-box">
                                              <img class="img-fluid img-preview"  id="_front_center" :src="stepThreeMotorImagesPath['front_center'][0]" alt="">
                                            </div>
                                            <div v-if="stepThreeMotorImagesErrors.filter(x => x.field == 'front_center').length > 0" class="mt-3 pl-2">
                                              <div>
                                                <small class="text-danger">{{stepThreeMotorImagesErrors.filter(x => x.field == 'front_center')[0].message}}</small>
                                              </div>
                                            </div>
                                          </div>
                                          <div>
                                            <div class="image-gallery-box">
                                              <img class="img-fluid img-preview"  id="_front_left" :src="stepThreeMotorImagesPath['front_left'][0]" alt="">
                                            </div>
                                            <div v-if="stepThreeMotorImagesErrors.filter(x => x.field == 'front_left').length > 0" class="mt-3 pl-2">
                                              <div>
                                                <small class="text-danger">{{stepThreeMotorImagesErrors.filter(x => x.field == 'front_left')[0].message}}</small>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        <div class="image-gallery-row">
                                          <div>
                                            <div class="image-gallery-box">
                                              <img class="img-fluid img-preview" id="_center_right" :src="stepThreeMotorImagesPath['center_right'][0]" alt="">
                                            </div>
                                            <div v-if="stepThreeMotorImagesErrors.filter(x => x.field == 'center_right').length > 0" class="mt-3">
                                              <div>
                                                <small class="text-danger">{{stepThreeMotorImagesErrors.filter(x => x.field == 'center_right')[0].message}}</small>
                                              </div>
                                            </div>
                                          </div>
                                          <div>
                                            <div class="image-gallery-box">
                                              <img class="img-fluid img-preview" id="_center_top" :src="stepThreeMotorImagesPath['center_top'][0]" alt="">
                                            </div>
                                            <div v-if="stepThreeMotorImagesErrors.filter(x => x.field == 'center_top').length > 0" class="mt-3">
                                              <div>
                                                <small class="text-danger">{{stepThreeMotorImagesErrors.filter(x => x.field == 'center_top')[0].message}}</small>
                                              </div>
                                            </div>
                                          </div>
                                          <div>
                                            <div class="image-gallery-box">
                                              <img class="img-fluid img-preview" id="_center_left" :src="stepThreeMotorImagesPath['center_left'][0]" alt="">
                                            </div>
                                            <div v-if="stepThreeMotorImagesErrors.filter(x => x.field == 'center_left').length > 0" class="mt-3">
                                              <div>
                                                <small class="text-danger">{{stepThreeMotorImagesErrors.filter(x => x.field == 'center_left')[0].message}}</small>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        <div class="image-gallery-row">
                                          <div>
                                            <div class="image-gallery-box">
                                              <img class="img-fluid img-preview" id="_rear_right" :src="stepThreeMotorImagesPath['rear_right'][0]" alt="">
                                            </div>
                                            <div v-if="stepThreeMotorImagesErrors.filter(x => x.field == 'rear_right').length > 0" class="mt-3">
                                              <div>
                                                <small class="text-danger">{{stepThreeMotorImagesErrors.filter(x => x.field == 'rear_right')[0].message}}</small>
                                              </div>
                                            </div>
                                          </div>
                                          <div>
                                            <div class="image-gallery-box">
                                              <img class="img-fluid img-preview" id="_rear_center" :src="stepThreeMotorImagesPath['rear_center'][0]" alt="">
                                            </div>
                                            <div v-if="stepThreeMotorImagesErrors.filter(x => x.field == 'rear_center').length > 0" class="mt-3">
                                              <div>
                                                <small class="text-danger">{{stepThreeMotorImagesErrors.filter(x => x.field == 'rear_center')[0].message}}</small>
                                              </div>
                                            </div>
                                          </div>
                                          <div>
                                            <div class="image-gallery-box">
                                              <img class="img-fluid img-preview" id="_rear_left" :src="stepThreeMotorImagesPath['rear_left'][0]" alt="">
                                            </div>
                                            <div v-if="stepThreeMotorImagesErrors.filter(x => x.field == 'rear_left').length > 0" class="mt-3">
                                              <div>
                                                <small class="text-danger">{{stepThreeMotorImagesErrors.filter(x => x.field == 'rear_left')[0].message}}</small>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="col-md-5 order-1 order-md-2 mb-3">
                                      <div class="container mx-auto ib-car-bg">
                                        <div class="row">
                                          <div class="col-4">
                                            <div class="input-btn-width input-first-btn">
                                              <input id="front_right" type="file" accept="image/*" @change="uploadStepThreeMotorImages($event, 'front_right')" onclick="this.value=null" class="css-checkbox">
                                              <label for="front_right" class="css-label-checked" v-if="stepThreeMotorImages['front_right'].length > 0" style="font-size:20px !important;">&check;</label>
                                              <label for="front_right" class="css-label" v-else>&#43;</label>
                                            </div>
                                          </div>
                                          <div class="col-4">
                                            <div class="input-btn-width input-second-btn">
                                              <input id="front_center" type="file" accept="image/*" @change="uploadStepThreeMotorImages($event, 'front_center')" onclick="this.value=null" class="css-checkbox">
                                              <label for="front_center" class="css-label-checked" v-if="stepThreeMotorImages['front_center'].length > 0" style="font-size:20px !important;">&check;</label>
                                              <label for="front_center" class="css-label" v-else>&#43;</label>
                                            </div>
                                          </div>
                                          <div class="col-4">
                                            <div class="input-btn-width input-third-btn">
                                              <input  id="front_left" type="file" accept="image/*" @change="uploadStepThreeMotorImages($event, 'front_left')" onclick="this.value=null" class="css-checkbox">
                                              <label for="front_left" class="css-label-checked" v-if="stepThreeMotorImages['front_left'].length > 0" style="font-size:20px !important;">&check;</label>
                                              <label for="front_left" class="css-label" v-else>&#43;</label>
                                            </div>
                                          </div>
                                        </div>
                                        <div class="row">
                                          <div class="col-4">
                                            <div class="input-btn-width input-forth-btn">
                                              <input id="center_right" type="file" accept="image/*" @change="uploadStepThreeMotorImages($event, 'center_right')" onclick="this.value=null" class="css-checkbox">
                                              <label for="center_right" class="css-label-checked" v-if="stepThreeMotorImages['center_right'].length > 0" style="font-size:20px !important;">&check;</label>
                                              <label for="center_right" class="css-label" v-else>&#43;</label>
                                            </div>
                                          </div>
                                          <div class="col-4">
                                            <div class="input-btn-width input-fifth-btn">
                                              <input id="center_top" type="file" accept="image/*" @change="uploadStepThreeMotorImages($event, 'center_top')" onclick="this.value=null" class="css-checkbox">
                                              <label for="center_top" class="css-label-checked" v-if="stepThreeMotorImages['center_top'].length > 0" style="font-size:20px !important;">&check;</label>
                                              <label for="center_top" class="css-label" v-else>&#43;</label>
                                            </div>
                                          </div>
                                          <div class="col-4">
                                            <div class="input-btn-width input-sixth-btn">
                                              <input id="center_left" type="file" accept="image/*" @change="uploadStepThreeMotorImages($event, 'center_left')" onclick="this.value=null" class="css-checkbox">
                                              <label for="center_left" class="css-label-checked" v-if="stepThreeMotorImages['center_left'].length > 0" style="font-size:20px !important;">&check;</label>
                                              <label for="center_left" class="css-label" v-else>&#43;</label>
                                            </div>
                                          </div>
                                        </div>
                                        <div class="row">
                                          <div class="col-4">
                                            <div class="input-btn-width input-seventh-btn">
                                              <input id="rear_right" type="file" accept="image/*" @change="uploadStepThreeMotorImages($event, 'rear_right')" onclick="this.value=null" class="css-checkbox">
                                              <label for="rear_right" class="css-label-checked" v-if="stepThreeMotorImages['rear_right'].length > 0" style="font-size:20px !important;">&check;</label>
                                              <label for="rear_right" class="css-label" v-else>&#43;</label>
                                            </div>
                                          </div>
                                          <div class="col-4">
                                            <div class="input-btn-width input-eighth-btn">
                                              <input id="rear_center" type="file" accept="image/*" @change="uploadStepThreeMotorImages($event, 'rear_center')" onclick="this.value=null" class="css-checkbox">
                                              <label for="rear_center" class="css-label-checked" v-if="stepThreeMotorImages['rear_center'].length > 0" style="font-size:20px !important;">&check;</label>
                                              <label for="rear_center" class="css-label" v-else>&#43;</label>
                                            </div>
                                          </div>
                                          <div class="col-4">
                                            <div class="input-btn-width input-ninth-btn">
                                              <input id="rear_left" type="file" accept="image/*" @change="uploadStepThreeMotorImages($event, 'rear_left')" onclick="this.value=null" class="css-checkbox">
                                              <label for="rear_left" class="css-label-checked" v-if="stepThreeMotorImages['rear_left'].length > 0" style="font-size:20px !important;">&check;</label>
                                              <label for="rear_left" class="css-label" v-else>&#43;</label>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div v-if="section.image_type == 'generic'">
                                    <div class="container">
                                      <div class="row text-center ib-default-flex">
                                        <div class="col-md-6 order-last order-md-first" v-for="(image, index) in selfInspectionDynamicDocuments[section.field_name]" :key="image.name">
                                          <div class="document-list">
                                            <div class="">
                                              <span>
                                                <img class="doc-remove-icon" @click="removeSelfInspectionImages(image, section.field_name)" :src="require('@/assets/images/ib-upload-remove-icon.svg')"></span>
                                            </div>
                                            <span class="document-list-title"><img :src="require('@/assets/images/text-document.svg')"> {{image.name}}</span>
                                          </div>
                                        </div>
                                        <div key="key1" class="col-10 col-sm-8 col-md-10 col-lg-6 mx-auto ml-md-0 order-first order-md-last">
                                          <label class="" :for="'generic-images-' + index1">
                                            <div class="">
                                              <div class="ib-upload-btn">
                                                <div class="jbl-browse-text"></div>
                                              </div>
                                            </div>
                                          </label>

                                          <input style="display: none" :name="section.field_name" :id="'generic-images-' + index1"
                                            type="file"
                                            multiple
                                            accept="image/*"
                                            @change="uploadSelfInspectionImages($event, section.field_name, section.max_images)"
                                            onclick="this.value=null"
                                          />

                                          <div v-if="selfInspectionImagesErrors.filter(x => x.field == section.field_name).length > 0" class="mt-3">
                                            <div class="d-block jbl-text-danger">
                                              <small class="text-danger">{{selfInspectionImagesErrors.filter(x => x.field == section.field_name)[0].message}}</small>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div v-if="!showDocuments">
                              <hr>
                              <div class="ib-label-detail">
                                <div class="in-checkbox-wrapper">
                                  <input value="true" type="checkbox" v-model="declaration.things_to_note" id="things_to_note"/>
                                  <label for="things_to_note">I verify points mentioned under <span class="in-text-color">"Things to note"</span> tab.</label>
                                </div>
                                <div class="in-checkbox-wrapper">
                                  <input value="true" type="checkbox" v-model="declaration.right_information" id="right_info"/>
                                  <label for="right_info">The information provided is to the best of my knowledge and misinformation provided can lead to partial or complete
                                    forfeiture by InsuranceBazaar of any premium payment made by me.</label>
                                </div>
                              </div>
                            </div>
                            <div class="ib-action-btns">
                              <button class="ib-btn-outline ib-btn-width ib-btn-hover mr-3" @click="getPolicyBeneficiaries(1)">Back</button>
                              <button class="ib-btn-primary ib-btn-width ib-btn-hover" @click="validateSelfInspectionImages()">Continue</button>
                            </div>
                          </fieldset>
                          <fieldset v-show="uploadInformationStep == 3" :style="uploadInformationStep == 3 && nav_step == 3 ? { display: 'block', opacity: 1 } : {}">
                            <div class="container">
                              <div class="row">
                                <div class="col-md-8 col-xl-8">
                                  <div v-for="(element, index) in stepThreeDocumentSections" :key="element.field_name">
                                    <div>
                                      <h4 class="ib-upload-heading">{{element.label}}<span v-if="element.required"> *</span></h4>
                                    </div>
                                    <div class="container">
                                      <div class="row text-center ib-default-flex">
                                        <!-- col-lg-8  -->
                                        <div class="col-md-6 order-last order-md-first" v-for="(image, index) in stepThreeDynamicDocuments[element.field_name]" :key="image.name">
                                          <div class="document-list">
                                            <div class="">
                                              <span><img class="doc-remove-icon" :src="require('@/assets/images/ib-upload-remove-icon.svg')" @click="removeStepThreeUploadedImage(index, element.field_name)"></span>
                                            </div>
                                            <span class="document-list-title"><img :src="require('@/assets/images/text-document.svg')"> {{image.name}}</span>
                                          </div>
                                        </div>
                                        <div key="key1" class="col-10 col-sm-8 col-md-10 col-lg-6 mx-auto ml-md-0 order-first order-md-last">
                                          <label class="" :for="index">
                                            <div class="">
                                              <!-- col-10 col-sm-8 col-md-10 col-lg-6 mx-auto ml-md-0  -->
                                              <div class="ib-upload-btn">
                                                <div class="jbl-browse-text"></div>
                                              </div>
                                            </div>
                                            <!-- Upload Document -->
                                          </label>

                                          <input style="display: none" :name="element.field_name" :id="index"
                                            type="file"
                                            multiple
                                            accept="image/*"
                                            @change="uploadStepThreeImages($event, element.field_name, element.max_rule)"
                                            onclick="this.value=null"
                                          />

                                          <div v-if="stepThreeDocumentsErrors.filter(x => x.field == element.field_name).length > 0" class="mt-3">
                                            <div class="d-block jbl-text-danger">
                                              <small class="text-danger">{{stepThreeDocumentsErrors.filter(x => x.field == element.field_name)[0].message}}</small>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="col-md-4 col-xl-4">
                                  <div class="d-none d-md-flex ib-default-flex h-75 mt-3">
                                    <img class="img-fluid" :src="require('@/assets/images/ib-upload-section-right-bg.svg')" alt="Background Image"/>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <hr>

                            <div class="ib-label-detail">
                              <div class="in-checkbox-wrapper">
                                <input value="true" type="checkbox" v-model="declaration.things_to_note" id="things_to_note"/>
                                <label for="things_to_note">I verify points mentioned under <span class="in-text-color">"Things to note"</span> tab.</label>
                              </div>
                              <div class="in-checkbox-wrapper">
                                <input value="true" type="checkbox" v-model="declaration.right_information" id="right_info"/>
                                <label for="right_info">The information provided is to the best of my knowledge and misinformation provided can lead to partial or complete
                                  forfeiture by InsuranceBazaar of any premium payment made by me.</label>
                              </div>
                            </div>
                            <div class="ib-action-btns">
                              <button class="ib-btn-outline ib-btn-width ib-btn-hover mr-3" @click="uploadInformationStep = uploadInformationStep - 1" v-if="classType == 'motor' && requireSelfInspectionImages">Back</button>
                              <button class="ib-btn-outline ib-btn-width ib-btn-hover mr-3" @click="getPolicyBeneficiaries(2)" v-else>Back</button>
                              <button class="ib-btn-primary ib-btn-width ib-btn-hover" @click="submitStepThreeInformation()">Next</button>
                            </div>
                          </fieldset>
                        </div>
                        <!-- Acquisition step 4  -->
                        <div v-show="nav_step == 4" id="choosePaymentMethod">
                          <div class="container" :style="nav_step == 4 ? { display: 'block', opacity: 1 } : {}">
                            <div class="row">
                              <div class="col-12">
                                <div class="promo-field-wrapper">
                                  <label class="jbl-dynamic-label in-label-top">Promo Code<span style="color:red;">*</span></label>
                                  <div class="promo-field">
                                    <div class="jbl-field in-min-height">
                                      <input type="text" class="jbl-dynamic-input in-sm-placehoder" v-model="promoCode" :placeholder="'Enter Promo code here'">
                                    </div>
                                    <input class="promo-apply-btn" type="button" @click="processPromoCode(1)" value="Apply" v-if="!promoCodeApplied">
                                    <input class="promo-applied-btn" type="button" @click="processPromoCode(-1)" value="Remove" v-if="promoCodeApplied">
                                  </div>
                                  <div>
                                    <button class="in-gear-btn" v-if="planPromos.length > 0" data-toggle="modal" data-target="#planPromoModal">
                                      <img class="img-fluid" alt="icon" :src="require('@/assets/images/promo-gear-icon.svg')" />
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-lg-8 mx-auto pt-3">
                                <div class="container">
                                  <nav>
                                    <div class="in-payment-tab" id="nav-tab-payment" role="tablist">
                                      <a class="nav-item nav-link in-payment-btn" v-for="method in paymentMethods" :key="method.id"
                                         @click="choosePaymentMethod(method.payment_method)"
                                         :class="selectedPaymentMethod == method.payment_method ? 'active' : ''">
                                        <div class="img-div"><img class="img-fluid" :src="method.logo" alt="payment icon"></div>
                                        <div class="method-name">{{method.name}}</div>
                                      </a>
                                    </div>
                                  </nav>
                                </div>
                                <div class="row data-row row-tab-content mt-5" id="myTabContent">
                                  <!-- cheque -->
                                  <div class="col-md-12 ml-md-4 pl-md-4" v-if="selectedPaymentMethod.toLowerCase() == 'cheque'">
                                    <div>
                                      <label class="jbl-dynamic-label">Cheque Number</label>
                                      <div class="jbl-field">
                                        <input type="text" class="jbl-dynamic-input" v-model="cheque.cheque_no" :placeholder="'Enter Cheque Number'">
                                      </div>

                                      <div v-if="chequePaymentMethodErrors.filter(x => x.field == 'cheque_no').length > 0">
                                        <div>
                                          <small class="text-danger">{{chequePaymentMethodErrors.filter(x => x.field == 'cheque_no')[0].message}}</small>
                                        </div>
                                      </div>
                                    </div>

                                    <div>
                                      <label class="jbl-dynamic-label">Cheque Issue Date</label>
                                      <div class="jbl-field">
                                        <datepicker initial-view="year" class="jbl-dynamic-input" v-model="cheque.cheque_issue_date" :max="issueDate" format="dd-MMM-yyyy" placeholder="DD-MM-YYYY" input-class="jbl-generated-input" calendar-class="jbl-calendar"></datepicker>
                                      </div>

                                      <div v-if="chequePaymentMethodErrors.filter(x => x.field == 'cheque_issue_date').length > 0">
                                        <div class="d-block jbl-text-danger">
                                          <small class="text-danger">{{chequePaymentMethodErrors.filter(x => x.field == 'cheque_issue_date')[0].message}}</small>
                                        </div>
                                      </div>
                                    </div>

                                    <div class="container" >
                                      <div class="row text-center ib-default-flex">
                                        <div class="col-md-6 order-last order-md-first" key="key2" >
                                          <div class="document-list" v-for="(image, index) in chequeImages" :key="image.name">
                                            <div class="">
                                              <span><img class="doc-remove-icon" @click="removeUploadedChequeImage(index)" :src="require('@/assets/images/ib-upload-remove-icon.svg')" ></span>
                                            </div>
                                            <span class="document-list-title"><img :src="require('@/assets/images/text-document.svg')"> {{image.name}}</span>
                                          </div>
                                        </div>
                                        <div key="key1" class="col-10 col-sm-8 col-md-10 col-lg-6 mx-auto ml-md-0 order-first order-md-last">
                                          <label class="" for="cheque-images">
                                            <div class="">
                                              <div class="ib-upload-btn">
                                                <div class="jbl-browse-text"></div>
                                              </div>
                                            </div>
                                          </label>
                                          <input style="" name="cheque-images" id="cheque-images"
                                                 type="file"
                                                 accept="image/*"
                                                 @change="uploadChequeImages($event)"
                                                 multiple
                                                 onclick="this.value=null"
                                          />
                                          <div v-if="chequePaymentMethodErrors.filter(x => x.field == 'cheque_image').length > 0">
                                            <div class="d-block jbl-text-danger">
                                              <small class="text-danger">{{chequePaymentMethodErrors.filter(x => x.field == 'cheque_image')[0].message}}</small>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <!-- cash -->
                                  <div class="col-md-12 ml-md-4 pl-md-4" v-if="selectedPaymentMethod.toLowerCase() == 'cash'">
                                    <div>
                                      <h4 class="ib-total-amount">Total Amount: </h4>
                                      <p class="ib-total-rupees">{{selectedProduct.currency}}
                                        <span class="jbl-summary-price" v-if="!promoCodeApplied">{{ priceFormatter(calculatedProductPrice) }}</span>
                                        <span class="jbl-summary-price" v-else>{{ priceFormatter(calculatedProductPriceWithDiscount) }}</span>
                                      </p>
                                    </div>
                                  </div>
                                  <!-- easypaisa -->
                                  <div class="col-md-12 ml-md-4 pl-md-4" v-if="selectedPaymentMethod.toLowerCase() == 'easypaisa'">
                                    <div>
                                      <label class="jbl-dynamic-label">Mobile Number<span style="color:red;">*</span></label>
                                      <div class="jbl-field">
                                        <input type="text" class="jbl-dynamic-input" v-model="easypaisa.mobile_no" :placeholder="'Enter Mobile Number'" v-mask="'###########'">
                                      </div>

                                      <div v-if="easyPaisaMethodErrors.filter(x => x.field == 'mobile_no').length > 0">
                                        <div>
                                          <small class="text-danger">{{easyPaisaMethodErrors.filter(x => x.field == 'mobile_no')[0].message}}</small>
                                        </div>
                                      </div>
                                    </div>

                                    <div>
                                      <label class="jbl-dynamic-label">Email<span style="color:red;">*</span></label>
                                      <div class="jbl-field">
                                        <input type="email" class="jbl-dynamic-input" v-model="easypaisa.email" :placeholder="'Enter Email'">
                                      </div>

                                      <div v-if="easyPaisaMethodErrors.filter(x => x.field == 'email').length > 0">
                                        <div>
                                          <small class="text-danger">{{easyPaisaMethodErrors.filter(x => x.field == 'email')[0].message}}</small>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div class="ib-action-btns" v-if="!quotationPaymentStatus">
                                  <button class="ib-btn-outline ib-btn-width ib-btn-hover mr-3" @click="updateStep(-1)">Back</button>
                                  <button data-toggle="pill" class="ib-btn-primary ib-btn-width ib-btn-hover" @click="ContinuePaymentMethod()" v-if="paymentMethods.length > 0">Checkout</button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <!-- Acquisition step 5  -->
                        <div v-show="nav_step == 5" id="summary">
                          <div class="container" :style="nav_step == 5 ? { display: 'block', opacity: 1 } : {}">
                            <div class="row">
                              <div class="col-lg-4 order-lg-2">
                                <h3 class="summary-box-title">Summary Details</h3>
                                <div class="summary-right-box">
                                  <div class="d-flex">
                                    <div class="w-40 td-left">Package: </div>
                                    <div class="w-60 td-right">
                                      <span>{{ selectedProduct.product_name }}</span>
                                      <span class="ib-card-plan" v-if="selectedProduct.plan_name != ''">{{ selectedProduct.plan_name }}</span>
                                    </div>
                                  </div>
                                  <div class="d-flex" v-if="classType == 'motor'">
                                    <div class="w-40 td-left">Rate: </div>
                                    <div class="w-60 td-right"><span>{{ selectedProduct.net_premium_rate }}%</span></div>
                                  </div>
                                  <div class="d-flex" v-else>
                                    <div class="w-40 td-left">Cover Limit:</div>
                                    <div class="w-60 td-right"><span>{{selectedProduct.sum_insured_currency}} {{ priceFormatter(selectedProduct.sum_insured_value) }}</span></div>
                                  </div>
                                  <div class="d-flex">
                                    <div class="w-40 td-left">Premium Amount: </div>
                                    <div class="w-60 td-right"><span>{{selectedProduct.currency}} {{ priceFormatter(selectedProduct.price) }}</span></div>
                                  </div>
                                  <div class="d-flex" v-if="Object.keys(selectedProduct).length > 0 && selectedProduct.add_ons.length > 0">
                                    <div class="w-40 td-left">Add-On Covers: </div>
                                    <div class="w-60 td-right"><span>{{selectedProduct.currency}} {{ priceFormatter(calculatedAddonsPrice) }}</span></div>
                                  </div>
                                  <div class="d-flex" v-if="showWithHoldingTaxData">
                                    <div class="w-40 td-left">Withholding Tax: </div>
                                    <div class="w-60 td-right">
                                      <span v-if="withHoldingTaxAmount > 0">{{selectedProduct.currency}} {{priceFormatter(withHoldingTaxAmount)}}</span>
                                      <span v-else>{{selectedProduct.currency}} 0</span>
                                    </div>
                                  </div>
                                  <div class="d-flex" v-if="promoCodeApplied">
                                    <div class="w-40 td-left">Discount</div>
                                    <div class="w-60 td-right" v-if="promoCodeDiscountType == 'percentage'">
                                      {{promoCodeDiscount}}% off
                                    </div>
                                    <div class="w-60 td-right" v-else>
                                      {{selectedProduct.currency}} {{promoCodeDiscount}} off
                                    </div>
                                  </div>
                                  <div class="w-100 total-box">
                                    <span class="td-left">Total Premium: </span>
                                    <span class="td-right" v-if="!promoCodeApplied">{{selectedProduct.currency}} {{ priceFormatter(calculatedProductPrice) }}</span>
                                    <span class="td-right" v-else>{{selectedProduct.currency}} {{ priceFormatter(calculatedProductPriceWithDiscount) }}</span>
                                  </div>
                                </div>
                              </div>
                              <div class="col-lg-8 order-lg-1">
                                <div class="container px-0 px-lg-3">
                                  <div class="row summary-left-box">
                                    <div class="summary-box-banner" v-if="mainClasses.length > 0">
                                      <div class="summary-banner-logo">
                                        <img class="img-fluid" :src="mainClasses.filter(x => x.id == selectedClassId)[0].logo" alt="class image">
                                      </div>
                                      <h2 class="summary-banner-title">{{mainClasses.filter(x => x.id == selectedClassId)[0].name}}</h2>
                                    </div>
                                    <div class="col-1 d-none d-md-block">
                                      <div class="summary-left-line"></div>
                                    </div>
                                    <div class="col-md-11 px-0 px-md-3">
                                      <div class="mt-4">
                                        <div class="container jbl-summary-section">
                                          <div class="summary-section">
                                            <h4 class="ib-form-subheading">Insured Details</h4>
                                            <table class="table">
                                              <tr v-if="stepThreeDynamicFields.first_name == undefined && stepThreeDynamicFields.last_name == undefined">
                                                <td class="jbl-summary-title">Customer Name</td>
                                                <th class="jbl-summary-right" style="text-transform: capitalize;">{{stepOneDynamicFields.first_name != undefined && stepOneDynamicFields.first_name != 'undefined' ? stepOneDynamicFields.first_name : '' }} {{ stepOneDynamicFields.last_name != undefined && stepOneDynamicFields.last_name != 'undefined' ? stepOneDynamicFields.last_name : '' }}</th>
                                              </tr>
                                              <tr v-else>
                                                <td class="jbl-summary-title">Customer Name</td>
                                                <th class="jbl-summary-right" style="text-transform: capitalize;">{{ stepThreeDynamicFields.first_name != undefined && stepThreeDynamicFields.first_name != 'undefined' ? stepThreeDynamicFields.first_name : '' }} {{ stepThreeDynamicFields.last_name != undefined && stepThreeDynamicFields.last_name != 'undefined' ? stepThreeDynamicFields.last_name : '' }}</th>
                                              </tr>
                                              <tr>
                                                <td class="jbl-summary-title">Mobile Number</td>
                                                <th class="jbl-summary-right">{{ stepThreeDynamicFields.mobile_no != undefined && stepThreeDynamicFields.mobile_no != 'undefined' ? stepThreeDynamicFields.mobile_no : '' }}</th>
                                              </tr>
                                              <tr>
                                                <td class="jbl-summary-title">Email</td>
                                                <th class="jbl-summary-right">{{ stepThreeDynamicFields.email_id != undefined && stepThreeDynamicFields.email_id != 'undefined' ? stepThreeDynamicFields.email_id : ''}}</th>
                                              </tr>
                                              <tr>
                                                <td class="jbl-summary-title">Address</td>
                                                <th class="jbl-summary-right">{{ stepThreeDynamicFields.address != undefined && stepThreeDynamicFields.address != 'undefined' ? stepThreeDynamicFields.address : ''}}</th>
                                              </tr>
                                            </table>
                                          </div>
                                          <div class="summary-section">
                                            <h4 class="ib-form-subheading">Policy Details</h4>
                                            <table class="table">
                                              <tr>
                                                <td class="jbl-summary-title">Insurance Category</td>
                                                <th class="jbl-summary-right">{{submittedAcquisitionResponse.quotation && submittedAcquisitionResponse.quotation.subclass ? submittedAcquisitionResponse.quotation.subclass.name : ''}}</th>
                                              </tr>
                                              <tr>
                                                <td class="jbl-summary-title">Package Detail</td>
                                                <th class="jbl-summary-right">{{submittedAcquisitionResponse.product.product_name}}</th>
                                              </tr>
                                              <!--                                              <tr>-->
                                              <!--                                                <td class="jbl-summary-title">Cover Limit</td>-->
                                              <!--                                                <th class="jbl-summary-right">{{selectedProduct.sum_insured_currency}} <span class="jbl-summary-price">{{ priceFormatter(submittedAcquisitionResponse.product.sum_insured_value) }}</span></th>-->
                                              <!--                                              </tr>-->
                                              <!--                                              <tr>-->
                                              <!--                                                <td class="jbl-summary-title">Package Price</td>-->
                                              <!--                                                <th class="jbl-summary-right">{{selectedProduct.currency}} <span class="jbl-summary-price">{{ priceFormatter(submittedAcquisitionResponse.quotation.paid_amount) }}</span></th>-->
                                              <!--                                              </tr>-->
                                              <!--                                              <tr>-->
                                              <!--                                                <td class="jbl-summary-title">Validity</td>-->
                                              <!--                                                <th class="jbl-summary-right">{{submittedAcquisitionResponse.quotation.validity}}</th>-->
                                              <!--                                              </tr>-->
                                            </table>
                                          </div>
                                          <div class="summary-section" v-if="selectedAddonCovers.length > 0">
                                            <h4 class="ib-form-subheading">Selected Addon's Details</h4>
                                            <table class="table">
                                              <tr v-for="(addon, index) in selectedAddonCovers" :key="index">
                                                <td class="jbl-summary-title">{{selectedProduct.add_ons.filter(x => x.id == addon.id)[0].cover}}</td>
                                                <th class="jbl-summary-right">{{selectedProduct.currency}} <span class="jbl-summary-price">{{ priceFormatter(selectedProduct.add_ons.filter(x => x.id == addon.id)[0].cover_limit_amount) }}</span></th>
                                              </tr>
                                              <tr>
                                                <td class="jbl-summary-title">Total Addon's Price</td>
                                                <th class="jbl-summary-right">{{selectedProduct.currency}} <span class="jbl-summary-price">{{ priceFormatter(calculatedAddonsPrice) }}</span></th>
                                              </tr>
                                            </table>
                                          </div>
                                          <div class="summary-section" v-if="selectedAddonCovers.length > 0 && Object.keys(submittedAcquisitionResponse.quotation).length > 0">
                                            <h4 class="ib-form-subheading">Premium Details</h4>
                                            <table class="table">
                                              <tr>
                                                <td class="jbl-summary-title">Addon's Price</td>
                                                <th class="jbl-summary-right">{{selectedProduct.currency}} <span class="jbl-summary-price">{{ priceFormatter(calculatedAddonsPrice) }}</span></th>
                                              </tr>
                                              <tr>
                                                <td class="jbl-summary-title">Package Price</td>
                                                <th class="jbl-summary-right">{{selectedProduct.currency}} <span class="jbl-summary-price">{{ priceFormatter(selectedProduct.price) }}</span></th>
                                              </tr>
                                              <tr v-if="paymentMethods.filter(x => x.payment_method.toLowerCase() == selectedPaymentMethod.toLowerCase())[0].name.toLowerCase() == 'free'">
                                                <td class="jbl-summary-title">Net Premium Amount</td>
                                                <th class="jbl-summary-right">{{selectedProduct.currency}} <span class="jbl-summary-price">{{ priceFormatter(submittedAcquisitionResponse.quotation.price_before_discount) }}</span></th>
                                              </tr>
                                              <tr v-else>
                                                <td class="jbl-summary-title">Net Premium Amount</td>
                                                <th class="jbl-summary-right">{{selectedProduct.currency}} <span class="jbl-summary-price">{{ priceFormatter(submittedAcquisitionResponse.quotation.paid_amount) }}</span></th>
                                              </tr>
                                              <tr>
                                                <td class="jbl-summary-title">Payment Status</td>
                                                <th class="jbl-summary-right">{{submittedAcquisitionResponse.quotation.payment_status}}</th>
                                              </tr>
                                              <tr>
                                                <td class="jbl-summary-title">Payment Method</td>
                                                <th class="jbl-summary-right">{{Object.keys(submittedAcquisitionResponse.quotation).length > 0 ? paymentMethods.filter(x => x.payment_method.toLowerCase() == selectedPaymentMethod.toLowerCase())[0].name : ''}}</th>
                                              </tr>
                                            </table>
                                          </div>
                                          <div v-if="selectedAddonCovers.length == 0 && Object.keys(submittedAcquisitionResponse.quotation).length > 0">
                                            <h4 class="ib-form-subheading">Premium Details</h4>
                                            <table class="table">
                                              <tr v-if="paymentMethods.filter(x => x.payment_method.toLowerCase() == selectedPaymentMethod.toLowerCase())[0].name.toLowerCase() == 'free'">
                                                <td class="jbl-summary-title">Net Premium Amount</td>
                                                <th class="jbl-summary-right">{{selectedProduct.currency}} <span class="jbl-summary-price">{{ priceFormatter(submittedAcquisitionResponse.quotation.price_before_discount) }}</span></th>
                                              </tr>
                                              <tr v-else>
                                                <td class="jbl-summary-title">Net Premium Amount</td>
                                                <th class="jbl-summary-right">{{selectedProduct.currency}} <span class="jbl-summary-price">{{ priceFormatter(submittedAcquisitionResponse.quotation.paid_amount) }}</span></th>
                                              </tr>
                                              <tr>
                                                <td class="jbl-summary-title">Payment Status</td>
                                                <th class="jbl-summary-right">{{submittedAcquisitionResponse.quotation.payment_status}}</th>
                                              </tr>
                                              <tr>
                                                <td class="jbl-summary-title">Payment Method</td>
                                                <th class="jbl-summary-right">{{Object.keys(submittedAcquisitionResponse.quotation).length > 0 ? paymentMethods.filter(x => x.payment_method.toLowerCase() == selectedPaymentMethod.toLowerCase())[0].name : ''}}</th>
                                              </tr>
                                            </table>
                                          </div>
                                        </div>
                                        <div class="ib-action-btns">
                                          <button class="ib-btn-outline ib-btn-width ib-btn-hover mr-3" @click="flushPolicyDetails()">Continue</button>
                                          <a class="ib-btn-primary ib-btn-width ib-btn-hover" :href="pdfLink" target="_blank" v-if="pdfLink">View&nbsp;Document</a>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-else>
              <div id="overlay" style="text-align: center">
                <div class="ib-finish-container">
                  <div class="ib-finish-top">
                    <img class="img-fluid" :src="require('@/assets/images/success.png')">
                    <div class="finish-submitted">
                      Policy Request Submitted
                    </div>
                    <div class="finish-success">Successfully!</div>
                  </div>
                  <!--                  <div class="ib-finish-bottom">-->
                  <!--                    <img class="img-fluid gift-img" :src="require('@/assets/images/gift-img.svg')">-->
                  <!--                    <h4 class="gift-heading">-->
                  <!--                      You may also like these Plans…-->
                  <!--                    </h4>-->
                  <!--                    <h6 class="gift-desc">Buy <span>NOW</span> and avail <span>Special Discounts…!</span></h6>-->
                  <!--                  </div>-->
                  <div class="container">
                    <div class="row">
                      <div class="col-lg-6 px-0 px-sm-3">
                        <div class="promo-field-box" v-if="promos.length > 0">
                          <div v-for="(promo, index) in promos">
                            <div class="d-flex">
                              <div class="promo-title">{{promo.name}}</div>
                              <span class="ib-card-plan promo-percent-height" v-if="promo.value_type == 'percentage'">{{promo.value}}%</span>
                              <span class="ib-card-plan promo-percent-height" v-else>PKR {{promo.value}}</span>
                            </div>
                            <div class="promo-field-wrapper2">
                              <div class="promo-field">
                                <div class="jbl-field">
                                  <input type="text" class="jbl-dynamic-input vlaue-text" readonly :value="promo.promo_code" :id="'promocode'+index">
                                </div>
                                <button class="promo-apply-btn promo-btn-fixed" @click="copyText(index)"><i class="fa fa-copy" aria-hidden="true"></i></button>
                              </div>
                            </div>
                            <div class="promo-subtitle">{{promo.heading}}</div>
                            <div class="promo-desc">{{promo.description}}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="ib-action-btns">
                    <router-link :to="{ name: 'Home' }" class="ib-btn-primary ib-btn-width ib-btn-hover mr-3">OKAY!</router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="modal fade" id="planPromoModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-xl in-modal-xl" role="document">
              <div class="modal-content ib-compare-modal">
                <div class="modal-header ib-modal-header">
                  <h3 class="listing-page-desc text-uppercase">Promos</h3>
                  <span class="ib-m-close plan-x-icon" data-dismiss="modal" aria-label="Close">
                    <!-- &times; -->
                    <img class="img-fluid" :src="require('@/assets/images/jbl-m-x-icon.png')"/>
                  </span>
                </div>
                <div class="modal-body" style="min-height: 500px;">
                  <div class="container">
                    <div class="row">
                      <a class="promotion-link" v-for="(promotion, index) in planPromos">
                        <div class="first-div in-w-75">
                          <img class="img-fluid" :src="require('@/assets/images/promo-cart2.svg')" alt />
                        </div>
                        <div class="in-flex-one in-flex-start">
                          <div class="title">{{promotion.sale_promotion.heading}}</div>
                          <div><p class="text">{{promotion.sale_promotion.description}}</p></div>
                          <div class="d-md-flex align-items-center mt-5" v-if="promotion.promo_code != ''">
                            <div class="in-promo-label">Promo Code:</div>
                            <div class="promo-field-wrapper2 in-relative-top">
                              <div class="promo-field">
                                <div class="jbl-field" :style="promotion.is_consumed ? 'background-color: #c9c8c8 !important;' : ''">
                                  <input type="text" readonly :style="promotion.is_consumed ? 'background-color: #c9c8c8 !important; color: black !important;' : ''" class="jbl-dynamic-input value-text in-text-primary" :value="promotion.promo_code" :id="'planpromocode'+index">
                                </div>
                                <button v-if="promotion.is_consumed != 1" class="promo-apply-btn promo-btn-fixed in-copy-btn" @click="copyPlanPromoText(index)"><i class="fa fa-copy" aria-hidden="true"></i></button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="modal fade" id="productCompareModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-xl in-modal-xl" role="document">
              <div class="modal-content ib-compare-modal">
                <div class="modal-header ib-modal-header">
                  <h3 class="listing-page-desc text-uppercase">Compare Plans</h3>
                  <span class="ib-m-close plan-x-icon" data-dismiss="modal" aria-label="Close" @click="closeComparePlansModal()">
                    <!-- &times; -->
                    <img class="img-fluid" :src="require('@/assets/images/jbl-m-x-icon.png')"/>
                  </span>
                </div>
                <div class="modal-body login-modal-body" style="min-height: 500px;">
                  <div class="container">
                    <div class="row">
                      <div class="col-sm-9 offset-sm-3">
                        <div class="row position-relative d-flex justify-content-md-center">
                          <div v-for="(product, index) in comparingProducts" :key="'image-' + index" class="col-md-4 compare-plan-box">
                            <div class="">
                              <div class="">
                                <div class="compare-plan-logo">
                                  <img class="img-fluid" :src="product.comparison_config.company_logo" alt="company_logo">
                                </div>
                                <div class="compare-company-title">{{product.company_name}}</div>
                              </div>
                              <div>
                                <div class="compare-company-desc">{{product.product_name}}</div>
                              </div>
                              <div class="text-center">
                                <button class="ib-btn-primary ib-btn-hover ib-btn-width" data-dismiss="modal" aria-label="Close" @click="buyComparingProduct(product)">Buy&nbsp;Now</button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="compare-th-div" v-if="showComaprisonPremiumRate || showComaprisonTracker || showComaprisonSumInsured || showComaprisonPremiumAmount">
                    <h3 class="compare-th-title">Basic Details</h3>
                  </div>
                  <div class="container" v-if="showComaprisonPremiumRate || showComaprisonTracker || showComaprisonSumInsured || showComaprisonPremiumAmount">
                    <div class="row">
                      <table class="table table-bordered compare-table-first">
                        <tr v-if="classType == 'motor' && showComaprisonPremiumRate">
                          <td>Premium Rate</td>
                          <td v-for="(product, index) in comparingProducts" :key="'premiumrate-' + index">
                            <span v-if="product.comparison_config.basic_detail.premium_rate_type.toLowerCase() == 'fixed'">
                              <span class="compare-currency">{{ product.currency }} </span>
                              {{ product.comparison_config.basic_detail.premium_amount }}
                            </span>
                            <span v-if="product.comparison_config.basic_detail.premium_rate_type.toLowerCase() == 'percentage'">
                              {{ product.comparison_config.basic_detail.premium_rate }}
                              <span class="compare-percent"> %</span>
                            </span>
                          </td>
                        </tr>
                        <tr v-if="classType == 'motor' && showComaprisonTracker">
                          <td>Tracker</td>
                          <td v-for="(product, index) in comparingProducts" :key="'tracker-' + index">
                            <span class="compare-tick" v-if="trackerRequired">&check;</span>
                            <span class="compare-cross" v-else>&times;</span>
                          </td>
                        </tr>
                        <tr v-if="showComaprisonSumInsured">
                          <td>Sum Insured</td>
                          <td v-for="(product, index) in comparingProducts" :key="'suminsured-' + index"><span class="compare-currency">{{ product.comparison_config.basic_detail.sum_insured_currency }}</span>
                            {{ priceFormatter(product.comparison_config.basic_detail.sum_insured) }}
                          </td>
                        </tr>
                        <tr v-if="showComaprisonPremiumAmount">
                          <td>Premium Amount</td>
                          <td v-for="(product, index) in comparingProducts" :key="'premiumamount-' + index"><span class="compare-currency">{{ product.currency }}</span>
                            {{ priceFormatter(product.comparison_config.basic_detail.premium_amount) }}
                          </td>
                        </tr>
                      </table>
                    </div>
                  </div>
                  <div class="compare-th-div" v-if="showComaprisonCoverages">
                    <h3 class="compare-th-title">Coverages</h3>
                  </div>
                  <div v-if="showComaprisonCoverages">
                    <div>
                      <div v-for="(coverage, index1) in comparisonCompanyProfileCoverages" :key="'companycoverages-' + index1"
                           id="accordion-table">
                        <div class="container">
                          <div class="row compare-accordion-flex">
                            <div class="custom-td">
                              {{ coverage }}
                            </div>

                            <div class="custom-td" v-for="(product, index2) in comparingProducts" :key="'companyprofile-' + index2">
                              <span v-if="product.comparison_config.coverages.filter(x => x.name.toLowerCase() == coverage).length > 0">
                                {{ product.comparison_config.coverages.filter(x => x.name.toLowerCase() == coverage)[0].value != null ? product.comparison_config.coverages.filter(x => x.name.toLowerCase() == coverage)[0].value : '-' }}
                              </span>
                              <a class="copmare-a" data-toggle="collapse" :data-target="'#collapse' + index1"
                                 aria-expanded="false" :aria-controls="'collapse' + index1" v-if="index2 == (comparingProducts.length - 1)">
                                <i class="fa fa-chevron-down"></i>
                              </a>
                            </div>
                          </div>
                        </div>

                        <div :id="'collapse' + index1" class="collapse" data-parent="#accordion-table">
                          <div class="container">
                            <div class="row compare-accordion-flex" v-if="showComaprisonCoveragesDeductible">
                              <div class="custom-td">Deductible</div>
                              <div class="custom-td" v-for="(product, index3) in comparingProducts" :key="'companyprofile-' + index3">
                                <span v-if="product.comparison_config.coverages.filter(x => x.name.toLowerCase() == coverage).length > 0 &&
                                product.comparison_config.coverages.filter(x => x.name.toLowerCase() == coverage)[0].deductible_type != null">
                                  <span v-if="product.comparison_config.coverages.filter(x => x.name.toLowerCase() == coverage)[0].deductible_type.toLowerCase() == 'fixed_amount'">
                                    {{ product.currency }} {{ priceFormatter(product.comparison_config.coverages.filter(x => x.name.toLowerCase() == coverage)[0].deductible) }}
                                  </span>
                                  <span v-if="product.comparison_config.coverages.filter(x => x.name.toLowerCase() == coverage)[0].deductible_type.toLowerCase() == 'text'">
                                    {{ product.comparison_config.coverages.filter(x => x.name.toLowerCase() == coverage)[0].deductible }}
                                  </span>
                                  <span v-if="product.comparison_config.coverages.filter(x => x.name.toLowerCase() == coverage)[0].deductible_type.toLowerCase() == 'percentage'">
                                    {{ product.comparison_config.coverages.filter(x => x.name.toLowerCase() == coverage)[0].deductible }} %
                                  </span>
                                </span>
                                <span v-else>-</span>
                              </div>
                            </div>

                            <div class="row compare-accordion-flex" v-if="showComaprisonCoveragesDetails">
                              <div class="custom-td">Cover Details</div>
                              <div class="custom-td" v-for="(product, index4) in comparingProducts" :key="'companyprofile-' + index4">
                                <span v-if="product.comparison_config.coverages.filter(x => x.name.toLowerCase() == coverage).length > 0 &&
                                 product.comparison_config.coverages.filter(x => x.name.toLowerCase() == coverage)[0].cover_detail != null">
                                  {{ product.comparison_config.coverages.filter(x => x.name.toLowerCase() == coverage)[0].cover_detail }}
                                </span>
                                <span v-else>-</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="compare-th-div" v-if="showComaprisonExclusions">
                    <h3 class="compare-th-title">Exclusions</h3>
                  </div>
                  <div class="container" v-if="showComaprisonExclusions">
                    <div class="row">
                      <table class="table table-bordered compare-table">
                        <tr>
                          <td>Sum Insured</td>
                          <td v-for="(product, index) in comparingProducts" :key="'exclusions-' + index">{{ product.comparison_config.exclusion.text != null ? product.comparison_config.exclusion.text : '-' }}</td>
                        </tr>
                      </table>
                    </div>
                  </div>
                  <div class="compare-th-div" v-if="showComaprisonCompanyProfile">
                    <h3 class="compare-th-title">Company Profile</h3>
                  </div>
                  <div class="container" v-if="showComaprisonCompanyProfile">
                    <div class="row">
                      <table class="table table-bordered compare-table">
                        <tr v-for="(obj, index) in comparisonCompanyProfileObjects" :key="'companyprofileobj-' + index">
                          <td>{{ obj }}</td>
                          <td v-for="(product, index) in comparingProducts" :key="'companyprofile-' + index">
                            <span v-if="product.comparison_config.company_profile.filter(x => x.name.toLowerCase() == obj).length > 0">
                              {{ product.comparison_config.company_profile.filter(x => x.name.toLowerCase() == obj)[0].value != null ? product.comparison_config.company_profile.filter(x => x.name.toLowerCase() == obj)[0].value : '-' }}
                            </span>
                          </td>
                        </tr>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div id="VerifyMobileModal" class="modal" role="dialog" style="backdrop-filter: contrast(0.5);">
            <div class="modal-dialog modal-lg modal-dialog-scrollable">
              <!-- Modal content-->
              <div class="modal-content ib-login-modal">
                <div class="modal-header ib-modal-header">
                  <span class="ib-m-close ib-x-m-icon" @click="closeVerifyMobileModal()">
                    <!-- &times; -->
                    <img class="img-fluid" :src="require('@/assets/images/jbl-m-x-icon.png')" alt="Close" />
                  </span>
                </div>
                <div class="modal-body login-modal-body" style="min-height: 500px;">
                  <verifymobile :mobile="otpMobile" :quotationId="quotationDetails.customer_quotation_id" v-if="renderVerifyMobileModal"/>
                </div>
              </div>
            </div>
          </div>

          <div id="AddFamilyModal" class="modal" role="dialog" style="backdrop-filter: contrast(0.5);">
            <div class="modal-dialog modal-dialog-scrollable">
              <!-- Modal content-->
              <div class="modal-content ib-login-modal">
                <div class="modal-header ib-modal-header">
                  <h3 class="compare-th-title">{{ familyModalType }} Family</h3>
                  <span class="ib-m-close ib-x-m-icon" @click="closeFamilyModal()">
                    <!-- &times; -->
                    <img class="img-fluid" :src="require('@/assets/images/jbl-m-x-icon.png')" alt="Close" />
                  </span>
                </div>
                <div class="modal-body login-modal-body in-scroll-body" style="min-height: 500px;">
                  <div>
                    <label class="jbl-dynamic-label">Name<span>*</span></label>
                    <div class="jbl-field">
                      <input class="jbl-dynamic-input" type="text" v-model="familyData.name" placeholder="Enter Name"/>
                    </div>

                    <div v-if="familyErrors.filter(x => x.field == 'name').length > 0">
                      <div>
                        <small class="text-danger">{{familyErrors.filter(x => x.field == 'name')[0].message}}</small>
                      </div>
                    </div>
                  </div>

                  <div>
                    <label class="jbl-dynamic-label">CNIC<span>*</span></label>
                    <div class="jbl-field">
                      <input class="jbl-dynamic-input" type="text" v-model="familyData.cnic" placeholder="Enter CNIC" v-mask="'#####-#######-#'"/>
                    </div>

                    <div v-if="familyErrors.filter(x => x.field == 'cnic').length > 0">
                      <div>
                        <small class="text-danger">{{familyErrors.filter(x => x.field == 'cnic')[0].message}}</small>
                      </div>
                    </div>
                  </div>

                  <div>
                    <label class="jbl-dynamic-label">Date of Birth<span>*</span></label>
                    <div class="jbl-field">
                      <datepicker initial-view="year" class="jbl-dynamic-input" name="family_dob" v-model="familyData.dob" format="dd-MMM-yyyy" placeholder="DD-MM-YYYY" input-class="jbl-generated-input" calendar-class="jbl-calendar"></datepicker>
                    </div>

                    <div v-if="familyErrors.filter(x => x.field == 'dob').length > 0">
                      <div>
                        <small class="text-danger">{{familyErrors.filter(x => x.field == 'dob')[0].message}}</small>
                      </div>
                    </div>
                  </div>

                  <div>
                    <label class="jbl-dynamic-label">Passport Number<span>*</span></label>
                    <div class="jbl-field">
                      <input class="jbl-dynamic-input" type="text" v-model="familyData.passport" placeholder="Enter Passport Number"/>
                    </div>

                    <div v-if="familyErrors.filter(x => x.field == 'passport').length > 0">
                      <div>
                        <small class="text-danger">{{familyErrors.filter(x => x.field == 'passport')[0].message}}</small>
                      </div>
                    </div>
                  </div>

                  <div>
                    <div>
                      <label>Relationship<span>*</span></label>
                      <select style="width: 100% !important;" class="floating-select" v-model="familyData.relationship">
                        <option value="">Select Relationship</option>
                        <option value="spouse">Spouse</option>
                        <option value="child">Child</option>
                      </select>
                      <span class="highlight"></span>
                      <div class="ib-custom-select"></div>
                    </div>

                    <div v-if="familyErrors.filter(x => x.field == 'relationship').length > 0">
                      <div class="d-block jbl-text-danger">
                        <small class="text-danger">{{familyErrors.filter(x => x.field == 'relationship')[0].message}}</small>
                      </div>
                    </div>
                  </div>

                  <div>
                    <div>
                      <label>Gender<span>*</span></label>
                      <select style="width: 100% !important;" class="floating-select" v-model="familyData.gender">
                        <option value="">Select Gender</option>
                        <option value="male">Male</option>
                        <option value="female">Female</option>
                      </select>
                      <span class="highlight"></span>
                      <div class="ib-custom-select"></div>
                    </div>

                    <div v-if="familyErrors.filter(x => x.field == 'gender').length > 0">
                      <div class="d-block jbl-text-danger">
                        <small class="text-danger">{{familyErrors.filter(x => x.field == 'gender')[0].message}}</small>
                      </div>
                    </div>
                  </div>
                  <div class="in-mbody-footer">
                    <button class="ib-btn-primary ib-btn-hover mr-3" type="button" @click="addFamilyData()" v-if="familyModalType == 'Add'">Add</button>
                    <button class="ib-btn-primary ib-btn-hover mr-3" type="button" @click="updateFamilyData()" v-else>Update</button>
                    <button class="ib-btn-outline ib-outline-hp ib-btn-hover" @click="closeFamilyModal()">Cancel</button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div id="AddBeneficiaryModal" class="modal" role="dialog" style="backdrop-filter: contrast(0.5);">
            <div class="modal-dialog">
              <!-- Modal content-->
              <div class="modal-content ib-login-modal">
                <div class="modal-header ib-modal-header">
                  <h3 class="compare-th-title">{{ beneficiaryModalType }} Beneficiary</h3>
                  <span class="ib-m-close ib-x-m-icon" @click="closeBeneficiaryModal()">
                    <!-- &times; -->
                    <img class="img-fluid" :src="require('@/assets/images/jbl-m-x-icon.png')" alt="Close" />
                  </span>
                </div>
                <div class="modal-body login-modal-body in-scroll-body" style="min-height: fit-content !important; max-height: 600px; overflow: hidden scroll;">
                  <div>
                    <div v-if="Object.keys(beneficiary).length > 0 && beneficiary.fields.length > 0 && beneficiary.fields.filter(x => x.beneficiary_detail_field == 'first_name').length > 0
                     && beneficiary.fields.filter(x => x.beneficiary_detail_field == 'first_name')[0].visible">
                      <label>First Name<span v-if="beneficiary.fields.filter(x => x.beneficiary_detail_field == 'first_name')[0].required">*</span></label>
                      <div class="jbl-field">
                        <input class="jbl-dynamic-input" type="text" name="first_name" v-model="beneficiaryData['first_name']" :placeholder="'Enter First Name'">
                      </div>

                      <div v-if="beneficiaryErrors.filter(x => x.field == 'first_name').length > 0">
                        <div>
                          <small class="text-danger">{{beneficiaryErrors.filter(x => x.field == 'first_name')[0].message}}</small>
                        </div>
                      </div>
                    </div>
                    <div v-if="Object.keys(beneficiary).length > 0 && beneficiary.fields.length > 0 && beneficiary.fields.filter(x => x.beneficiary_detail_field == 'last_name').length > 0
                     && beneficiary.fields.filter(x => x.beneficiary_detail_field == 'last_name')[0].visible">
                      <label>Last Name<span v-if="beneficiary.fields.filter(x => x.beneficiary_detail_field == 'last_name')[0].required">*</span></label>
                      <div class="jbl-field">
                        <input class="jbl-dynamic-input" type="text" name="last_name" v-model="beneficiaryData['last_name']" :placeholder="'Enter Last Name'">
                      </div>

                      <div v-if="beneficiaryErrors.filter(x => x.field == 'last_name').length > 0">
                        <div>
                          <small class="text-danger">{{beneficiaryErrors.filter(x => x.field == 'last_name')[0].message}}</small>
                        </div>
                      </div>
                    </div>
                    <div v-if="Object.keys(beneficiary).length > 0 && beneficiary.fields.length > 0 && beneficiary.fields.filter(x => x.beneficiary_detail_field == 'dob').length > 0
                     && beneficiary.fields.filter(x => x.beneficiary_detail_field == 'dob')[0].visible">
                      <label>Date of Birth<span v-if="beneficiary.fields.filter(x => x.beneficiary_detail_field == 'dob')[0].required">*</span></label>
                      <div class="jbl-field">
                        <datepicker initial-view="year" class="jbl-dynamic-input" name="beneficiary_dob" v-model="beneficiaryData['dob']" format="dd-MMM-yyyy" placeholder="DD-MM-YYYY" input-class="jbl-generated-input" calendar-class="jbl-calendar"></datepicker>
                      </div>

                      <div v-if="beneficiaryErrors.filter(x => x.field == 'dob').length > 0">
                        <div>
                          <small class="text-danger">{{beneficiaryErrors.filter(x => x.field == 'dob')[0].message}}</small>
                        </div>
                      </div>
                    </div>
                    <div v-if="Object.keys(beneficiary).length > 0 && beneficiary.fields.length > 0 && beneficiary.fields.filter(x => x.beneficiary_detail_field == 'gender').length > 0
                     && beneficiary.fields.filter(x => x.beneficiary_detail_field == 'gender')[0].visible">
                      <div>
                        <label>Gender<span v-if="beneficiary.fields.filter(x => x.beneficiary_detail_field == 'gender')[0].required">*</span></label>
                        <select style="width: 100% !important;" class="floating-select" v-model="beneficiaryData['gender']">
                          <option value="">Select Gender</option>
                          <option value="male">Male</option>
                          <option value="female">Female</option>
                        </select>
                        <span class="highlight"></span>
                        <div class="ib-custom-select"></div>
                      </div>

                      <div v-if="beneficiaryErrors.filter(x => x.field == 'gender').length > 0">
                        <div class="d-block jbl-text-danger">
                          <small class="text-danger">{{beneficiaryErrors.filter(x => x.field == 'gender')[0].message}}</small>
                        </div>
                      </div>
                    </div>
                    <div v-if="Object.keys(beneficiary).length > 0 && beneficiary.fields.length > 0 && beneficiary.fields.filter(x => x.beneficiary_detail_field == 'cnic').length > 0
                     && beneficiary.fields.filter(x => x.beneficiary_detail_field == 'cnic')[0].visible">
                      <label>CNIC<span v-if="beneficiary.fields.filter(x => x.beneficiary_detail_field == 'cnic')[0].required">*</span></label>
                      <div class="jbl-field">
                        <input class="jbl-dynamic-input" type="text" name="cnic" v-model="beneficiaryData['cnic']" v-mask="'#####-#######-#'" :placeholder="'Enter CNIC'">
                      </div>

                      <div v-if="beneficiaryErrors.filter(x => x.field == 'cnic').length > 0">
                        <div>
                          <small class="text-danger">{{beneficiaryErrors.filter(x => x.field == 'cnic')[0].message}}</small>
                        </div>
                      </div>
                    </div>
                    <div v-if="Object.keys(beneficiary).length > 0 && beneficiary.fields.length > 0 && beneficiary.fields.filter(x => x.beneficiary_detail_field == 'cnic_issue_date').length > 0
                     && beneficiary.fields.filter(x => x.beneficiary_detail_field == 'cnic_issue_date')[0].visible">
                      <label>CNIC Issue Date<span v-if="beneficiary.fields.filter(x => x.beneficiary_detail_field == 'cnic_issue_date')[0].required">*</span></label>
                      <div class="jbl-field">
                        <datepicker initial-view="year" class="jbl-dynamic-input" name="cnic_issue_date" v-model="beneficiaryData['cnic_issue_date']" format="dd-MMM-yyyy" placeholder="DD-MM-YYYY" input-class="jbl-generated-input" calendar-class="jbl-calendar"></datepicker>
                      </div>

                      <div v-if="beneficiaryErrors.filter(x => x.field == 'cnic_issue_date').length > 0">
                        <div>
                          <small class="text-danger">{{beneficiaryErrors.filter(x => x.field == 'cnic_issue_date')[0].message}}</small>
                        </div>
                      </div>
                    </div>
                    <div v-if="Object.keys(beneficiary).length > 0 && beneficiary.fields.length > 0 && beneficiary.fields.filter(x => x.beneficiary_detail_field == 'cnic_expiry_date').length > 0
                     && beneficiary.fields.filter(x => x.beneficiary_detail_field == 'cnic_expiry_date')[0].visible">
                      <label>CNIC Expiry Date<span v-if="beneficiary.fields.filter(x => x.beneficiary_detail_field == 'cnic_expiry_date')[0].required">*</span></label>
                      <div class="jbl-field">
                        <datepicker initial-view="year" class="jbl-dynamic-input" name="cnic_expiry_date" v-model="beneficiaryData['cnic_expiry_date']" format="dd-MMM-yyyy" placeholder="DD-MM-YYYY" input-class="jbl-generated-input" calendar-class="jbl-calendar"></datepicker>
                      </div>

                      <div v-if="beneficiaryErrors.filter(x => x.field == 'cnic_expiry_date').length > 0">
                        <div>
                          <small class="text-danger">{{beneficiaryErrors.filter(x => x.field == 'cnic_expiry_date')[0].message}}</small>
                        </div>
                      </div>
                    </div>
                    <div v-if="Object.keys(beneficiary).length > 0 && beneficiary.fields.length > 0 && beneficiary.fields.filter(x => x.beneficiary_detail_field == 'mobile_no').length > 0
                     && beneficiary.fields.filter(x => x.beneficiary_detail_field == 'mobile_no')[0].visible">
                      <label>Mobile Number<span v-if="beneficiary.fields.filter(x => x.beneficiary_detail_field == 'mobile_no')[0].required">*</span></label>
                      <div class="jbl-field">
                        <input class="jbl-dynamic-input" type="text" name="mobile_no" v-model="beneficiaryData['mobile_no']" v-mask="'+92##########'"
                               @change="validateBeneficiaryMobileNo($event)" :placeholder="'Enter Mobile Number'">
                      </div>

                      <div v-if="beneficiaryErrors.filter(x => x.field == 'mobile_no').length > 0">
                        <div>
                          <small class="text-danger">{{beneficiaryErrors.filter(x => x.field == 'mobile_no')[0].message}}</small>
                        </div>
                      </div>
                    </div>
                    <div v-if="Object.keys(beneficiary).length > 0 && beneficiary.fields.length > 0 && beneficiary.fields.filter(x => x.beneficiary_detail_field == 'email').length > 0
                     && beneficiary.fields.filter(x => x.beneficiary_detail_field == 'email')[0].visible">
                      <label>Email<span v-if="beneficiary.fields.filter(x => x.beneficiary_detail_field == 'email')[0].required">*</span></label>
                      <div class="jbl-field">
                        <input class="jbl-dynamic-input" type="email" name="email" v-model="beneficiaryData['email']" :placeholder="'Enter Email'"
                               @change="verifyBeneficiaryEmail($event)">
                      </div>

                      <div v-if="beneficiaryErrors.filter(x => x.field == 'email').length > 0">
                        <div>
                          <small class="text-danger">{{beneficiaryErrors.filter(x => x.field == 'email')[0].message}}</small>
                        </div>
                      </div>
                    </div>
                    <div v-if="Object.keys(beneficiary).length > 0 && beneficiary.fields.length > 0 && beneficiary.fields.filter(x => x.beneficiary_detail_field == 'relationship').length > 0
                     && beneficiary.fields.filter(x => x.beneficiary_detail_field == 'relationship')[0].visible">
                      <div>
                        <label>Relationship<span v-if="beneficiary.fields.filter(x => x.beneficiary_detail_field == 'relationship')[0].required">*</span></label>
                        <select style="width: 100% !important;" class="floating-select" name="relationship" v-model="beneficiaryData['relationship']"
                                onchange="this.setAttribute('value', this.value);" v-if="beneficiaryData.relationship" :value="beneficiaryData.relationship">
                          <option value="">Select Relationship</option>
                          <option v-for="(beneficiaryRelation, index) in beneficiaryRelations" :value="beneficiaryRelation.id" :key="index">{{beneficiaryRelation.name}}</option>
                        </select>
                        <select style="width: 100% !important;" class="floating-select" name="relationship" v-model="beneficiaryData['relationship']"
                                onchange="this.setAttribute('value', this.value);" v-else value="">
                          <option value="">Select Relationship</option>
                          <option v-for="(beneficiaryRelation, index) in beneficiaryRelations" :value="beneficiaryRelation.id" :key="index">{{beneficiaryRelation.name}}</option>
                        </select>
                        <span class="highlight"></span>
                        <div class="ib-custom-select"></div>
                      </div>

                      <div v-if="beneficiaryErrors.filter(x => x.field == 'relationship').length > 0">
                        <div>
                          <small class="text-danger">{{beneficiaryErrors.filter(x => x.field == 'relationship')[0].message}}</small>
                        </div>
                      </div>
                    </div>
                    <div v-if="Object.keys(beneficiary).length > 0 && beneficiary.fields.length > 0 && beneficiary.fields.filter(x => x.beneficiary_detail_field == 'address').length > 0
                     && beneficiary.fields.filter(x => x.beneficiary_detail_field == 'address')[0].visible">
                      <label>Address<span v-if="beneficiary.fields.filter(x => x.beneficiary_detail_field == 'address')[0].required">*</span></label>
                      <div class="jbl-field">
                        <textarea class="jbl-dynamic-input" v-model="beneficiaryData['address']" name="address" :placeholder="'Enter Address'"></textarea>
                      </div>

                      <div v-if="beneficiaryErrors.filter(x => x.field == 'address').length > 0">
                        <div>
                          <small class="text-danger">{{beneficiaryErrors.filter(x => x.field == 'address')[0].message}}</small>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="in-mbody-footer">
                    <button class="ib-btn-primary ib-btn-hover mr-3" type="button" @click="addBeneficiaryData()" v-if="beneficiaryModalType == 'Add'">Add</button>
                    <button class="ib-btn-primary ib-btn-hover mr-3" type="button" @click="updateBeneficiaryData()" v-else>Update</button>
                    <button class="ib-btn-outline ib-outline-hp ib-btn-hover" @click="closeBeneficiaryModal()">Cancel</button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <button id="easyPaisaModalButton" data-toggle="modal" data-target="#easyPaisaModal" style="display: none;"></button>
          <div class="modal fade" id="easyPaisaModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-xl in-modal-xl" role="document">
              <div class="modal-content ib-compare-modal">
                <div class="modal-header ib-modal-header">
                  <span class="ib-m-close plan-x-icon" data-dismiss="modal" aria-label="Close" @click="closeEasyPaisaModal()">
                    <!-- &times; -->
                    <img class="img-fluid" :src="require('@/assets/images/jbl-m-x-icon.png')"/>
                  </span>
                </div>

                <div class="modal-body login-modal-body" style="min-height: 500px;">
                  <div class="container">
                    <div class="row">
                      <div class="col-12">
                        <iframe :src="easyPaisaUrl" frameborder="0" class="in-payment-iframe"></iframe>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Datepicker from 'vuejs-datepicker';
  import moment from 'moment';
  import { mask } from 'vue-the-mask';
  import loading from '@/components/Loading/Loading';
  import verifymobile from '@/components/Auth/VerifyMobile';
  import httpClient from '../Acquisition/httpClient';

  export default {
    name: "AbandonedRenew",
    data() {
      return {
        showLoader: false,
        renderVerifyMobileModal: false,
        user: {},
        nav_step: 1,
        parentId: '',
        oldQuotationId: '',
        oldPlanId: '',
        selectedClassId: '',
        mainClasses: {},
        classType: '',
        hasCategory: false,
        categories: {},
        subClasses: {},
        selectedSubclassId: '',
        selectedCategoryId: '',
        stepOneSections: {},
        stepOneDynamicFields: {},
        trackerRequired: false,
        stepOneErrors: [],
        selectedAddonCovers: [],
        quotationDetails: {},
        products: {},
        filteredProducts: {},
        sortByPremium: '',
        productsCompanies: [],
        selectedFilteringProductsCompanies: [],
        productsNames: [],
        selectedFilteringProductsNames: [],
        selectedProduct: {},
        calculatedAddonsPrice: 0,
        calculatedProductPrice: 0,
        promoCode: '',
        promoCodeApplied: false,
        promoCodeDiscountType: '',
        promoCodeDiscount: 0,
        promoCodeDiscountAmount: 0,
        calculatedProductPriceWithDiscount: 0,
        showAddonDropped: false,
        showProductComparison: false,
        comparingProducts: [],
        showComaprisonPremiumRate: false,
        showComaprisonPremiumAmount: false,
        showComaprisonSumInsured: false,
        showComaprisonTracker: false,
        showComaprisonCoverages: false,
        showComaprisonCoveragesDeductible: false,
        showComaprisonCoveragesDetails: false,
        showComaprisonExclusions: false,
        showComaprisonCompanyProfile: false,
        comparisonCompanyProfileObjects: [],
        comparisonCompanyProfileCoverages: [],
        chooseProductStep: 1,
        workFlows: [],
        requireSelfInspectionImages: false,
        selfInspectionType: '',
        selfInspectionSections: [],
        selfInspectionDynamicDocuments: {},
        selfInspectionImagesErrors: [],
        stepThreeSections: {},
        stepThreeDocumentSections: [],
        showWithHoldingTaxData: false,
        withHoldingTaxRequired: false,
        withHoldingTaxAmount: 0,
        withHoldingTaxPercentage: 0,
        stepThreeDynamicFields: {},
        stepThreeDynamicDocuments: {},
        showBeneficiary: false,
        beneficiary: {},
        beneficiaryData: {},
        submitBeneficiary: [],
        beneficiaryRelations: {},
        beneficiaryModalType: '',
        beneficiaryErrors: [],
        showFamily: false,
        family: {},
        familyData: {
          id: '',
          name: '',
          cnic: '',
          dob: '',
          passport: '',
          relationship: '',
          gender: '',
          is_deleted: false
        },
        submitFamily: {
          spouse: [],
          child: []
        },
        familyModalType: '',
        familyErrors: [],
        stepThreeErrors: [],
        showDocuments: false,
        stepThreeDocumentsErrors: [],
        uploadInformationStep: 1,
        stepThreeMotorImages: {
          front_right: [],
          front_center: [],
          front_left: [],
          center_right: [],
          center_top: [],
          center_left: [],
          rear_right: [],
          rear_center: [],
          rear_left: []
        },
        stepThreeMotorImagesPath: {
          front_right: [],
          front_center: [],
          front_left: [],
          center_right: [],
          center_top: [],
          center_left: [],
          rear_right: [],
          rear_center: [],
          rear_left: []
        },
        declaration: {
          things_to_note: false,
          right_information: false
        },
        stepThreeMotorImagesErrors: [],
        paymentMethods: [],
        planPromos: [],
        quotationPaymentStatus: false,
        selectedPaymentMethod: '',
        cardPaymentMethodErrors: [],
        cheque: {
          cheque_no: '',
          cheque_issue_date: ''
        },
        chequeImages: [],
        chequePaymentMethodErrors: [],
        easypaisa: {
          mobile_no: '',
          email: ''
        },
        easyPaisaMethodErrors: [],
        easyPaisaUrl: '',
        mobileNumberVerified: false,
        sessionResponse: {},
        pdfLink: '',
        promos: [],
        submittedAcquisitionResponse: {
          product: {},
          quotation: {}
        },
        showSubmitted: false
      };
    },
    components: {
      loading,
      verifymobile,
      Datepicker
    },
    directives: { mask },
    created() {
      const self = this;
      self.user = self.$store.getters.getUser;
      self.selectedSubclassId = this.$route.params.subClassId ? parseInt(this.$route.params.subClassId) : '';
      self.oldQuotationId = this.$route.params.quotationId ? parseInt(this.$route.params.quotationId) : '';
      self.parentId = this.$route.params.parentId ? parseInt(this.$route.params.parentId) : '';

      this.$root.$on('updateMobileNumber', (newNumber, oldNumber) => {
        self.updateMobileNumber(newNumber, oldNumber);
      });
      this.$root.$on('mobileNumberVerifiedPost', () => {
        self.mobileNumberVerifiedPost();
      });
      this.$root.$on('closeVerifyMobileNumberModal', () => {
        self.closeVerifyMobileModal();
      });

      let routePaymentCheck = self.$route.query.payment;
      let routePaymentStatus = self.$route.query.status;
      let statePaymentCheck = self.$store.getters.getQuotationPayment;

      if(routePaymentCheck != undefined && statePaymentCheck) {
        self.retrievePostPaymentData(routePaymentStatus);
      } else if (routePaymentCheck != undefined && !statePaymentCheck) {
        self.$store.commit('resetQuotationTempData');
        self.$router.push({ name: 'Home' });
      } else {
        self.$store.commit('resetQuotationTempData');
        self.getMainClasses();
        self.getOldPolicyData();
      }
    },
    beforeDestroy() {
      this.$root.$off('updateMobileNumber');
      this.$root.$off('mobileNumberVerifiedPost');
      this.$root.$off('closeVerifyMobileNumberModal');
    },
    computed: {
      issueDate () {
        return moment().format('YYYY-MM-DD');
      }
    },
    watch: {
      selectedFilteringProductsCompanies: {
        deep: true, // for watching array objects as well
        handler () {
          const self = this;
          self.updateFilteredProductsByCompany();

        }
      },
      selectedFilteringProductsNames: {
        deep: true, // for watching array objects as well
        handler () {
          const self = this;
          self.updateFilteredProductsByName();

        }
      },
      sortByPremium: {
        deep: true, // for watching array objects as well
        handler () {
          const self = this;
          self.updateFilteredProductsByPremium();

        }
      }
    },
    methods: {
      DateDiff(serverDate) {
        const myDate = new Date();
        var a = moment(myDate);
        var b = moment(serverDate);
        var response = '';

        var diff = a.diff(b, 'months');
        response = diff + ' Months Ago';

        if(diff === 0) {
          diff = a.diff(b, 'days');
          response = diff + ' Days Ago';
        }

        if(diff === 0) {
          diff = a.diff(b, 'hours');
          response = diff + ' Hours Ago';
        }

        if (diff === 0) {
          diff = a.diff(b, 'minutes');
          response = diff + ' Minutes Ago';
        }

        return response;
      },
      copyText(index) {
        var copyText = document.getElementById('promocode'+index);
        copyText.select();
        document.execCommand('copy');
        $toast.success('Promo Code Copied!', { position: 'top-right' });
      },
      copyPlanPromoText(index) {
        var copyText = document.getElementById('planpromocode'+index);
        copyText.select();
        document.execCommand('copy');
        $toast.success('Promo Code Copied!', { position: 'top-right' });
      },
      formatDBDate (dbDate, type) {
        if(dbDate == '' || dbDate == null || dbDate == undefined) {
          return '';
        } else {
          if(type == 'field') {
            var parts = dbDate.split('-'); //'20-04-2021'
            if (parts[2].length == 4){
              var newDate = new Date(parts[2], parts[1] -1, parts[0]);
            }else{
              var newDate = new Date(parts[0], parts[1] -1, parts[2]);
            }
          }
          if(type == 'beneficiary') {
            var parts = dbDate.split('-'); //'2021-04-20'
            var newDate = new Date(parts[0], parts[1] -1, parts[2]);
          }
          //let newDate = new Date(Date.parse(dbDate));
          let date = newDate.getDate();
          let month = newDate.getMonth() + 1;
          let year = Math.abs(newDate.getFullYear());
          let newDateString = month + '-' + date + '-' + year;
          let selectedDate = moment(newDateString, "M-D-YYYY").toDate();
          return selectedDate;
        }
      },
      priceFormatter(price) {
        return new Intl.NumberFormat('en-PK').format(price);
      },
      load_script () {
        let self = this
        return new Promise((resolve, reject) => {
          let script = document.createElement('script')
          script.setAttribute('src', 'https://bankalfalah.gateway.mastercard.com/checkout/version/56/checkout.js')
          script.setAttribute('data-error', "https://staging.insurancebazaar.com.pk/abandoned_renew/" + self.parentId + '/' + self.oldQuotationId + '/' + self.selectedClassId + "?payment=true&status=error")
          script.setAttribute('data-cancel', "https://staging.insurancebazaar.com.pk/abandoned_renew/" + self.parentId + '/' + self.oldQuotationId + '/' + self.selectedClassId + "?payment=true&status=cancel")
          //script.setAttribute('data-error', "http://localhost:8080/abandoned_renew/" + self.parentId + '/' + self.oldQuotationId + '/' + self.selectedClassId + "?payment=true&status=error")
          //script.setAttribute('data-cancel', "http://localhost:8080/abandoned_renew/" + self.parentId + '/' + self.oldQuotationId + '/' + self.selectedClassId + "?payment=true&status=cancel")
          script.async = true

          script.onload = () => {
            resolve('loaded');
          }
          document.head.appendChild(script);
        });
      },
      stepOnePaymentMethod () {
        const self = this;
        let obj = {
          parentId: self.parentId,
          oldQuotationId: self.oldQuotationId,
          oldPlanId: self.oldPlanId,
          selectedProduct: self.selectedProduct,
          mainClasses: self.mainClasses,
          hasCategory: self.hasCategory,
          categories: self.categories,
          subClasses: self.subClasses,
          selectedClassId: self.selectedClassId,
          selectedSubclassId: self.selectedSubclassId,
          selectedCategoryId: self.selectedCategoryId,
          stepOneSections: self.stepOneSections,
          stepOneDynamicFields: self.stepOneDynamicFields,
          trackerRequired: self.trackerRequired,
          selectedAddonCovers: self.selectedAddonCovers,
          quotationDetails: self.quotationDetails,
          products: self.products,
          calculatedAddonsPrice: self.calculatedAddonsPrice,
          calculatedProductPrice: self.calculatedProductPrice,
          promoCode: self.promoCode,
          promoCodeApplied: self.promoCodeApplied,
          promoCodeDiscountType: self.promoCodeDiscountType,
          promoCodeDiscount: self.promoCodeDiscount,
          promoCodeDiscountAmount: self.promoCodeDiscountAmount,
          calculatedProductPriceWithDiscount: self.calculatedProductPriceWithDiscount,
          chooseProductStep: self.chooseProductStep,
          workFlows: self.workFlows,
          showProductComparison: self.showProductComparison,
          requireSelfInspectionImages: self.requireSelfInspectionImages,
          selfInspectionType: self.selfInspectionType,
          selfInspectionSections: self.selfInspectionSections,
          selfInspectionDynamicDocuments: self.selfInspectionDynamicDocuments,
          stepThreeSections: self.stepThreeSections,
          stepThreeDocumentSections: self.stepThreeDocumentSections,
          showWithHoldingTaxData: self.showWithHoldingTaxData,
          withHoldingTaxRequired: self.withHoldingTaxRequired,
          withHoldingTaxAmount: self.withHoldingTaxAmount,
          withHoldingTaxPercentage: self.withHoldingTaxPercentage,
          stepThreeDynamicFields: self.stepThreeDynamicFields,
          stepThreeDynamicDocuments: self.stepThreeDynamicDocuments,
          showBeneficiary: self.showBeneficiary,
          beneficiary: self.beneficiary,
          beneficiaryData: self.beneficiaryData,
          submitBeneficiary: self.submitBeneficiary,
          beneficiaryRelations: self.beneficiaryRelations,
          showFamily: self.showFamily,
          family: self.family,
          submitFamily: self.submitFamily,
          showDocuments: self.showDocuments,
          uploadInformationStep: self.uploadInformationStep,
          stepThreeMotorImages: self.stepThreeMotorImages,
          stepThreeMotorImagesPath: self.stepThreeMotorImagesPath,
          declaration: self.declaration,
          paymentMethods: self.paymentMethods,
          quotationPaymentStatus: self.quotationPaymentStatus,
          selectedPaymentMethod: self.selectedPaymentMethod,
          mobileNumberVerified: self.mobileNumberVerified,
        };
        self.$store.commit('setPrePaymentData', obj);
        self.$store.commit('setQuotationPayment');

        const token = Buffer.from(`merchant.INSURANCEBAZ:8813a4c3768e8dd89edf7aeaab4448a4`, 'utf8').toString('base64');
        let url = 'https://bankalfalah.gateway.mastercard.com/api/rest/version/56/merchant/INSURANCEBAZ/session';
        let return_url = "https://staging.insurancebazaar.com.pk/abandoned_renew/" + self.parentId + '/' + self.oldQuotationId + '/' + self.selectedClassId + "?payment=true&status=success";
        //let return_url = "http://localhost:8080/abandoned_renew/" + self.parentId + '/' + self.oldQuotationId + '/' + self.selectedClassId + "?payment=true&status=success";

        if(self.promoCodeApplied) {
          var transactionAmount = self.calculatedProductPriceWithDiscount;
        } else {
          var transactionAmount = self.calculatedProductPrice;
        }

        self.showLoader = true;
        self.sessionResponse = {};
        var formData = new FormData();
        formData.append('token', token);
        formData.append('url', url);
        formData.append('order_id', self.quotationDetails.customer_quotation_id);
        formData.append('amount', transactionAmount);
        formData.append('currency', self.selectedProduct.currency);
        formData.append('return_url', return_url);
        axios.post('customer/payment/session', formData).then(function (resp) {
          self.quotationPaymentStatus = true;
          self.sessionResponse = resp.data.data.session;
          self.$store.commit('setSessionResponse', self.sessionResponse);

          self.load_script().then((response) => {
            Checkout.configure({
              merchant: 'INSURANCEBAZ',
              session: {
                id: self.sessionResponse.id
              },
              order: {
                id: self.quotationDetails.customer_quotation_id,
                amount: transactionAmount,
                currency: self.selectedProduct.currency,
                description: self.selectedProduct.product_name + ' - ' + self.selectedProduct.company_name
              },
              interaction: {
                operation: 'PURCHASE',
                merchant: {
                  name: 'INSURANCE BAZAAR',
                  address: {
                    line1: '',
                    line2: ''
                  }
                }
              }
            });

            setTimeout(function() {
              self.showLoader = false;
              Checkout.showPaymentPage();
            }, 100);
          });
        }).catch((error) => {
          self.showLoader = false;
          if(error.response.data.errors != undefined) {
            error.response.data.errors.forEach(element => {
              $toast.error(element.message, { position: 'top-right' });
            });
          } else {
            $toast.error(error.response.data, { position: 'top-right' });
          }
          return false;
        });
      },
      stepOneEasyPaisaPaymentMethod() {
        const self = this;
        let obj = {
          selectedProduct: self.selectedProduct,
          mainClasses: self.mainClasses,
          hasCategory: self.hasCategory,
          categories: self.categories,
          subClasses: self.subClasses,
          selectedClassId: self.selectedClassId,
          selectedSubclassId: self.selectedSubclassId,
          selectedCategoryId: self.selectedCategoryId,
          stepOneSections: self.stepOneSections,
          stepOneDynamicFields: self.stepOneDynamicFields,
          trackerRequired: self.trackerRequired,
          selectedAddonCovers: self.selectedAddonCovers,
          quotationDetails: self.quotationDetails,
          products: self.products,
          calculatedAddonsPrice: self.calculatedAddonsPrice,
          calculatedProductPrice: self.calculatedProductPrice,
          promoCode: self.promoCode,
          promoCodeApplied: self.promoCodeApplied,
          promoCodeDiscountType: self.promoCodeDiscountType,
          promoCodeDiscount: self.promoCodeDiscount,
          promoCodeDiscountAmount: self.promoCodeDiscountAmount,
          calculatedProductPriceWithDiscount: self.calculatedProductPriceWithDiscount,
          chooseProductStep: self.chooseProductStep,
          wishlist: self.wishlist,
          workFlows: self.workFlows,
          showProductComparison: self.showProductComparison,
          requireSelfInspectionImages: self.requireSelfInspectionImages,
          selfInspectionType: self.selfInspectionType,
          selfInspectionSections: self.selfInspectionSections,
          selfInspectionDynamicDocuments: self.selfInspectionDynamicDocuments,
          stepThreeSections: self.stepThreeSections,
          stepThreeDocumentSections: self.stepThreeDocumentSections,
          stepThreeDynamicFields: self.stepThreeDynamicFields,
          stepThreeDynamicDocuments: self.stepThreeDynamicDocuments,
          showWithHoldingTaxData: self.showWithHoldingTaxData,
          withHoldingTaxRequired: self.withHoldingTaxRequired,
          withHoldingTaxAmount: self.withHoldingTaxAmount,
          withHoldingTaxPercentage: self.withHoldingTaxPercentage,
          showBeneficiary: self.showBeneficiary,
          beneficiary: self.beneficiary,
          beneficiaryData: self.beneficiaryData,
          submitBeneficiary: self.submitBeneficiary,
          beneficiaryRelations: self.beneficiaryRelations,
          showFamily: self.showFamily,
          family: self.family,
          submitFamily: self.submitFamily,
          showDocuments: self.showDocuments,
          uploadInformationStep: self.uploadInformationStep,
          stepThreeMotorImages: self.stepThreeMotorImages,
          stepThreeMotorImagesPath: self.stepThreeMotorImagesPath,
          declaration: self.declaration,
          paymentMethods: self.paymentMethods,
          quotationPaymentStatus: self.quotationPaymentStatus,
          selectedPaymentMethod: self.selectedPaymentMethod,
          mobileNumberVerified: self.mobileNumberVerified,
        };
        self.$store.commit('setPrePaymentData', obj);
        self.$store.commit('setQuotationPayment');

        let storeId = '12544';
        let orderId = self.quotationDetails.customer_quotation_id;
        if(self.promoCodeApplied) {
          var transactionAmount = self.calculatedProductPriceWithDiscount;
        } else {
          var transactionAmount = self.calculatedProductPrice;
        }

        let mobileAccountNo = self.easypaisa.mobile_no;
        let emailAddress = self.easypaisa.email;
        let transactionType = 'InitialRequest';
        let ExpiryDate = moment().format('YYYYMMDD HHMMSS');
        let timeStamp = moment().format('YYYY-MM-DDTHH:mm:ss');
        let postBackUrl = "https://staging.insurancebazaar.com.pk/abandoned_renew/" + self.parentId + '/' + self.oldQuotationId + '/' + self.selectedClassId + "?payment=true";
        let paymentMethod = 'MA_PAYMENT_METHOD';

        let str = 'amount='+transactionAmount+'&emailAddress='+emailAddress+'&expiryDate='+ExpiryDate+'&mobileNum='+mobileAccountNo+
          '&orderRefNum='+orderId+'&paymentMethod='+transactionType+'&postBackURL='+postBackUrl+'&storeId='+storeId+'&timeStamp='+timeStamp;

        var aesjs = require("aes-js")
        const keyBuffer = aesjs.utils.utf8.toBytes('WCDN4B7E7574HLYN');
        const inputBuffer = aesjs.padding.pkcs7.pad(aesjs.utils.utf8.toBytes(str));
        const escEcb = new aesjs.ModeOfOperation.ecb(keyBuffer);
        const encryptedBytes = escEcb.encrypt(inputBuffer);
        let encryptedData = Buffer.from(encryptedBytes).toString('base64');

        var formData = new Object();
        formData.storeId = storeId;
        formData.orderId = orderId;
        formData.transactionAmount = transactionAmount;
        formData.mobileAccountNo = mobileAccountNo;
        formData.emailAddress = emailAddress;
        formData.transactionType = transactionType;
        formData.tokenExpiry = ExpiryDate;
        formData.encryptedHashRequest = encryptedData;
        formData.bankIdentificationNumber = '';
        formData.postBackURL = postBackUrl;
        formData.signature = '';

        let sampleString = $.param(formData);

        let baseUrl = 'https://easypaystg.easypaisa.com.pk/tpg/?';
        self.easyPaisaUrl = baseUrl + sampleString;

        //document.getElementById('easyPaisaModalButton').click();
        window.location.href = self.easyPaisaUrl;
      },
      retrievePostPaymentData(status) {
        const self = this;
        self.showLoader = true;
        self.sessionResponse = self.$store.getters.getSessionResponse;

        let obj = self.$store.getters.getPrePaymentData;
        self.parentId = obj.parentId;
        self.oldQuotationId = obj.oldQuotationId;
        self.oldPlanId = obj.oldPlanId;
        self.selectedProduct = obj.selectedProduct;
        self.mainClasses = obj.mainClasses;
        self.hasCategory = obj.hasCategory;
        self.categories = obj.categories;
        self.subClasses = obj.subClasses;
        self.selectedClassId = obj.selectedClassId;
        self.selectedSubclassId = obj.selectedSubclassId;
        self.selectedCategoryId = obj.selectedCategoryId;
        self.stepOneSections = obj.stepOneSections;
        self.stepOneDynamicFields = obj.stepOneDynamicFields;
        self.trackerRequired = obj.trackerRequired;
        self.selectedAddonCovers = obj.selectedAddonCovers;
        self.quotationDetails = obj.quotationDetails;
        self.products = obj.products;
        self.calculatedAddonsPrice = obj.calculatedAddonsPrice;
        self.calculatedProductPrice = obj.calculatedProductPrice;
        self.promoCode = obj.promoCode;
        self.promoCodeApplied = obj.promoCodeApplied;
        self.promoCodeDiscountType = obj.promoCodeDiscountType;
        self.promoCodeDiscount = obj.promoCodeDiscount;
        self.promoCodeDiscountAmount = obj.promoCodeDiscountAmount;
        self.calculatedProductPriceWithDiscount = obj.calculatedProductPriceWithDiscount;
        self.chooseProductStep = obj.chooseProductStep;
        self.workFlows = obj.workFlows;
        self.showProductComparison = obj.showProductComparison;
        self.requireSelfInspectionImages = obj.requireSelfInspectionImages;
        self.selfInspectionType = obj.selfInspectionType;
        self.selfInspectionSections = obj.selfInspectionSections;
        self.selfInspectionDynamicDocuments = obj.selfInspectionDynamicDocuments;
        self.stepThreeSections = obj.stepThreeSections;
        self.stepThreeDocumentSections = obj.stepThreeDocumentSections;
        self.showWithHoldingTaxData = obj.showWithHoldingTaxData;
        self.withHoldingTaxRequired = obj.withHoldingTaxRequired;
        self.withHoldingTaxAmount = obj.withHoldingTaxAmount;
        self.withHoldingTaxPercentage = obj.withHoldingTaxPercentage;
        self.stepThreeDynamicFields = obj.stepThreeDynamicFields;
        self.stepThreeDynamicDocuments = obj.stepThreeDynamicDocuments;
        self.showBeneficiary = obj.showBeneficiary;
        self.beneficiary = obj.beneficiary;
        self.beneficiaryData = obj.beneficiaryData;
        self.submitBeneficiary = obj.submitBeneficiary;
        self.beneficiaryRelations = obj.beneficiaryRelations;
        self.showFamily = obj.showFamily;
        self.family = obj.family;
        self.submitFamily = obj.submitFamily;
        self.showDocuments = obj.showDocuments;
        self.uploadInformationStep = obj.uploadInformationStep;
        self.stepThreeMotorImages = obj.stepThreeMotorImages;
        self.stepThreeMotorImagesPath = obj.stepThreeMotorImagesPath;
        self.declaration = obj.declaration;
        self.paymentMethods = obj.paymentMethods;
        self.quotationPaymentStatus = obj.quotationPaymentStatus;
        self.selectedPaymentMethod = obj.selectedPaymentMethod;
        self.mobileNumberVerified = obj.mobileNumberVerified;
        self.nav_step = 4;
        self.quotationPaymentStatus = true;
        self.$store.commit('resetQuotationTempData');

        if(self.selectedPaymentMethod.toLowerCase() == 'easypaisa') {
          self.showLoader = false;
          if(status == '0000') {
            let orderId = self.$route.query.orderRefNumber != undefined ? self.$route.query.orderRefNumber : '0000';
            self.proceedToCheckPayment(orderId); //for customer quotation id
          } else {
            self.nav_step = 4;
            self.quotationPaymentStatus = false;
            if(status == '0001') {
              $toast.error('Payment Failed!', { position: 'top-right' });
            } else {
              let message = self.$route.query.description != undefined ? self.$route.query.description : 'Payment Error Occurred!'
              $toast.error(message, { position: 'top-right' });
            }
          }
        } else if(self.selectedPaymentMethod.toLowerCase() == 'stripe') {
          if (status == 'success') {
            let orderId = self.quotationDetails.customer_quotation_id;
            const token = Buffer.from(`merchant.INSURANCEBAZ:8813a4c3768e8dd89edf7aeaab4448a4`, 'utf8').toString('base64');
            let url = 'https://bankalfalah.gateway.mastercard.com/api/rest/version/58/merchant/INSURANCEBAZ/order/' + orderId;
            self.showLoader = true;
            var formData = new FormData();
            formData.append('token', token);
            formData.append('url', url);
            setTimeout(function () {
              axios.post('customer/payment/order_confirmation', formData).then(function (response) {
                if (response.data.data.result == 'SUCCESS') {
                  self.quotationPaymentStatus == true;
                  self.nav_step == 5;
                  self.proceedToCheckPayment(orderId); //for customer quotation id
                } else {
                  self.nav_step = 4;
                  self.quotationPaymentStatus = false;
                  self.showLoader = false;
                }
              }).catch((error) => {
                self.showLoader = false;
                if (error.response.data.errors != undefined) {
                  error.response.data.errors.forEach(element => {
                    $toast.error(element.message, {position: 'top-right'});
                  });
                } else {
                  $toast.error(error.response.data, {position: 'top-right'});
                }
                return false;
              });
            }, 300);
          } else {
            self.nav_step = 4;
            self.quotationPaymentStatus = false;
            self.showLoader = false;
            if (status == 'cancel') {
              $toast.error('Payment Cancelled!', {position: 'top-right'});
            } else {
              $toast.error('Payment Error Occurred!', {position: 'top-right'});
            }
          }
        } else {

        }
      },
      async getOldPolicyData() {
        const self = this;
        await axios.get('customer/policy_detail?id=' + self.oldQuotationId).then(function (resp) {
          if (resp.data.code == 200) {
            self.oldPlanId = resp.data.data.plan_id
          } else {
            $toast.error(resp.data.message, { position: 'top-right' });
            return false;
          }
        }).catch(function (error) {
          self.showLoader = false;
          if(error.response) {
            error.response.data.errors.forEach(element => {
              $toast.error(element.message, { position: 'top-right' });
            });
          } else {
            $toast.error(error.data.message, { position: 'top-right' });
          }
        });
      },
      async getMainClasses() {
        const self = this;
        self.showLoader = true;
        await axios.get('get_mainclasses').then(function (resp) {
          if(resp.data.code == 200) {
            self.mainClasses = resp.data.data.main_classes;
            let mainClass = {};

            let noCategory = self.mainClasses.filter(x => x.has_category == 0);
            noCategory.forEach(element => {
              let findSubClass = element.sub_classes.filter(x => x.subclass_id == self.selectedSubclassId);
              if(findSubClass.length > 0) {
                mainClass = element;
                self.selectedClassId = element.id;
                self.subClasses = element.sub_classes;
                self.categories = mainClass.categories;
                self.workFlows = findSubClass[0].workflows;
              }
            });
            if (Object.keys(mainClass).length == 0) {
              let withCategory = self.mainClasses.filter(x => x.has_category == 1);
              withCategory.forEach(element => {
                element.categories.forEach(element1 => {
                  let findSubClass = element1.sub_classes.filter(x => x.subclass_id == self.selectedSubclassId);
                  if(findSubClass.length > 0) {
                    mainClass = element;
                    self.selectedClassId = element.id;
                    self.hasCategory = true;
                    self.selectedCategoryId = element1.id;
                    self.subClasses = element1.sub_classes;
                    self.categories = mainClass.categories;
                    self.workFlows = findSubClass[0].workflows;
                  }
                })
              });
            }
            let className = mainClass.name.toLowerCase();
            if(className.includes('motor')) {
              self.classType = 'motor';
            }
            if(className.includes('health')) {
              self.classType = 'health';
            }
            if(className.includes('life')) {
              self.classType = 'life';
            }
            if(className.includes('travel')) {
              self.classType = 'travel';
            }
            if(className.includes('pa')) {
              self.classType = 'pa';
            }
            if(className.includes('home')) {
              self.classType = 'home';
            }

            if(self.redirectFrom != '') {
              if(!self.hasCategory) {
                self.subClasses = mainClass.sub_classes;
                let selectedSubclass = self.subClasses.filter(x => x.subclass_id == self.selectedSubclassId)[0];
                self.workFlows = selectedSubclass.workflows;
              } else {
                self.categories = mainClass.categories;
                let selectedCategory = self.categories.filter(x => x.id == self.selectedCategoryId)[0];
                self.subClasses = selectedCategory.sub_classes;
                let selectedSubclass = selectedCategory.sub_classes.filter(x => x.subclass_id == self.selectedSubclassId)[0];
                self.workFlows = selectedSubclass.workflows;
              }
            } else {
              self.hasCategory = mainClass.has_category == 1 ? true : false;
              if(!self.hasCategory) {
                self.selectedCategoryId = '';
                self.subClasses = mainClass.sub_classes;
                self.selectedSubclassId = mainClass.sub_classes[0].subclass_id;
                self.workFlows = mainClass.sub_classes[0].workflows;
              } else {
                self.selectedCategoryId = mainClass.categories[0].id;
                self.subClasses = mainClass.categories[0].sub_classes;
                self.categories = mainClass.categories;
                self.selectedSubclassId = mainClass.categories[0].sub_classes[0].subclass_id;
                self.workFlows = mainClass.categories[0].sub_classes[0].workflows;
              }
            }

            self.updateWorkflows();
            self.getQuotationStepOneForm(self.selectedSubclassId);
          } else {
            self.showLoader = false;
            $toast.error(resp.data.message, { position: 'top-right' });
            return false;
          }
        }).catch(function (error) {
          self.showLoader = false;
          if(error.response) {
            error.response.data.errors.forEach(element => {
              $toast.error(element.message, { position: 'top-right' });
            });
          } else {
            $toast.error(error.data.message, { position: 'top-right' });
          }
        });
      },
      async selectCategory(categoryId) {
        const self = this;
        self.selectedCategoryId = categoryId;
        self.subClasses = {};
        self.selectedSubclassId = '';
        let mainClass = self.mainClasses.filter(x => x.id == self.selectedClassId)[0];
        let category = mainClass.categories.filter(x => x.id == self.selectedCategoryId)[0];
        self.subClasses = category.sub_classes;
        self.selectedSubclassId = category.sub_classes[0].subclass_id;
        self.workFlows = category.sub_classes[0].workflows;
        self.updateWorkflows();
        self.getQuotationStepOneForm(self.selectedSubclassId);
      },
      updateWorkflows() {
        const self = this;
        if(Object.keys(self.workFlows).length > 0) {
          let productComparisonWorkflow = self.workFlows.Acquisition.filter(x => x.key == 'multi-insurer-product-comparison');
          if(productComparisonWorkflow.length > 0) {
            self.showProductComparison = productComparisonWorkflow[0].customer_app == 1 ? true : false;
          }
          let imageWorkflow = self.workFlows.Acquisition.filter(x => x.key == 'upload-images-self-inspection');
          if(imageWorkflow.length > 0) {
            self.requireSelfInspectionImages = imageWorkflow[0].customer_app == 1 ? true : false;
          }
          let familyWorkflow = self.workFlows.Acquisition.filter(x => x.key == 'family-information');
          if(familyWorkflow.length > 0) {
            self.showFamily = familyWorkflow[0].customer_app == 1 ? true : false;
          }
          let beneficiaryWorkflow = self.workFlows.Acquisition.filter(x => x.key == 'beneficiary-information');
          if(beneficiaryWorkflow.length > 0) {
            self.showBeneficiary = beneficiaryWorkflow[0].customer_app == 1 ? true : false;
          }
        }
      },
      async getQuotationStepOneForm(subclassId) {
        const self = this;
        self.selectedSubclassId = subclassId;
        self.resetQuotationData();
        self.showLoader = true;

        var formData = new FormData();
        formData.append('subclass_id', subclassId);
        formData.append('customer_quotation_id', self.oldQuotationId);
        await axios.post('get_subclass_form', formData).then(function (resp) {
          self.showLoader = false;
          if(resp.data.code == 200) {
            if (Object.keys(resp.data.data).length > 0) {
              self.stepOneSections = resp.data.data.sections;
              self.initializeStepOneDynamicArray();
            }
          } else {
            self.showLoader = false;
            $toast.error(resp.data.message, { position: 'top-right' });
            return false;
          }
        }).catch(function (error) {
          self.showLoader = false;
          if(error.data.errors != undefined) {
            error.data.errors.forEach(element => {
              $toast.error(element.message, { position: 'top-right' });
            });
          } else {
            $toast.error(error.data.message, { position: 'top-right' });
          }
        });
      },
      initializeStepOneDynamicArray() {
        const self = this;
        self.selectedAddonCovers = [];
        Object.entries(self.stepOneSections).forEach(([key, section]) => {
          Object.entries(section.custom_fields).forEach(([key, field]) => {
            if(field.type.toLowerCase() == 'date') {
              self.stepOneDynamicFields[field.field_name] = self.formatDBDate(field.selected_value, 'field');
            } else {
              self.stepOneDynamicFields[field.field_name] = field.selected_value;
            }
          });
        });
      },
      async getStepOneChildData(field) {
        const self = this;
        if(field.child_id != 0 && self.stepOneDynamicFields[field.field_name] != '') {
          self.showLoader = true;
          var formData = new FormData();
          formData.append('child_form_field_id', field.child_id);
          formData.append('parent_value_id', self.stepOneDynamicFields[field.field_name]);
          await axios.post('get_child_form_field_values', formData).then(function (resp) {
            self.showLoader = false;
            if(resp.data.code == 200) {
              Object.entries(self.stepOneSections).forEach(([key, section]) => {
                Object.entries(section.custom_fields).forEach(([key, secField]) => {
                  if(secField.id == field.child_id) {
                    let values = resp.data.data.form_field_values;
                    secField.default_values = [];
                    values.forEach(element => {
                      secField.default_values.push({
                        id: element.id,
                        text: element.field_value,
                        form_fields_id: element.form_fields_id
                      });
                    });
                    self.stepOneDynamicFields[secField.field_name] = '';
                  }
                });
              });
            } else {
              self.showLoader = false;
              $toast.error(resp.data.message, { position: 'top-right' });
              return false;
            }
          }).catch(function (error) {
            self.showLoader = false;
            if(error.data.errors != undefined) {
              error.data.errors.forEach(element => {
                $toast.error(element.message, { position: 'top-right' });
              });
            } else {
              $toast.error(error.data.message, { position: 'top-right' });
            }
          });
        }
      },
      verifyStepOneNumbers(event, field_name) {
        const self = this;
        self.stepOneErrors = [];
        let val = event.target.value;
        if(val == '') {
          return false;
        }

        const re = /^\d+$/; // for float use /^\d+\.\d+$/
        let result = re.test(String(val));
        if(!result) {
          self.stepOneErrors.push({
            field: field_name,
            message: 'Only numbers are allowed'
          });
        }
      },
      validateStepOneMobileNo(event, field_name) {
        const self = this;
        let val = event.target.value;

        if(val != "") {
          const usingSplit = val.split('');
          let issue = false;

          let i = 0;
          for (i; i < 4; i++) {
            if(usingSplit[i] === '0') {
              issue = true;
              break;
            }
          }

          if (issue) {
            self.stepOneDynamicFields[field_name] = '+92';
          }
        }
      },
      verifyStepOneEmail(event, field_name) {
        const self = this;

        self.stepOneErrors = [];
        let email = event.target.value;
        if(email == '') {
          return false;
        }

        const re = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
        let result = re.test(String(email).toLowerCase());
        if(!result) {
          self.stepOneErrors.push({
            field: field_name,
            message: 'Invalid Email'
          });
        }
      },
      async continueStageOneFrom() {
        const self = this;
        self.stepOneErrors = [];
        Object.entries(self.stepOneDynamicFields).forEach(([key, value]) => {
          if (value == '') {
            Object.entries(self.stepOneSections).forEach(([key1, section]) => {
              Object.entries(section.custom_fields).forEach(([key2, secField]) => {
                if(secField.field_name == key) {
                  if(secField.required) {
                    self.stepOneErrors.push({
                      field: key,
                      message: key.replace(/_/g,' ') + ' required'
                    });
                  }
                }
              })
            })
          } else {
            Object.entries(self.stepOneSections).forEach(([key1, section]) => {
              Object.entries(section.custom_fields).forEach(([key2, secField]) => {
                if(secField.field_name == key) {
                  if(secField.type == 'date') {
                    let selectedDate = moment(value).startOf('day');
                    if (secField.max_date && secField.min_date) {
                      let maxDate = moment(secField.max_date, "YYYY-MM-DD");
                      let minDate = moment(secField.min_date, "YYYY-MM-DD");
                      if (selectedDate < minDate) {
                        self.stepOneErrors.push({
                          field: key,
                          message: key.replace(/_/g, ' ') + ' must be between ' + moment(minDate).format('DD-MMM-YYYY') + ' and ' + moment(maxDate).format('DD-MMM-YYYY')
                        });
                        return false;
                      }
                      if (selectedDate > maxDate) {
                        self.stepOneErrors.push({
                          field: key,
                          message: key.replace(/_/g, ' ') + ' must be between ' + moment(minDate).format('DD-MMM-YYYY') + ' and ' + moment(maxDate).format('DD-MMM-YYYY')
                        });
                        return false;
                      }
                    }

                    if (secField.max_date) {
                      let maxDate = moment(secField.max_date, "YYYY-MM-DD");
                      if (selectedDate > maxDate) {
                        self.stepOneErrors.push({
                          field: key,
                          message: key.replace(/_/g, ' ') + ' must be less than or equal to ' + moment(maxDate).format('DD-MMM-YYYY')
                        });
                        return false;
                      }
                    }

                    if (secField.min_date) {
                      let minDate = moment(secField.min_date, "YYYY-MM-DD");
                      if (selectedDate < minDate) {
                        self.stepOneErrors.push({
                          field: key,
                          message: key.replace(/_/g, ' ') + ' must be greater than or equal to  ' + moment(minDate).format('DD-MMM-YYYY')
                        });
                        return false;
                      }
                    }
                  }

                  if(secField.inputType == 'email') {
                    const e_re = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
                    let e_result = e_re.test(value);
                    if(!e_result) {
                      self.stepOneErrors.push({
                        field: key,
                        message: 'Invalid Email'
                      });
                    }
                  }

                  if(secField.inputType == 'mobile') {
                    if(value.length < 13) {
                      self.stepOneErrors.push({
                        field: key,
                        message: 'Incorrect Mobile Number'
                      });
                    }
                  }

                  if(secField.inputType == 'number') {
                    const re = /^\d+$/; // for float use /^\d+\.\d+$/
                    let result = re.test(value);
                    if(!result) {
                      self.stepOneErrors.push({
                        field: key,
                        message: 'Only numbers allowed'
                      });
                    }

                    if((secField.min_rule != null && secField.max_rule != null) && (value < secField.min_rule || value > secField.max_rule)) {
                      self.stepOneErrors.push({
                        field: key,
                        message: secField.label + ' must be between ' + secField.min_rule + ' and ' + secField.max_rule
                      });
                    }

                    if(secField.min_rule != null && value < secField.min_rule) {
                      self.stepOneErrors.push({
                        field: key,
                        message: secField.label + ' must be greater than or equal to ' + secField.min_rule
                      });
                    }

                    if(secField.max_rule != null && value > secField.max_rule) {
                      self.stepOneErrors.push({
                        field: key,
                        message: secField.label + ' must be less than or equal to ' + secField.max_rule
                      });
                    }
                  }

                  if(secField.inputType == 'cnic') {
                    if(value.length != 15) {
                      self.stepOneErrors.push({
                        field: key,
                        message: 'Invalid Cnic'
                      });
                    }
                  }

                  if (key === 'first_name'|| (key === 'middle_name' && value != '') || key === 'last_name') {
                    const re = /^[A-Za-z ]+$/;
                    let result = re.test(value);
                    if(!result) {
                      self.stepOneErrors.push({
                        field: key,
                        message: 'Only characters allowed'
                      });
                    }

                    if (value != null && value.length > 15) {
                      self.stepOneErrors.push({
                        field: key,
                        message: 'Maximum 15 characters allowed'
                      });
                    }
                  }

                  if(key == 'tracker_required') {
                    let yesId = secField.default_values.filter(x => x.text.toLowerCase() == 'yes')[0].id;
                    let noId = secField.default_values.filter(x => x.text.toLowerCase() == 'no')[0].id;

                    if(value == yesId) {
                      self.trackerRequired = true;
                    }
                    if(value == noId) {
                      self.trackerRequired = false;
                    }
                  }
                }
              })
            })
          }
        });

        if (self.stepOneErrors.length > 0) {
          $toast.error('Please Review Fields Again!', { position: 'top-right' });
          return false;
        }

        var formData = new FormData();
        if(self.hasCategory) {
          formData.append('category_id', self.selectedCategoryId);
        }
        formData.append('subclass_id', self.selectedSubclassId);
        formData.append('customer_quotation_id', self.oldQuotationId);
        Object.entries(self.stepOneDynamicFields).forEach(([key, value]) => {
          Object.entries(self.stepOneSections).forEach(([key1, section]) => {
            Object.entries(section.custom_fields).forEach(([key2, secField]) => {
              if (secField.field_name == key) {
                if(secField.type.toLowerCase() == 'date') {
                  formData.append(key, moment(value).format("YYYY-MM-DD"));
                } else {
                  formData.append(key, value);
                }
              }
            })
          });
        });

        self.showLoader = true;
        await axios.post('customer_quotation', formData).then(function (resp) {
          self.showLoader = false;
          if(resp.data.code == 200) {
            self.comparingProducts = [];
            self.products = resp.data.data.products;
            self.filteredProducts = resp.data.data.products;
            //self.selectedFilteringProductsCompanies = [];
            self.selectedFilteringProductsNames = [];
            resp.data.data.products.forEach(product => {
              self.productsCompanies.push(product.company_name.toLowerCase());
              self.productsNames.push(product.product_name.toLowerCase());
            });

            let newCompanies = self.productsCompanies.filter((x, i, a) => a.indexOf(x) === i);
            self.productsCompanies = newCompanies;
            let newNames = self.productsNames.filter((x, i, a) => a.indexOf(x) === i);
            self.productsNames = newNames;

            let oldPlan = self.filteredProducts.filter(x => x.plan_id == self.oldPlanId);
            if(oldPlan.length > 0) {
              self.chooseProductStep = 1;
              self.updateStep(1);
              self.selectProduct(oldPlan[0]);
            } else {
              $toast.error('Old Plan Not Found!', { position: 'top-right' });
              return false;
            }
          } else {
            self.showLoader = false;
            $toast.error(resp.data.message, { position: 'top-right' });
            return false;
          }
        }).catch(function (error) {
          self.showLoader = false;
          if(error.data.errors != undefined) {
            error.data.errors.forEach(element => {
              $toast.error(element.message, { position: 'top-right' });
            });
          } else {
            $toast.error(error.data.message, { position: 'top-right' });
          }
        });
      },
      updateFilteredProductsByCompany() {
        const self = this
        self.selectedProduct = {};
        self.sortByPremium = '';
        self.selectedFilteringProductsNames = [];
        let filteringProducts = [];
        let filteringNames = [];

        if(self.selectedFilteringProductsCompanies.length > 0) {
          self.selectedFilteringProductsCompanies.forEach(company => {
            let products = self.products.filter(x => x.company_name.toLowerCase() == company.toLowerCase());
            if(products.length > 0) {
              self.filteredProducts = {};
              self.productsNames = [];
              products.forEach(prod => {
                filteringProducts.push(prod);
                filteringNames.push(prod.product_name);
              });
              self.filteredProducts = filteringProducts;

              let newNames = filteringNames.filter((x, i, a) => a.indexOf(x) === i);
              self.productsNames = newNames;
            }
          });
        } else {
          Object.entries(self.products).forEach(([key, value]) => {
            filteringProducts.push(value);
            filteringNames.push(value.product_name);
          });

          self.filteredProducts = {};
          self.filteredProducts = filteringProducts;

          self.productsNames = [];
          let newNames = filteringNames.filter((x, i, a) => a.indexOf(x) === i);
          self.productsNames = newNames;
        }
      },
      updateFilteredProductsByName() {
        const self = this
        let filteringProducts = [];
        let filteringNames = [];
        if(self.selectedFilteringProductsCompanies.length > 0) {
          self.selectedFilteringProductsCompanies.forEach(company => {
            let products = self.products.filter(x => x.company_name.toLowerCase() == company.toLowerCase());
            if(products.length > 0) {
              self.filteredProducts = {};
              self.productsNames = [];
              products.forEach(prod => {
                filteringProducts.push(prod);
                filteringNames.push(prod.product_name);
              });
              self.filteredProducts = filteringProducts;

              let newNames = filteringNames.filter((x, i, a) => a.indexOf(x) === i);
              self.productsNames = newNames;
            }
          });
        } else {
          Object.entries(self.products).forEach(([key, value]) => {
            filteringProducts.push(value);
            filteringNames.push(value.product_name);
          });

          self.filteredProducts = {};
          self.filteredProducts = filteringProducts;

          self.productsNames = [];
          let newNames = filteringNames.filter((x, i, a) => a.indexOf(x) === i);
          self.productsNames = newNames;
        }

        filteringProducts = [];
        if(self.selectedFilteringProductsNames.length > 0) {
          self.selectedFilteringProductsNames.forEach(name => {
            let products = self.filteredProducts.filter(x => x.product_name.toLowerCase() == name.toLowerCase());
            if(products.length > 0) {
              products.forEach(prod => {
                filteringProducts.push(prod);
              });
            }
          });
          self.filteredProducts = {};
          self.filteredProducts = filteringProducts;
        } else {
          Object.entries(self.filteredProducts).forEach(([key, value]) => {
            filteringProducts.push(value);
            filteringNames.push(value.product_name);
          });

          self.filteredProducts = {};
          self.filteredProducts = filteringProducts;

          self.productsNames = [];
          let newNames = filteringNames.filter((x, i, a) => a.indexOf(x) === i);
          self.productsNames = newNames;
        }

        self.updateFilteredProductsByPremium();
      },
      updateFilteredProductsByPremium() {
        const self = this;
        if(self.sortByPremium != '' && self.sortByPremium == 'low to high') {
          self.filteredProducts.sort(function (a, b) {
            let fa = a.price, fb = b.price

            if (fa < fb) {
              return -1
            }
            if (fa > fb) {
              return 1
            }
            return 0
          });
        }
        if(self.sortByPremium != '' && self.sortByPremium == 'high to low') {
          self.filteredProducts.sort(function (a, b) {
            let fa = a.price, fb = b.price

            if (fa > fb) {
              return -1
            }
            if (fa < fb) {
              return 1
            }
            return 0
          });
        }
      },
      selectProduct(product) {
        const self = this;
        self.selectedProduct = product;
        self.withHoldingTaxRequired = product.withholding_tax_applicable ? true : false;
        self.calculatedProductPrice = product.price;
        let selectedAddons = self.selectedProduct.add_ons.filter(x => x.is_selected == 1);
        selectedAddons.forEach(addon => {
          self.checkUncheck(addon.id);
          self.showAddonDropped = true;
        });
        if(self.selectedProduct.add_ons.length > 0) {
          self.chooseProductStep = self.chooseProductStep + 1;
        } else {
          self.chooseProductStep = self.chooseProductStep + 2;
        }
      },
      showComparePlansModal() {
        const self = this;
        self.showComaprisonPremiumRate = false;
        self.showComaprisonPremiumAmount = false;
        self.showComaprisonSumInsured = false;
        self.showComaprisonTracker = false;
        self.showComaprisonCoverages = false;
        self.showComaprisonCoveragesDeductible = false;
        self.showComaprisonCoveragesDetails = false;
        self.showComaprisonExclusions = false;
        self.showComaprisonCompanyProfile = false;
        self.comparisonCompanyProfileObjects = [];
        self.comparisonCompanyProfileCoverages = [];

        self.comparingProducts.forEach(product => {
          if(product.comparison_config.basic_detail.premium_rate_is_on) {
            self.showComaprisonPremiumRate = true;
          }

          if(product.comparison_config.basic_detail.premium_amount_is_on) {
            self.showComaprisonPremiumAmount = true;
          }

          if(product.comparison_config.basic_detail.sum_insured_is_on) {
            self.showComaprisonSumInsured = true;
          }

          if(product.comparison_config.basic_detail.tracker_is_on) {
            self.showComaprisonTracker = true;
          }

          if(product.comparison_config.coverages_is_on) {
            self.showComaprisonCoverages = true;
          }

          if(product.comparison_config.exclusions_is_on) {
            self.showComaprisonExclusions = true;
          }

          if(product.comparison_config.company_profile_is_on) {
            self.showComaprisonCompanyProfile = true;
          }

          product.comparison_config.company_profile.forEach(obj => {
            self.comparisonCompanyProfileObjects.push(obj.name.toLowerCase());
          });

          product.comparison_config.coverages.forEach(obj => {
            self.comparisonCompanyProfileCoverages.push(obj.name.toLowerCase());
          });

          if(product.comparison_config.coverages.filter(x => x.allow_deductible == 1).length > 0) {
            self.showComaprisonCoveragesDeductible = true;
          }

          if(product.comparison_config.coverages.filter(x => x.allow_coverdetail == 1).length > 0) {
            self.showComaprisonCoveragesDetails = true;
          }
        });

        let newObjects = self.comparisonCompanyProfileObjects.filter((x, i, a) => a.indexOf(x) === i);
        self.comparisonCompanyProfileObjects = newObjects;
        let newCoverages = self.comparisonCompanyProfileCoverages.filter((x, i, a) => a.indexOf(x) === i);
        self.comparisonCompanyProfileCoverages = newCoverages;

        //document.getElementById('ComparisonModal').style.display = 'block';
      },
      closeComparePlansModal() {
        const self = this;
        self.showComaprisonPremiumRate = false;
        self.showComaprisonPremiumAmount = false;
        self.showComaprisonSumInsured = false;
        self.showComaprisonTracker = false;
        self.showComaprisonCoverages = false;
        self.showComaprisonCoveragesDeductible = false;
        self.showComaprisonCoveragesDetails = false;
        self.showComaprisonExclusions = false;
        self.showComaprisonCompanyProfile = false;
        self.comparisonCompanyProfileObjects = [];
        self.comparisonCompanyProfileCoverages = [];
        //document.getElementById('ComparisonModal').style.display = 'none';
      },
      addComparingProduct(product) {
        const self = this;
        if(self.comparingProducts.length < 3) {
          self.comparingProducts.push(product);
        } else {
          $toast.error("Maximum three plans can be compared ata time", { position: 'top-right' });
        }
      },
      removeComparingProduct(product) {
        const self = this;
        let index = self.comparingProducts.findIndex(x => x.id == product.id);
        if (index !== -1) {
          self.comparingProducts.splice(index, 1);
        }
      },
      buyComparingProduct(product) {
        const self = this;
        setTimeout(function() {
          self.comparingProducts = [];
        }, 100);
        self.selectedProduct = product;
        self.calculatedProductPrice = product.price;
        if(self.selectedProduct.add_ons.length > 0) {
          self.chooseProductStep = self.chooseProductStep + 1;
        } else {
          self.chooseProductStep = self.chooseProductStep + 2;
        }

        self.closeComparePlansModal();
      },
      checkUncheck(addonId) {
        const self = this;
        let index = self.selectedAddonCovers.findIndex(x => x.id == addonId);
        let addon = self.selectedProduct.add_ons.filter(x => x.id == addonId)[0];
        if(index == -1) {
          self.selectedAddonCovers.push(addon);
          self.calculatedAddonsPrice = self.calculatedAddonsPrice + parseInt(addon.cover_limit_amount);
          self.calculatedProductPrice = self.calculatedProductPrice + parseInt(addon.cover_limit_amount);
        } else {
          let index = self.selectedAddonCovers.findIndex(x => x.id == addonId);
          if (index !== -1) {
            self.selectedAddonCovers.splice(index, 1);
          }
          self.calculatedAddonsPrice = self.calculatedAddonsPrice - parseInt(addon.cover_limit_amount);
          self.calculatedProductPrice = self.calculatedProductPrice - parseInt(addon.cover_limit_amount);
        }
      },
      checkAUth() {
        const self = this;
        let token = self.$store.getters.getLoginUserToken;
        if(token == "") {
          self.showLoginModal();
        } else {
          self.submitStageOneFrom();
        }
      },
      resetQuotationData() {
        const self = this;
        self.nav_step = 1;
        self.products = {};
        self.filteredProducts = {};
        self.sortByPremium = '';
        self.productsCompanies = [];
        self.selectedFilteringProductsCompanies = [];
        self.productsNames = [];
        self.selectedFilteringProductsNames = [];
        self.selectedProduct = {};
        self.calculatedAddonsPrice = 0;
        self.calculatedProductPrice = 0;
        self.promoCode = ''
        self.promoCodeApplied = false;
        self.promoCodeDiscountType = '';
        self.promoCodeDiscount = 0;
        self.promoCodeDiscountAmount = 0;
        self.calculatedProductPriceWithDiscount = 0;
        self.showAddonDropped = false;
        self.comparingProducts = [];
        self.showComaprisonPremiumRate = false;
        self.showComaprisonPremiumAmount = false;
        self.showComaprisonSumInsured = false;
        self.showComaprisonTracker = false;
        self.showComaprisonCoverages = false;
        self.showComaprisonCoveragesDeductible = false;
        self.showComaprisonCoveragesDetails = false;
        self.showComaprisonExclusions = false;
        self.showComaprisonCompanyProfile = false;
        self.comparisonCompanyProfileObjects = [];
        self.comparisonCompanyProfileCoverages = [];
        self.chooseProductStep = 1;
        self.stepOneSections = {};
        self.stepOneDynamicFields = {};
        self.trackerRequired = false;
        self.stepOneErrors = [];
        self.selectedAddonCovers = [];
        self.quotationDetails = {};
        //self.workFlows = [];
        //self.requireSelfInspectionImages = false;
        self.selfInspectionType = '';
        self.selfInspectionSections = [];
        self.selfInspectionDynamicDocuments = {};
        self.selfInspectionImagesErrors = [];
        self.stepThreeSections = {};
        self.stepThreeDocumentSections = [];
        self.showWithHoldingTaxData = false;
        self.withHoldingTaxRequired = false;
        self.withHoldingTaxAmount = 0;
        self.withHoldingTaxPercentage = 0;
        self.stepThreeDynamicFields = {};
        self.stepThreeDynamicDocuments = {};
        //self.showBeneficiary = false;
        self.beneficiary = {};
        self.beneficiaryData = {};
        self.submitBeneficiary = [];
        self.beneficiaryRelations = {};
        self.beneficiaryModalType = '';
        self.beneficiaryErrors = [];
        //self.showFamily = false;
        self.family = {};
        self.submitFamily = {
          spouse: [],
          child: []
        };
        self.familyErrors = [];
        self.familyData = {
          name: '',
          cnic: '',
          dob: '',
          passport: '',
          relationship: '',
          is_deleted: false,
          gender: ''
        };
        self.familyModalType = '';
        self.stepThreeErrors = [];
        self.showDocuments = false;
        self.stepThreeDocumentsErrors = [];
        self.uploadInformationStep = 1;
        self.stepThreeMotorImages = {
          front_right: [],
          front_center: [],
          front_left: [],
          center_right: [],
          center_top: [],
          center_left: [],
          rear_right: [],
          rear_center: [],
          rear_left: []
        };
        self.stepThreeMotorImagesPath = {
          front_right: [],
          front_center: [],
          front_left: [],
          center_right: [],
          center_top: [],
          center_left: [],
          rear_right: [],
          rear_center: [],
          rear_left: []
        };
        self.declaration = {
          things_to_note: false,
          right_information: false
        };
        self.stepThreeMotorImagesErrors = [];
        self.paymentMethods = [];
        self.planPromos = [];
        self.quotationPaymentStatus = false;
        self.selectedPaymentMethod = '';
        self.cardPaymentMethodErrors = [];
        self.cheque = {
          cheque_no: '',
          cheque_issue_date: ''
        };
        self.chequeImages = [];
        self.chequePaymentMethodErrors = [];
        self.easypaisa = {
          mobile_no: '',
          email: ''
        };
        self.easyPaisaMethodErrors = [];
        self.easyPaisaUrl = '';
        self.mobileNumberVerified = false;
        self.sessionResponse = {};
        self.pdfLink = '';
        self.promos = [];
        self.submittedAcquisitionResponse = {
          product: {},
          quotation: {}
        };
        self.showSubmitted = false;
      },
      async submitStageOneFrom() {
        const self = this;
        var formData = new FormData();
        formData.append('subclass_id', self.selectedSubclassId);
        formData.append('plan_id', self.selectedProduct.plan_id);
        formData.append('product_price', self.calculatedProductPrice);
        formData.append('customer_quotation_id', self.oldQuotationId);
        formData.append('parent_id', self.parentId);

        Object.entries(self.stepOneDynamicFields).forEach(([key, value]) => {
          Object.entries(self.stepOneSections).forEach(([key1, section]) => {
            Object.entries(section.custom_fields).forEach(([key2, secField]) => {
              if (secField.field_name == key) {
                if(secField.type.toLowerCase() == 'date') {
                  formData.append(key, moment(value).format("YYYY-MM-DD"));
                } else {
                  formData.append(key, value);
                }
              }
            })
          });
        });

        if (self.selectedAddonCovers.length > 0) {
          var addonsArray = new Array();
          self.selectedAddonCovers.forEach(cover => {
            addonsArray.push(cover.id);
          })
          formData.append('add_on_ids[]', addonsArray);
        }

        self.showLoader = true;
        await axios.post('customer/quotation', formData).then(function (resp) {
          if(resp.data.code == 200) {
            if(resp.data.data.quotation_details.length > 0) {
              self.quotationDetails = resp.data.data.quotation_details[0];
              self.$store.commit('setCustomerQuotation', resp.data.data.quotation_details[0])
            }
            self.getQuotationStepThreeForm();
          } else {
            self.showLoader = false;
            $toast.error(resp.data.message, { position: 'top-right' });
            return false;
          }
        }).catch(function (error) {
          self.showLoader = false;
          if(error.data.errors != undefined) {
            error.data.errors.forEach(element => {
              $toast.error(element.message, { position: 'top-right' });
            });
          } else {
            $toast.error(error.data.message, { position: 'top-right' });
          }
        });
      },
      async getQuotationStepThreeForm() {
        const self = this;
        self.showLoader = true;
        let obj = {
          customer_quotation_id: self.oldQuotationId, stage: 3, subclass_id: self.selectedSubclassId
        }

        await axios.get('customer/quote_fields', { params: obj }).then(function (resp) {
          self.showLoader = false;
          if(resp.data.code == 200) {
            let addSignature = false;
            let addDocuments = false;

            if(Object.keys(self.workFlows).length > 0) {
              self.selfInspectionType = resp.data.data.inspection_images.lenght > 0 ? resp.data.data.inspection_images[0].image_type : '';
              self.selfInspectionSections = resp.data.data.inspection_images.filter(x => x.is_visible == 1);

              Object.entries(self.selfInspectionSections).forEach(([key, field]) => {
                self.selfInspectionDynamicDocuments[field.field_name] = [];
              });

              if(self.showFamily && resp.data.data.configurations.family != null) {
                self.showFamily = true;
              } else {
                self.showFamily = false;
              }

              if(self.showBeneficiary && resp.data.data.configurations.beneficiary.fields.length > 0) {
                self.showBeneficiary = true;
              } else {
                self.showBeneficiary = false;
              }

              let signatureWorkflow = self.workFlows.Acquisition.filter(x => x.key == 'signatures');
              if(signatureWorkflow.length > 0) {
                addSignature = signatureWorkflow[0].customer_app == 1 ? true : false;
              }
              let uploadDocumentsWorkflow = self.workFlows.Acquisition.filter(x => x.key == 'upload-required-document');
              if(uploadDocumentsWorkflow.length > 0) {
                addDocuments = uploadDocumentsWorkflow[0].customer_app == 1 ? true : false;
              }
            }

            self.stepThreeSections = resp.data.data.sections;
            self.beneficiary = resp.data.data.configurations.beneficiary;
            self.family = resp.data.data.configurations.family == null ? {} : resp.data.data.configurations.family;
            self.stepThreeDocumentSections = [];
            if(addDocuments) {
              self.stepThreeDocumentSections = resp.data.data.documents.filter(x => x.visible == 1);
            }

            if(addSignature) {
              self.stepThreeDocumentSections.push({
                field_name: 'signature_document',
                label: 'Signature',
                required: 0,
                visible: 1,
                max_rule: 1,
                min_rule: 1,
              });
            }

            if(addSignature || addDocuments) {
              self.showDocuments = true;
            }

            self.initializeStepThreeDynamicArray();
            if(self.showBeneficiary) {
              self.initializeBeneficiaryDynamicArray();
            }
            if(self.showFamily) {
              self.getFamilyData();
            }
            self.updateStep(1);
          } else {
            self.showLoader = false;
            $toast.error(resp.data.message, { position: 'top-right' });
            return false;
          }
        }).catch(function (error) {
          self.showLoader = false;
          if(error.data.errors != undefined) {
            error.data.errors.forEach(element => {
              $toast.error(element.message, { position: 'top-right' });
            });
          } else {
            $toast.error(error.data.message, { position: 'top-right' });
          }
        });
      },
      initializeStepThreeDynamicArray() {
        const self = this;
        Object.entries(self.stepThreeSections).forEach(([key, section]) => {
          Object.entries(section.custom_fields).forEach(([key, field]) => {
            if(field.type.toLowerCase() == 'date') {
              self.stepThreeDynamicFields[field.field_name] = self.formatDBDate(field.selected_value, 'field');
            } else {
              self.stepThreeDynamicFields[field.field_name] = field.selected_value;
            }
          });
        });

        if(self.showDocuments) {
          Object.entries(self.stepThreeDocumentSections).forEach(([key, field]) => {
            self.stepThreeDynamicDocuments[field.field_name] = [];
          });
        }
      },
      initializeBeneficiaryDynamicArray() {
        const self = this;
        self.beneficiaryData['id'] = '';
        self.beneficiary.fields.forEach(field => {
          self.beneficiaryData[field.beneficiary_detail_field] = '';
        });
        self.beneficiaryData['is_deleted'] = false;
        self.getBeneficiariesData();
      },
      async getBeneficiariesData () {
        const self = this;
        const promises = [];
        self.showLoader = true;
        promises.push(await axios.get('customer/beneficiary_relations').then(function (resp) {
          if(resp.data.code == 200) {
            self.beneficiaryRelations = resp.data.data.beneficiary_relations;
          } else {
            $toast.error(resp.data.message, { position: 'top-right' });
          }
        }).catch(function (error) {
          self.showLoader = false;
          if(error.data.errors != undefined) {
            error.data.errors.forEach(element => {
              $toast.error(element.message, { position: 'top-right' });
            });
          } else {
            $toast.error(error.data.message, { position: 'top-right' });
          }
        }));

        promises.push(await axios.get('customer/policy_beneficiaries?policy_id=' + self.oldQuotationId + '&status=inactive').then(function (resp) {
          if(resp.data.code == 200) {
            if(resp.data.data.length > 0) {
              self.submitBeneficiary = [];
              resp.data.data.forEach(element => {
                self.submitBeneficiary.push({
                  id: element.id,
                  is_deleted: false,
                  first_name: element.first_name,
                  last_name: element.last_name,
                  gender: element.gender,
                  mobile_no: element.mobile_no,
                  cnic: element.cnic,
                  cnic_issue_date: self.formatDBDate(element.cnic_issue_date, 'beneficiary'),
                  cnic_expiry_date: self.formatDBDate(element.cnic_expiry_date, 'beneficiary'),
                  relationship: element.relation.id,
                  email: element.email,
                  dob: self.formatDBDate(element.dob, 'beneficiary'),
                  address: element.address,
                });
              });
            } else {
              axios.get('customer/policy_beneficiaries?policy_id=' + self.parentId + '&status=active').then(function (resp) {
                if(resp.data.data.length > 0) {
                  self.submitBeneficiary = [];
                  resp.data.data.forEach(element => {
                    self.submitBeneficiary.push({
                      id: -element.id,
                      is_deleted: false,
                      first_name: element.first_name,
                      last_name: element.last_name,
                      gender: element.gender,
                      mobile_no: element.mobile_no,
                      cnic: element.cnic,
                      cnic_issue_date: self.formatDBDate(element.cnic_issue_date, 'beneficiary'),
                      cnic_expiry_date: self.formatDBDate(element.cnic_expiry_date, 'beneficiary'),
                      relationship: element.relation.id,
                      email: element.email,
                      dob: self.formatDBDate(element.dob, 'beneficiary'),
                      address: element.address,
                    });
                  });
                }
              }).catch(function (resp) {
                self.showLoader = false;
                $toast.error('Error in fetching beneficiaries', { position: 'top-right' });
              });
            }
          } else {
            self.showLoader = false;
            $toast.error(resp.data.message, { position: 'top-right' });
          }
        }).catch(function (resp) {
          $toast.error('Error in beneficiaries fetching', { position: 'top-right' });
        }));

        Promise.all(promises).then(() => {
          self.showLoader = false;
        });
      },
      async getFamilyData() {
        const self = this;
        self.showLoader = true;
        await axios.get('customer/policy_family_members?policy_id=' + self.oldQuotationId).then(function (resp) {
          self.showLoader = false;
          if(resp.data.code == 200) {
            if(resp.data.data.length > 0) {
              self.showLoader = false;
              self.submitFamily = {
                spouse: [],
                child: []
              };
              resp.data.data.filter(x => x.relation == 'spouse').forEach(element => {
                self.submitFamily.spouse.push({
                  id: element.id,
                  name: element.name,
                  cnic: element.cnic,
                  dob: self.formatDBDate(element.dob, 'beneficiary'),
                  passport: element.passport,
                  relationship: element.relation,
                  gender: element.gender,
                  is_deleted: false
                });
              });
              resp.data.data.filter(x => x.relation == 'child').forEach(element => {
                self.submitFamily.child.push({
                  id: element.id,
                  name: element.name,
                  cnic: element.cnic,
                  dob: self.formatDBDate(element.dob, 'beneficiary'),
                  passport: element.passport,
                  relationship: element.relation,
                  gender: element.gender,
                  is_deleted: false
                });
              });
            } else {
              axios.get('customer/policy_family_members?policy_id=' + self.parentId).then(function (resp) {
                self.showLoader = false;
                if(resp.data.data.length > 0) {
                  self.submitFamily = {
                    spouse: [],
                    child: []
                  };
                  resp.data.data.filter(x => x.relation == 'spouse').forEach(element => {
                    self.submitFamily.spouse.push({
                      id: -element.id,
                      name: element.name,
                      cnic: element.cnic,
                      dob: self.formatDBDate(element.dob, 'beneficiary'),
                      passport: element.passport,
                      relationship: element.relation,
                      gender: element.gender,
                      is_deleted: false
                    });
                  });
                  resp.data.data.filter(x => x.relation == 'child').forEach(element => {
                    self.submitFamily.child.push({
                      id: -element.id,
                      name: element.name,
                      cnic: element.cnic,
                      dob: self.formatDBDate(element.dob, 'beneficiary'),
                      passport: element.passport,
                      relationship: element.relation,
                      gender: element.gender,
                      is_deleted: false
                    });
                  });
                }
              }).catch(function (resp) {
                self.showLoader = false;
                $toast.error('Error in family fetching', { position: 'top-right' });
              });
            }
          } else {
            self.showLoader = false;
            $toast.error(resp.data.message, { position: 'top-right' });
          }
        }).catch(function (resp) {
          self.showLoader = false;
          $toast.error('Error in family fetching', { position: 'top-right' });
        });
      },
      async getPolicyBeneficiaries(steps) {
        const self = this;
        self.showLoader = true;
        const promises = [];
        if(self.showBeneficiary) {
          promises.push(await axios.get('customer/policy_beneficiaries?policy_id=' + self.oldQuotationId + '&status=inactive').then(function (resp) {
            if(resp.data.code == 200) {
              if(resp.data.data.length > 0) {
                self.submitBeneficiary = [];
                resp.data.data.forEach(element => {
                  self.submitBeneficiary.push({
                    id: element.id,
                    is_deleted: false,
                    first_name: element.first_name,
                    last_name: element.last_name,
                    gender: element.gender,
                    mobile_no: element.mobile_no,
                    cnic: element.cnic,
                    cnic_issue_date: self.formatDBDate(element.cnic_issue_date, 'beneficiary'),
                    cnic_expiry_date: self.formatDBDate(element.cnic_expiry_date, 'beneficiary'),
                    relationship: element.relation.id,
                    email: element.email,
                    dob: self.formatDBDate(element.dob, 'beneficiary'),
                    address: element.address,
                  });
                });
              } else {
                axios.get('customer/policy_beneficiaries?policy_id=' + self.parentId + '&status=active').then(function (resp) {
                  if(resp.data.data.length > 0) {
                    self.submitBeneficiary = [];
                    resp.data.data.forEach(element => {
                      self.submitBeneficiary.push({
                        id: -element.id,
                        is_deleted: false,
                        first_name: element.first_name,
                        last_name: element.last_name,
                        gender: element.gender,
                        mobile_no: element.mobile_no,
                        cnic: element.cnic,
                        cnic_issue_date: self.formatDBDate(element.cnic_issue_date, 'beneficiary'),
                        cnic_expiry_date: self.formatDBDate(element.cnic_expiry_date, 'beneficiary'),
                        relationship: element.relation.id,
                        email: element.email,
                        dob: self.formatDBDate(element.dob, 'beneficiary'),
                        address: element.address,
                      });
                    });
                  }
                }).catch(function (resp) {
                  self.showLoader = false;
                  $toast.error('Error in fetching beneficiaries', { position: 'top-right' });
                });
              }
            } else {
              self.showLoader = false;
              $toast.error(resp.data.message, { position: 'top-right' });
            }
          }).catch(function (resp) {
            self.showLoader = false;
            $toast.error('Error in fetching beneficiaries', { position: 'top-right' });
          }));
        }

        if(self.showFamily) {
          promises.push(await axios.get('customer/policy_family_members?policy_id=' + self.oldQuotationId).then(function (resp) {
            if(resp.data.code == 200) {
              if(resp.data.data.length > 0) {
                self.submitFamily = {
                  spouse: [],
                  child: []
                };
                resp.data.data.filter(x => x.relation == 'spouse').forEach(element => {
                  self.submitFamily.spouse.push({
                    id: element.id,
                    name: element.name,
                    cnic: element.cnic,
                    dob: self.formatDBDate(element.dob, 'beneficiary'),
                    passport: element.passport,
                    relationship: element.relation,
                    gender: element.gender,
                    is_deleted: false
                  });
                });
                resp.data.data.filter(x => x.relation == 'child').forEach(element => {
                  self.submitFamily.child.push({
                    id: element.id,
                    name: element.name,
                    cnic: element.cnic,
                    dob: self.formatDBDate(element.dob, 'beneficiary'),
                    passport: element.passport,
                    relationship: element.relation,
                    gender: element.gender,
                    is_deleted: false
                  });
                });
              } else {
                axios.get('customer/policy_family_members?policy_id=' + self.parentId).then(function (resp) {
                  if(resp.data.data.length > 0) {
                    self.submitFamily = {
                      spouse: [],
                      child: []
                    };
                    resp.data.data.filter(x => x.relation == 'spouse').forEach(element => {
                      self.submitFamily.spouse.push({
                        id: -element.id,
                        name: element.name,
                        cnic: element.cnic,
                        dob: self.formatDBDate(element.dob, 'beneficiary'),
                        passport: element.passport,
                        relationship: element.relation,
                        gender: element.gender,
                        is_deleted: false
                      });
                    });
                    resp.data.data.filter(x => x.relation == 'child').forEach(element => {
                      self.submitFamily.child.push({
                        id: -element.id,
                        name: element.name,
                        cnic: element.cnic,
                        dob: self.formatDBDate(element.dob, 'beneficiary'),
                        passport: element.passport,
                        relationship: element.relation,
                        gender: element.gender,
                        is_deleted: false
                      });
                    });
                  }
                }).catch(function (resp) {
                  self.showLoader = false;
                  $toast.error('Error in family fetching', { position: 'top-right' });
                });
              }
            } else {
              self.showLoader = false;
              $toast.error(resp.data.message, { position: 'top-right' });
            }
          }).catch(function (resp) {
            self.showLoader = false;
            $toast.error('Error in family fetching', { position: 'top-right' });
          }));
        }

        Promise.all(promises).then(() => {
          self.showLoader = false;
          self.uploadInformationStep = self.uploadInformationStep - parseInt(steps);
        });
      },
      async getStepThreeChildData(field) {
        const self = this;
        if(field.child_id != 0 && self.stepThreeDynamicFields[field.field_name] != '') {
          self.showLoader = true;
          var formData = new FormData();
          formData.append('child_form_field_id', field.child_id);
          formData.append('parent_value_id', self.stepThreeDynamicFields[field.field_name]);
          await axios.post('get_child_form_field_values', formData).then(function (resp) {
            self.showLoader = false;
            if(resp.data.code == 200) {
              Object.entries(self.stepThreeSections).forEach(([key, section]) => {
                Object.entries(section.custom_fields).forEach(([key, secField]) => {
                  if(secField.id == field.child_id) {
                    let values = resp.data.data.form_field_values;
                    values.forEach(element => {
                      secField.default_values.push({
                        id: element.id,
                        text: element.field_value,
                        form_fields_id: element.form_fields_id
                      });
                    });
                    self.stepThreeDynamicFields[secField.field_name] = '';
                  }
                });
              });
            } else {
              self.showLoader = false;
              $toast.error(resp.data.message, { position: 'top-right' });
              return false;
            }
          }).catch(function (error) {
            self.showLoader = false;
            if(error.data.errors != undefined) {
              error.data.errors.forEach(element => {
                $toast.error(element.message, { position: 'top-right' });
              });
            } else {
              $toast.error(error.data.message, { position: 'top-right' });
            }
          });
        }
      },
      async validateTax (field_name) {
        const self = this;
        if(self.withHoldingTaxAmount > 0) {
          self.calculatedProductPrice = self.calculatedProductPrice - self.withHoldingTaxAmount;
        }
        self.showWithHoldingTaxData = false;
        self.withHoldingTaxPercentage = 0;
        self.withHoldingTaxAmount = 0;
        if(self.withHoldingTaxRequired && self.stepThreeDynamicFields[field_name].length == 15) {
          var formData = new FormData();
          formData.append('customer_quotation_id', self.quotationDetails.customer_quotation_id);
          formData.append('amount', self.calculatedProductPrice);
          formData.append('cnic', self.stepThreeDynamicFields[field_name]);

          await axios.post('customer/calculate_with_holding_tax', formData).then(function (resp) {
            self.showLoader = false;
            if(resp.data.code == 200) {
              self.showWithHoldingTaxData = true;
              self.withHoldingTaxPercentage = resp.data.data.with_holding_tax;
              self.withHoldingTaxAmount = resp.data.data.with_holding_tax_amount;
              self.calculatedProductPrice = resp.data.data.total_amount;
            } else {
              self.showLoader = false;
              $toast.error(resp.data.message, { position: 'top-right' });
              return false;
            }
          }).catch(function (error) {
            self.showLoader = false;
            if(error.data.errors != undefined) {
              error.data.errors.forEach(element => {
                $toast.error(element.message, { position: 'top-right' });
              });
            } else {
              $toast.error(error.data.message, { position: 'top-right' });
            }
          });
        }
      },
      showAddFamily() {
        const self = this;
        self.resetFamilyData();
        self.familyErrors = [];
        document.getElementById('AddFamilyModal').style.display = 'block';
        self.familyModalType = 'Add';
      },
      closeFamilyModal() {
        const self = this;
        self.resetFamilyData();
        self.familyErrors = [];
        document.getElementById('AddFamilyModal').style.display = 'none';
        self.familyModalType = '';
      },
      resetFamilyData() {
        const self = this;
        Object.entries(self.familyData).forEach(([key, value]) => {
          if(key == 'is_deleted') {
            self.familyData[key] = false;
          } else {
            self.familyData[key] = '';
          }
        });
      },
      addFamilyData() {
        const self = this;
        self.familyErrors = [];
        if(self.familyData.relationship == 'child') {
          if(self.family.no_of_child != null ) {
            if(self.family.no_of_child <= self.submitFamily.child.filter(x => x.is_deleted == false).length) {
              $toast.error('Max ' + self.family.no_of_child + ' Child Allowed', { position: 'top-right' });
              return false;
            }
          } else {
            $toast.error('Child Not Allowed!', { position: 'top-right' });
            return false;
          }
        }

        if(self.familyData.relationship == 'spouse') {
          if(self.family.no_of_spouse != null ) {
            if(self.family.no_of_spouse <= self.submitFamily.spouse.filter(x => x.is_deleted == false).length) {
              $toast.error('Max ' + self.family.no_of_spouse + ' Spouse Allowed', { position: 'top-right' });
              return false;
            }
          } else {
            $toast.error('Spouse Not Allowed!', { position: 'top-right' });
            return false;
          }
        }
        self.familyData.id = Math.floor(Math.random() * -1000);

        Object.entries(self.familyData).forEach(([key, value]) => {
          if (value == '' && key != 'is_deleted') {
            self.familyErrors.push({
              field: key,
              message: key.replace(/_/g, ' ') + ' required'
            })
          } else {
            if (key == 'dob' && self.familyData.relationship != '') {
              let selectedDate = moment(value, "YYYY-MM-DD");
              let maxDate = '';
              let minDate = '';
              if(self.familyData.relationship == 'spouse') {
                maxDate = moment(self.family.spouse_max_age, "YYYY-MM-DD");
                minDate = moment(self.family.spouse_min_age, "YYYY-MM-DD");
              }
              if(self.familyData.relationship == 'child') {
                maxDate = moment(self.family.child_max_age, "YYYY-MM-DD");
                minDate = moment(self.family.child_min_age, "YYYY-MM-DD");
              }

              if (selectedDate > minDate) {
                self.familyErrors.push({
                  field: key,
                  message: 'Date of Birth must be between ' + moment(maxDate).format('DD-MMM-YYYY') + ' and ' + moment(minDate).format('DD-MMM-YYYY')
                });
                return false;
              }
              if (selectedDate < maxDate) {
                self.familyErrors.push({
                  field: key,
                  message: 'Date of Birth must be between ' + moment(maxDate).format('DD-MMM-YYYY') + ' and ' + moment(minDate).format('DD-MMM-YYYY')
                });
                return false;
              }
            }
          }
        });

        if(self.familyErrors.length > 0) {
          return false;
        }

        if(self.familyData.relationship == 'spouse') {
          self.submitFamily.spouse.push({
            id: self.familyData.id,
            name: self.familyData.name,
            cnic: self.familyData.cnic,
            dob: self.familyData.dob,
            passport: self.familyData.passport,
            relationship: self.familyData.relationship,
            gender: self.familyData.gender,
            is_deleted: self.familyData.is_deleted
          });
        }
        if(self.familyData.relationship == 'child') {
          self.submitFamily.child.push({
            id: self.familyData.id,
            name: self.familyData.name,
            cnic: self.familyData.cnic,
            dob: self.familyData.dob,
            passport: self.familyData.passport,
            relationship: self.familyData.relationship,
            gender: self.familyData.gender,
            is_deleted: self.familyData.is_deleted
          });
        }

        self.closeFamilyModal();
      },
      showUpdateFamily(id, type) {
        const self = this;
        if(type == 'spouse') {
          var data = self.submitFamily.spouse.filter(x => x.id == id)[0];
        }
        if(type == 'child') {
          var data = self.submitFamily.child.filter(x => x.id == id)[0];
        }

        self.familyData = {...data};
        document.getElementById('AddFamilyModal').style.display = 'block';
        self.familyModalType = 'Update';
      },
      updateFamilyData() {
        const self = this;
        self.familyErrors = [];
        let checkSpouse = self.submitFamily.spouse.findIndex(x => x.id == self.familyData.id);
        let checkChild = self.submitFamily.child.findIndex(x => x.id == self.familyData.id);
        let oldRelation = '';
        let newRelation = '';

        if(checkSpouse != -1) {
          if(self.familyData.relationship == 'child') {
            if(self.family.no_of_child != null ) {
              if (self.family.no_of_child <= self.submitFamily.child.filter(x => x.is_deleted == false).length) {
                $toast.error('Max ' + self.family.no_of_child + ' Child Allowed', {position: 'top-right'});
                return false;
              }
              oldRelation = 'spouse';
              newRelation = 'spouse';
              if (self.familyData.relationship == 'child') {
                newRelation = 'child';
              }
            } else {
              $toast.error('Child Not Allowed!', { position: 'top-right' });
              return false;
            }
          }
        }

        if(checkChild != -1) {
          if(self.familyData.relationship == 'spouse') {
            if(self.family.no_of_spouse != null ) {
              if(self.family.no_of_spouse <= self.submitFamily.spouse.filter(x => x.is_deleted == false).length) {
                $toast.error('Max ' + self.family.no_of_child + ' Spouse Allowed', { position: 'top-right' });
                return false;
              }
              oldRelation = 'child';
              oldRelation = 'child';
              if(self.familyData.relationship == 'spouse') {
                newRelation = 'spouse';
              }
            } else {
              $toast.error('Spouse Not Allowed!', { position: 'top-right' });
              return false;
            }
          }
        }

        Object.entries(self.familyData).forEach(([key, value]) => {
          if (value == '' && key != 'is_deleted') {
            self.familyErrors.push({
              field: key,
              message: key.replace(/_/g, ' ') + ' required'
            })
          } else {
            if (key == 'dob') {
              let selectedDate = moment(value, "YYYY-MM-DD");
              let maxDate = '';
              let minDate = '';
              if(self.familyData.relationship == 'spouse') {
                maxDate = moment(self.family.spouse_max_age, "YYYY-MM-DD");
                minDate = moment(self.family.spouse_min_age, "YYYY-MM-DD");
              }
              if(self.familyData.relationship == 'child') {
                maxDate = moment(self.family.child_max_age, "YYYY-MM-DD");
                minDate = moment(self.family.child_min_age, "YYYY-MM-DD");
              }

              if (selectedDate > minDate) {
                self.familyErrors.push({
                  field: key,
                  message: 'Date of Birth must be between ' + moment(maxDate).format('DD-MMM-YYYY') + ' and ' + moment(minDate).format('DD-MMM-YYYY')
                });
                return false;
              }
              if (selectedDate < maxDate) {
                self.familyErrors.push({
                  field: key,
                  message: 'Date of Birth must be between ' + moment(maxDate).format('DD-MMM-YYYY') + ' and ' + moment(minDate).format('DD-MMM-YYYY')
                });
                return false;
              }
            }
          }
        });

        if(self.familyErrors.length > 0) {
          return false;
        }

        if(self.familyData.relationship == 'spouse') {
          if(oldRelation != newRelation) {
            let index = self.submitFamily.child.findIndex(x => x.id == self.familyData.id);
            self.submitFamily.child.splice(index, 1);
            self.submitFamily.spouse.push({
              id: self.familyData.id,
              name: self.familyData.name,
              cnic: self.familyData.cnic,
              dob: self.familyData.dob,
              passport: self.familyData.passport,
              relationship: self.familyData.relationship,
              gender: self.familyData.gender,
              is_deleted: self.familyData.is_deleted
            });
          } else {
            let index = self.submitFamily.spouse.findIndex(x => x.id == self.familyData.id);
            self.submitFamily.spouse[index]['id'] = self.familyData.id;
            self.submitFamily.spouse[index]['name'] = self.familyData.name;
            self.submitFamily.spouse[index]['cnic'] = self.familyData.cnic;
            self.submitFamily.spouse[index]['dob'] = self.familyData.dob;
            self.submitFamily.spouse[index]['passport'] = self.familyData.passport;
            self.submitFamily.spouse[index]['relationship'] = self.familyData.relationship;
            self.submitFamily.spouse[index]['gender'] = self.familyData.gender;
            self.submitFamily.spouse[index]['is_deleted'] = self.familyData.is_deleted;
          }
        }

        if(self.familyData.relationship == 'child') {
          if(oldRelation != newRelation) {
            let index = self.submitFamily.spouse.findIndex(x => x.id == self.familyData.id);
            self.submitFamily.spouse.splice(index, 1);
            self.submitFamily.child.push({
              id: self.familyData.id,
              name: self.familyData.name,
              cnic: self.familyData.cnic,
              dob: self.familyData.dob,
              passport: self.familyData.passport,
              relationship: self.familyData.relationship,
              gender: self.familyData.gender,
              is_deleted: self.familyData.is_deleted
            });
          } else {
            let index = self.submitFamily.child.findIndex(x => x.id == self.familyData.id);
            self.submitFamily.child[index]['id'] = self.familyData.id;
            self.submitFamily.child[index]['name'] = self.familyData.name;
            self.submitFamily.child[index]['cnic'] = self.familyData.cnic;
            self.submitFamily.child[index]['dob'] = self.familyData.dob;
            self.submitFamily.child[index]['passport'] = self.familyData.passport;
            self.submitFamily.child[index]['relationship'] = self.familyData.relationship;
            self.submitFamily.child[index]['gender'] = self.familyData.gender;
            self.submitFamily.child[index]['is_deleted'] = self.familyData.is_deleted;
          }
        }

        self.closeFamilyModal();
      },
      removeFamily(id, type) {
        const self = this;
        if(type == 'spouse') {
          let index = self.submitFamily.spouse.findIndex(x => x.id == id)
          self.submitFamily.spouse[index]['is_deleted'] = true;
        }
        if(type == 'child') {
          let index = self.submitFamily.child.findIndex(x => x.id == id)
          self.submitFamily.child[index]['is_deleted'] = true;
        }
      },
      showAddBeneficiary() {
        const self = this;
        self.resetBeneficiaryData();
        self.beneficiaryErrors = [];
        document.getElementById('AddBeneficiaryModal').style.display = 'block';
        self.beneficiaryModalType = 'Add';
      },
      validateBeneficiaryMobileNo(event) {
        const self = this;
        let val = event.target.value;

        if(val != "") {
          const usingSplit = val.split('');
          let issue = false;

          let i = 0;
          for (i; i < 4; i++) {
            if(usingSplit[i] === '0') {
              issue = true;
              break;
            }
          }

          if (issue) {
            self.beneficiaryData['mobile_no'] = '+92';
          }
        }
      },
      verifyBeneficiaryEmail(event) {
        const self = this;

        self.beneficiaryErrors = [];
        let email = event.target.value;
        if(email == '') {
          return false;
        }

        const re = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
        let result = re.test(String(email).toLowerCase());
        if(!result) {
          self.beneficiaryErrors.push({
            field: 'email',
            message: 'Invalid Email'
          });
        }
      },
      addBeneficiaryData() {
        const self = this;
        self.beneficiaryErrors = [];
        if(self.beneficiary.no_of_beneficiary <= self.submitBeneficiary.filter(x => x.is_deleted == false).length) {
          $toast.error('Max ' + self.beneficiary.no_of_beneficiary + ' Beneficiary Allowed', { position: 'top-right' });
          return false;
        }

        self.beneficiaryData.id = Math.floor(Math.random() * -1000);
        Object.entries(self.beneficiaryData).forEach(([key, value]) => {
          if(key != 'is_deleted') {
            let field = self.beneficiary.fields.filter(x => x.beneficiary_detail_field == key)[0];
            if (field != undefined) {
              if (value == '' && field.required) {
                self.beneficiaryErrors.push({
                  field: key,
                  message: key.replace(/_/g, ' ') + ' required'
                })
              } else {
                let todayDate = moment().startOf('day');
                if (key == 'dob') {
                  let selectedDate = moment(value, "YYYY-MM-DD");
                  let maxDate = moment(self.beneficiary.beneficiary_max_age, "YYYY-MM-DD");
                  let minDate = moment(self.beneficiary.beneficiary_min_age, "YYYY-MM-DD");

                  if (selectedDate > minDate) {
                    self.beneficiaryErrors.push({
                      field: key,
                      message: 'Date of Birth must be between ' + moment(maxDate).format('DD-MMM-YYYY') + ' and ' + moment(minDate).format('DD-MMM-YYYY')
                    });
                    return false;
                  }
                  if (selectedDate < maxDate) {
                    self.beneficiaryErrors.push({
                      field: key,
                      message: 'Date of Birth must be between ' + moment(maxDate).format('DD-MMM-YYYY') + ' and ' + moment(minDate).format('DD-MMM-YYYY')
                    });
                    return false;
                  }
                } else if (key == 'cnic_issue_date') {
                  let selectedDate = moment(value, "YYYY-MM-DD");
                  if (selectedDate > todayDate) {
                    self.beneficiaryErrors.push({
                      field: key,
                      message: 'Cnic issue date must be less than or equal to ' + moment(todayDate).format('DD-MMM-YYYY')
                    });
                    return false;
                  }
                } else if (key == 'cnic_expiry_date') {
                  let selectedDate = moment(value, "YYYY-MM-DD");
                  if (selectedDate < todayDate) {
                    self.beneficiaryErrors.push({
                      field: key,
                      message: 'Cnic expiry date must be greater than or equal to ' + moment(todayDate).format('DD-MMM-YYYY')
                    });
                    return false;
                  } else if (key === 'first_name' || (key === 'middle_name' && value != '') || key === 'last_name') {
                    const re = /^[A-Za-z ]+$/;
                    let result = re.test(value);
                    if (!result) {
                      self.beneficiaryErrors.push({
                        field: key,
                        message: 'Only characters allowed'
                      });
                    }
                  }
                }
              }
            }
          }
        });

        if(self.beneficiaryData.email != undefined && self.beneficiaryData.email != '') {
          const re = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
          let result = re.test(String(self.beneficiaryData.email).toLowerCase());
          if (!result) {
            self.beneficiaryErrors.push({
              field: 'email',
              message: 'Invalid Email'
            });
          }
        }

        if(self.stepThreeDynamicFields.first_name != undefined && self.stepThreeDynamicFields.last_name != undefined
          && self.beneficiaryData.first_name != undefined && self.beneficiaryData.last_name != undefined
          && self.beneficiaryData.first_name != '' && self.beneficiaryData.last_name != '') {
          if(self.beneficiaryData.first_name.toLowerCase() == self.stepThreeDynamicFields.first_name.toLowerCase() &&
            self.beneficiaryData.last_name.toLowerCase() == self.stepThreeDynamicFields.last_name.toLowerCase()) {
            self.beneficiaryErrors.push({
              field: 'first_name',
              message: 'You cannot use Policy Holder Name for Beneficiary'
            });
          }
        }

        if(self.beneficiaryData.cnic == self.stepThreeDynamicFields.cnic_number && self.stepThreeDynamicFields.cnic_number != undefined
          && self.beneficiaryData.cnic != undefined && self.stepThreeDynamicFields.cnic_number != '' && self.beneficiaryData.cnic != '') {
          self.beneficiaryErrors.push({
            field: 'cnic',
            message: 'You cannot use Policy Holder CNIC for Beneficiary'
          });
        }

        if(self.stepThreeDynamicFields.email_id != undefined && self.beneficiaryData.email != undefined && self.stepThreeDynamicFields.email_id != '' && self.beneficiaryData.email != '') {
          if(self.beneficiaryData.email.toLowerCase() == self.stepThreeDynamicFields.email_id.toLowerCase()) {
            self.beneficiaryErrors.push({
              field: 'email',
              message: 'You cannot use Policy Holder Email for Beneficiary'
            });
          }
        }

        if(self.beneficiaryData.first_name != undefined && self.beneficiaryData.last_name != undefined && self.beneficiaryData.first_name != '' && self.beneficiaryData.last_name != '') {
          let checkBeneficiaryName = self.submitBeneficiary.findIndex(x => x.id != self.beneficiaryData.id && x.is_deleted == false && x.first_name.toLowerCase() == self.beneficiaryData.first_name.toLowerCase() && x.last_name.toLowerCase() == self.beneficiaryData.last_name.toLowerCase())
          if (checkBeneficiaryName !== -1) {
            self.beneficiaryErrors.push({
              field: 'first_name',
              message: 'Beneficiary Name is already used by another Beneficiary'
            });
          }
        }

        if(self.beneficiaryData.cnic != undefined && self.beneficiaryData.cnic != '') {
          let checkBeneficiaryCnic = self.submitBeneficiary.findIndex(x => x.id != self.beneficiaryData.id && x.is_deleted == false && x.cnic == self.beneficiaryData.cnic)
          if (checkBeneficiaryCnic !== -1) {
            self.beneficiaryErrors.push({
              field: 'cnic',
              message: 'Beneficiary CNIC is already used by another Beneficiary'
            });
          }
        }

        if(self.beneficiaryData.email != undefined && self.beneficiaryData.email != '') {
          let checkBeneficiaryEmail = self.submitBeneficiary.findIndex(x => x.id != self.beneficiaryData.id && x.is_deleted == false && x.email.toLowerCase() == self.beneficiaryData.email.toLowerCase())
          if (checkBeneficiaryEmail !== -1) {
            self.beneficiaryErrors.push({
              field: 'email',
              message: 'Beneficiary Email is already used by another Beneficiary'
            });
          }
        }

        if(self.beneficiaryErrors.length > 0) {
          return false;
        }

        self.submitBeneficiary.push({
          id: self.beneficiaryData.id,
          first_name: self.beneficiaryData.first_name != undefined ? self.beneficiaryData.first_name : '',
          last_name: self.beneficiaryData.last_name != undefined ? self.beneficiaryData.last_name : '',
          gender: self.beneficiaryData.gender != undefined ? self.beneficiaryData.gender : '',
          cnic: self.beneficiaryData.cnic != undefined ? self.beneficiaryData.cnic : '',
          cnic_issue_date: self.beneficiaryData.cnic_issue_date != undefined ? self.beneficiaryData.cnic_issue_date : '',
          cnic_expiry_date: self.beneficiaryData.cnic_expiry_date != undefined ? self.beneficiaryData.cnic_expiry_date : '',
          dob: self.beneficiaryData.dob != undefined ? self.beneficiaryData.dob : '',
          mobile_no: self.beneficiaryData.mobile_no != undefined ? self.beneficiaryData.mobile_no : '',
          email: self.beneficiaryData.email != undefined ? self.beneficiaryData.email : '',
          address: self.beneficiaryData.address != undefined ? self.beneficiaryData.address : '',
          relationship: self.beneficiaryData.relationship != undefined ? self.beneficiaryData.relationship : '',
          is_deleted: self.beneficiaryData.is_deleted
        });

        self.closeBeneficiaryModal();
      },
      showUpdateBeneficiary(id) {
        const self = this;
        var data = self.submitBeneficiary.filter(x => x.id == id)[0];

        self.beneficiaryData = {...data};
        Object.entries(self.beneficiaryData).forEach(([key, value]) => {
          if(value == undefined) {
            self.beneficiaryData[key] = '';
          }
        });
        document.getElementById('AddBeneficiaryModal').style.display = 'block';
        self.beneficiaryModalType = 'Update';
      },
      updateBeneficiaryData() {
        const self = this;
        self.beneficiaryErrors = [];
        // if(self.beneficiary.no_of_beneficiary <= self.submitBeneficiary.filter(x => x.is_deleted == false).length) {
        //   $toast.error('Max ' + self.beneficiary.no_of_beneficiary + ' Beneficiary Allowed', { position: 'top-right' });
        //   return false;
        // }

        Object.entries(self.beneficiaryData).forEach(([key, value]) => {
          if(key != 'is_deleted' && key != 'id' ) {
            let field = self.beneficiary.fields.filter(x => x.beneficiary_detail_field == key)[0]
            if (field != undefined) {
              if (value == '' && field.required) {
                self.beneficiaryErrors.push({
                  field: key,
                  message: key.replace(/_/g, ' ') + ' required'
                })
              } else {
                let todayDate = moment().startOf('day');
                if (key == 'dob') {
                  let selectedDate = moment(value, "YYYY-MM-DD");
                  let maxDate = moment(self.beneficiary.beneficiary_max_age, "YYYY-MM-DD");
                  let minDate = moment(self.beneficiary.beneficiary_min_age, "YYYY-MM-DD");

                  if (selectedDate > minDate) {
                    self.beneficiaryErrors.push({
                      field: key,
                      message: 'Date of Birth must be between ' + moment(maxDate).format('DD-MMM-YYYY') + ' and ' + moment(minDate).format('DD-MMM-YYYY')
                    });
                    return false;
                  }
                  if (selectedDate < maxDate) {
                    self.beneficiaryErrors.push({
                      field: key,
                      message: 'Date of Birth must be between ' + moment(maxDate).format('DD-MMM-YYYY') + ' and ' + moment(minDate).format('DD-MMM-YYYY')
                    });
                    return false;
                  }
                } else if (key == 'cnic_issue_date') {
                  let selectedDate = moment(value, "YYYY-MM-DD");
                  if (selectedDate > todayDate) {
                    self.beneficiaryErrors.push({
                      field: key,
                      message: 'Cnic issue date must be less than or equal to ' + moment(todayDate).format('DD-MMM-YYYY')
                    });
                    return false;
                  }
                } else if (key == 'cnic_expiry_date') {
                  let selectedDate = moment(value, "YYYY-MM-DD");
                  if (selectedDate < todayDate) {
                    self.beneficiaryErrors.push({
                      field: key,
                      message: 'Cnic issue date must be greater than or equal to ' + moment(todayDate).format('DD-MMM-YYYY')
                    });
                    return false;
                  } else if (key === 'first_name' || (key === 'middle_name' && value != '') || key === 'last_name') {
                    const re = /^[A-Za-z ]+$/;
                    let result = re.test(value);
                    if (!result) {
                      self.beneficiaryErrors.push({
                        field: key,
                        message: 'Only characters allowed'
                      });
                    }
                  }
                }
              }
            }
          }
        });

        if(self.beneficiaryData.email != undefined && self.beneficiaryData.email != '') {
          const re = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
          let result = re.test(String(self.beneficiaryData.email).toLowerCase());
          if (!result) {
            self.beneficiaryErrors.push({
              field: 'email',
              message: 'Invalid Email'
            });
          }
        }

        if(self.stepThreeDynamicFields.first_name != undefined && self.stepThreeDynamicFields.last_name != undefined
          && self.beneficiaryData.first_name != undefined && self.beneficiaryData.last_name != undefined
          && self.beneficiaryData.first_name != '' && self.beneficiaryData.last_name != '') {
          if(self.beneficiaryData.first_name.toLowerCase() == self.stepThreeDynamicFields.first_name.toLowerCase() &&
            self.beneficiaryData.last_name.toLowerCase() == self.stepThreeDynamicFields.last_name.toLowerCase()) {
            self.beneficiaryErrors.push({
              field: 'first_name',
              message: 'You cannot use Policy Holder Name for Beneficiary'
            });
          }
        }

        if(self.beneficiaryData.cnic == self.stepThreeDynamicFields.cnic_number && self.stepThreeDynamicFields.cnic_number != undefined
          && self.beneficiaryData.cnic != undefined && self.stepThreeDynamicFields.cnic_number != '' && self.beneficiaryData.cnic != '') {
          self.beneficiaryErrors.push({
            field: 'cnic',
            message: 'You cannot use Policy Holder CNIC for Beneficiary'
          });
        }

        if(self.stepThreeDynamicFields.email_id != undefined && self.beneficiaryData.email != undefined && self.stepThreeDynamicFields.email_id != '' && self.beneficiaryData.email != '') {
          if(self.beneficiaryData.email.toLowerCase() == self.stepThreeDynamicFields.email_id.toLowerCase()) {
            self.beneficiaryErrors.push({
              field: 'email',
              message: 'You cannot use Policy Holder Email for Beneficiary'
            });
          }
        }

        if(self.beneficiaryData.first_name != undefined && self.beneficiaryData.last_name != undefined && self.beneficiaryData.first_name != '' && self.beneficiaryData.last_name != '') {
          let checkBeneficiaryName = self.submitBeneficiary.findIndex(x => x.id != self.beneficiaryData.id && x.is_deleted == false && x.first_name.toLowerCase() == self.beneficiaryData.first_name.toLowerCase() && x.last_name.toLowerCase() == self.beneficiaryData.last_name.toLowerCase())
          if (checkBeneficiaryName !== -1) {
            self.beneficiaryErrors.push({
              field: 'first_name',
              message: 'Beneficiary Name is already used by another Beneficiary'
            });
          }
        }

        if(self.beneficiaryData.cnic != undefined && self.beneficiaryData.cnic != '') {
          let checkBeneficiaryCnic = self.submitBeneficiary.findIndex(x => x.id != self.beneficiaryData.id && x.is_deleted == false && x.cnic == self.beneficiaryData.cnic)
          if (checkBeneficiaryCnic !== -1) {
            self.beneficiaryErrors.push({
              field: 'cnic',
              message: 'Beneficiary CNIC is already used by another Beneficiary'
            });
          }
        }

        if(self.beneficiaryData.email != undefined && self.beneficiaryData.email != '') {
          let checkBeneficiaryEmail = self.submitBeneficiary.findIndex(x => x.id != self.beneficiaryData.id && x.is_deleted == false && x.email.toLowerCase() == self.beneficiaryData.email.toLowerCase())
          if (checkBeneficiaryEmail !== -1) {
            self.beneficiaryErrors.push({
              field: 'email',
              message: 'Beneficiary Email is already used by another Beneficiary'
            });
          }
        }

        if(self.beneficiaryErrors.length > 0) {
          return false;
        }

        let index = self.submitBeneficiary.findIndex(x => x.id == self.beneficiaryData.id);
        self.submitBeneficiary[index]['first_name'] = self.beneficiaryData.first_name != undefined ? self.beneficiaryData.first_name : '';
        self.submitBeneficiary[index]['last_name'] = self.beneficiaryData.last_name != undefined ? self.beneficiaryData.last_name : '';
        self.submitBeneficiary[index]['gender'] = self.beneficiaryData.gender != undefined ? self.beneficiaryData.gender : '';
        self.submitBeneficiary[index]['cnic'] = self.beneficiaryData.cnic != undefined ? self.beneficiaryData.cnic : '';
        self.submitBeneficiary[index]['cnic_issue_date'] = self.beneficiaryData.cnic_issue_date != undefined ? self.beneficiaryData.cnic_issue_date : '';
        self.submitBeneficiary[index]['cnic_expiry_date'] = self.beneficiaryData.cnic_expiry_date != undefined ? self.beneficiaryData.cnic_expiry_date : '';
        self.submitBeneficiary[index]['dob'] = self.beneficiaryData.dob != undefined ? self.beneficiaryData.dob : '';
        self.submitBeneficiary[index]['mobile_no'] = self.beneficiaryData.mobile_no != undefined ? self.beneficiaryData.mobile_no : '';
        self.submitBeneficiary[index]['email'] = self.beneficiaryData.email != undefined ? self.beneficiaryData.email : '';
        self.submitBeneficiary[index]['address'] = self.beneficiaryData.address != undefined ? self.beneficiaryData.address : '';
        self.submitBeneficiary[index]['relationship'] = self.beneficiaryData.relationship != undefined ? self.beneficiaryData.relationship : '';
        self.submitBeneficiary[index]['is_deleted'] = self.beneficiaryData.is_deleted;

        self.closeBeneficiaryModal();
      },
      removeBeneficiary(id) {
        const self = this;
        let index = self.submitBeneficiary.findIndex(x => x.id == id)
        self.submitBeneficiary[index]['is_deleted'] = true;
      },
      closeBeneficiaryModal() {
        const self = this;
        self.resetBeneficiaryData();
        self.beneficiaryErrors = [];
        document.getElementById('AddBeneficiaryModal').style.display = 'none';
        self.beneficiaryModalType = '';
      },
      resetBeneficiaryData() {
        const self = this;
        Object.entries(self.beneficiaryData).forEach(([key, value]) => {
          if(key == 'is_deleted') {
            self.beneficiaryData[key] = false;
          } else {
            self.beneficiaryData[key] = '';
          }
        });
      },
      verifyStepThreeNumbers(event, field_name) {
        const self = this;
        self.stepThreeErrors = [];
        let val = event.target.value;
        if(val == '') {
          return false;
        }

        const re = /^\d+$/; // for float use /^\d+\.\d+$/
        let result = re.test(String(val));
        if(!result) {
          self.stepThreeErrors.push({
            field: field_name,
            message: 'Only numbers are allowed'
          });
        }
      },
      validateStepThreeMobileNo(event, field_name) {
        const self = this;
        let val = event.target.value;

        if(val != "") {
          const usingSplit = val.split('');
          let issue = false;

          let i = 0;
          for (i; i < 4; i++) {
            if(usingSplit[i] === '0') {
              issue = true;
              break;
            }
          }

          if (issue) {
            self.stepThreeDynamicFields[field_name] = '+92';
          }
        }
      },
      verifyStepThreeEmail(event, field_name) {
        const self = this;

        self.stepThreeErrors = [];
        let email = event.target.value;
        if(email == '') {
          return false;
        }

        const re = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
        let result = re.test(String(email).toLowerCase());
        if(!result) {
          self.stepThreeErrors.push({
            field: field_name,
            message: 'Invalid Email'
          });
        }
      },
      async continueStageThreeFrom() {
        const self = this;
        self.stepThreeErrors = [];
        var errorSection = '';
        Object.entries(self.stepThreeDynamicFields).forEach(([key, value]) => {
          if (value == '') {
            Object.entries(self.stepThreeSections).forEach(([key1, section]) => {
              Object.entries(section.custom_fields).forEach(([key2, secField]) => {
                if(secField.field_name == key) {
                  if(secField.required) {
                    self.stepThreeErrors.push({
                      field: key,
                      message: key.replace(/_/g,' ') + ' required'
                    });
                    if(errorSection == '') {
                      errorSection = key1;
                    }
                  }
                }
              })
            })
          } else {
            Object.entries(self.stepThreeSections).forEach(([key1, section]) => {
              Object.entries(section.custom_fields).forEach(([key2, secField]) => {
                if(secField.field_name == key) {
                  if(secField.type == 'date') {
                    let selectedDate = moment(value).startOf('day');
                    if (secField.max_date && secField.min_date) {
                      let maxDate = moment(secField.max_date, "YYYY-MM-DD");
                      let minDate = moment(secField.min_date, "YYYY-MM-DD");
                      if (selectedDate < minDate) {
                        self.stepThreeErrors.push({
                          field: key,
                          message: key.replace(/_/g, ' ') + ' must be between ' + moment(minDate).format('DD-MMM-YYYY') + ' and ' + moment(maxDate).format('DD-MMM-YYYY')
                        });
                        if(errorSection == '') {
                          errorSection = key1;
                        }
                        return false;
                      }
                      if (selectedDate > maxDate) {
                        self.stepThreeErrors.push({
                          field: key,
                          message: key.replace(/_/g, ' ') + ' must be between ' + moment(minDate).format('DD-MMM-YYYY') + ' and ' + moment(maxDate).format('DD-MMM-YYYY')
                        });
                        if(errorSection == '') {
                          errorSection = key1;
                        }
                        return false;
                      }
                    }

                    if (secField.max_date) {
                      let maxDate = moment(secField.max_date, "YYYY-MM-DD");
                      if (selectedDate > maxDate) {
                        self.stepThreeErrors.push({
                          field: key,
                          message: key.replace(/_/g, ' ') + ' must be less than or equal to ' + moment(maxDate).format('DD-MMM-YYYY')
                        });
                        if(errorSection == '') {
                          errorSection = key1;
                        }
                        return false;
                      }
                    }

                    if (secField.min_date) {
                      let minDate = moment(secField.min_date, "YYYY-MM-DD");
                      if (selectedDate < minDate) {
                        self.stepThreeErrors.push({
                          field: key,
                          message: key.replace(/_/g, ' ') + ' must be greater than or equal to  ' + moment(minDate).format('DD-MMM-YYYY')
                        });
                        if(errorSection == '') {
                          errorSection = key1;
                        }
                        return false;
                      }
                    }
                  }

                  if(secField.inputType == 'email') {
                    const e_re = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
                    let e_result = e_re.test(value);
                    if(!e_result) {
                      self.stepThreeErrors.push({
                        field: key,
                        message: 'Invalid Email'
                      });
                      if(errorSection == '') {
                        errorSection = key1;
                      }
                    }
                  }

                  if(secField.inputType == 'mobile') {
                    if(value.length < 13) {
                      self.stepThreeErrors.push({
                        field: key,
                        message: 'Incorrect Mobile Number'
                      });
                      if(errorSection == '') {
                        errorSection = key1;
                      }
                    }
                  }

                  if(secField.inputType == 'number') {
                    const re = /^\d+$/; // for float use /^\d+\.\d+$/
                    let result = re.test(value);
                    if(!result) {
                      self.stepThreeErrors.push({
                        field: key,
                        message: 'Only numbers allowed'
                      });
                      if(errorSection == '') {
                        errorSection = key1;
                      }
                    }

                    if((secField.min_rule != null && secField.max_rule != null) && (value < secField.min_rule || value > secField.max_rule)) {
                      self.stepThreeErrors.push({
                        field: key,
                        message: secField.label + ' must be between ' + secField.min_rule + ' and ' + secField.max_rule
                      });
                      if(errorSection == '') {
                        errorSection = key1;
                      }
                    }

                    if(secField.min_rule != null && value < secField.min_rule) {
                      self.stepThreeErrors.push({
                        field: key,
                        message: secField.label + ' must be greater than or equal to ' + secField.min_rule
                      });
                      if(errorSection == '') {
                        errorSection = key1;
                      }
                    }

                    if(secField.max_rule != null && value > secField.max_rule) {
                      self.stepThreeErrors.push({
                        field: key,
                        message: secField.label + ' must be less than or equal to ' + secField.max_rule
                      });
                      if(errorSection == '') {
                        errorSection = key1;
                      }
                    }
                  }

                  if(secField.inputType == 'cnic') {
                    if(value.length != 15) {
                      self.stepThreeErrors.push({
                        field: key,
                        message: 'Invalid Cnic'
                      });
                      if(errorSection == '') {
                        errorSection = key1;
                      }
                    }
                  }

                  if (key === 'first_name'|| (key === 'middle_name' && value != '') || key === 'last_name') {
                    const re = /^[A-Za-z ]+$/;
                    let result = re.test(value);
                    if(!result) {
                      self.stepThreeErrors.push({
                        field: key,
                        message: 'Only characters allowed'
                      });
                      if(errorSection == '') {
                        errorSection = key1;
                      }
                    }

                    if (value != null && value.length > 15) {
                      self.stepThreeErrors.push({
                        field: key,
                        message: 'Maximum 15 characters allowed'
                      });
                      if(errorSection == '') {
                        errorSection = key1;
                      }
                    }
                  }
                }
              })
            })
          }
        });

        if (self.stepThreeErrors.length > 0) {
          $toast.error('Please Review Fields Again!', { position: 'top-right' });
          document.getElementById("nav-"+errorSection+"-tab").click();
          return false;
        }

        let submitFamilyBeneficiary = false;
        if(self.showFamily) {
          //validate family
          let hasSpouse = self.family.has_spouse;
          let hasChild = self.family.has_child;

          if(hasSpouse && self.submitFamily.spouse.filter(x => x.is_deleted == false).length < self.family.min_no_of_spouse) {
            $toast.error('At-least ' + self.family.min_no_of_spouse +' spouse required', { position: 'top-right' });
            document.getElementById("nav-family-tab").click();
            return false;
          }

          if(hasChild && self.submitFamily.child.filter(x => x.is_deleted == false).length < self.family.min_no_of_child) {
            $toast.error('At-least ' + self.family.min_no_of_child +' child required', { position: 'top-right' });
            document.getElementById("nav-family-tab").click();
            return false;
          }

          submitFamilyBeneficiary = true;
        }

        if(self.showBeneficiary) {
          //validate beneficiary
          if(self.submitBeneficiary.filter(x => x.is_deleted == false).length < 1) {
            $toast.error('At-least one beneficiary required', { position: 'top-right' });
            document.getElementById("nav-beneficiary-tab").click();
            return false;
          }

          submitFamilyBeneficiary = true;
        }

        let stepThreeDynamicFieldsFinal = {};
        Object.entries(self.stepThreeDynamicFields).forEach(([key, value]) => {
          Object.entries(self.stepThreeSections).forEach(([key1, section]) => {
            Object.entries(section.custom_fields).forEach(([key2, secField]) => {
              if (secField.field_name == key) {
                if(secField.type.toLowerCase() == 'date') {
                  stepThreeDynamicFieldsFinal[key] = moment(value).format("YYYY-MM-DD");
                } else {
                  stepThreeDynamicFieldsFinal[key] = value;
                }
              }
            })
          });
        });

        var formData = new FormData();
        formData.append('customer_quotation_id', self.quotationDetails.customer_quotation_id);

        Object.entries(stepThreeDynamicFieldsFinal).forEach(([key, value]) => {
          formData.append(key, value);
        });

        self.showLoader = true;
        await axios.post('non_rating_validation', formData).then(function (resp) {
          if(resp.data.code == 200) {
            if(resp.data.status == false) {
              $toast.error(resp.data.message, { position: 'top-right' });
              self.showLoader = false;
            } else {
              if(submitFamilyBeneficiary) {
                const promises = [];
                let allBeneficiaries = [];
                let deleted_beneficiaries_ids = [];

                if(self.showBeneficiary && self.submitBeneficiary.length > 0) {
                  self.submitBeneficiary.forEach(element => {
                    if(element.is_deleted == false) {
                      if(element.id < 0) {
                        allBeneficiaries.push({
                          first_name: element.first_name,
                          last_name: element.last_name,
                          gender: element.gender,
                          mobile_no: element.mobile_no,
                          cnic: element.cnic,
                          cnic_issue_date: element.cnic_issue_date != undefined && element.cnic_issue_date != '' ? moment(element.cnic_issue_date).format("YYYY-MM-DD") : '',
                          cnic_expiry_date: element.cnic_expiry_date != undefined && element.cnic_expiry_date != '' ? moment(element.cnic_expiry_date).format("YYYY-MM-DD") : '',
                          relation_id: element.relationship,
                          email: element.email,
                          dob: element.dob != undefined && element.dob != '' ? moment(element.dob).format("YYYY-MM-DD") : '',
                          address: element.address,
                        })
                      } else {
                        allBeneficiaries.push({
                          id: element.id,
                          first_name: element.first_name,
                          last_name: element.last_name,
                          gender: element.gender,
                          mobile_no: element.mobile_no,
                          cnic: element.cnic,
                          cnic_issue_date: element.cnic_issue_date != undefined && element.cnic_issue_date != '' ? moment(element.cnic_issue_date).format("YYYY-MM-DD") : '',
                          cnic_expiry_date: element.cnic_expiry_date != undefined && element.cnic_expiry_date != '' ? moment(element.cnic_expiry_date).format("YYYY-MM-DD") : '',
                          allow_notifications: element.allow_notifications ? 1 : 0,
                          relation_id: element.relationship,
                          email: element.email,
                          dob: element.dob != undefined && element.dob != '' ? moment(element.dob).format("YYYY-MM-DD") : '',
                          address: element.address,
                        })
                      }
                    } else {
                      if(element.id > 0) {
                        deleted_beneficiaries_ids.push(element.id);
                      }
                    }
                  });

                  var formData = new FormData();
                  formData.append('policy_id', self.quotationDetails.customer_quotation_id);
                  formData.append('beneficiaries', JSON.stringify(allBeneficiaries));
                  deleted_beneficiaries_ids.forEach(element => {
                    formData.append('deleted_beneficiaries_ids[]', element);
                  });

                  self.showLoader = true;
                  promises.push(axios.post('customer/store_beneficiaries', formData).then(function (resp) {
                    if(resp.data.code == 200) {
                    } else {
                      self.showLoader = false;
                      $toast.error(resp.data.message, { position: 'top-right' });
                      return Promise.reject(resp);
                    }
                  }).catch(function (error) {
                    self.showLoader = false;
                    if(error.data.errors != undefined) {
                      error.data.errors.forEach(element => {
                        $toast.error(element.message, { position: 'top-right' });
                      });
                    } else {
                      $toast.error(error.data.message, { position: 'top-right' });
                    }
                    return Promise.reject(error);
                  }));
                }

                if(self.showFamily && (self.submitFamily.spouse.length > 0 || self.submitFamily.child.length > 0)) {
                  let allSpouse = [];
                  let allChild = [];
                  let deleted_family_member_ids = [];

                  self.submitFamily.spouse.forEach(element => {
                    if(element.is_deleted == false) {
                      if(element.id < 0) {
                        allSpouse.push({
                          name: element.name,
                          cnic: element.cnic,
                          passport: element.passport,
                          gender: element.gender,
                          dob: element.dob != undefined && element.dob != '' ? moment(element.dob).format("YYYY-MM-DD") : '',
                          relationship: element.relationship
                        })
                      } else {
                        allSpouse.push({
                          id: element.id,
                          name: element.name,
                          cnic: element.cnic,
                          passport: element.passport,
                          gender: element.gender,
                          dob: element.dob != undefined && element.dob != '' ? moment(element.dob).format("YYYY-MM-DD") : '',
                          relationship: element.relationship
                        })
                      }
                    } else {
                      if(element.id > 0) {
                        deleted_family_member_ids.push(element.id);
                      }
                    }
                  });
                  self.submitFamily.child.forEach(element => {
                    if(element.is_deleted == false) {
                      if(element.id < 0) {
                        allChild.push({
                          name: element.name,
                          cnic: element.cnic,
                          passport: element.passport,
                          gender: element.gender,
                          dob: element.dob != undefined && element.dob != '' ? moment(element.dob).format("YYYY-MM-DD") : '',
                          relationship: element.relationship
                        })
                      } else {
                        allChild.push({
                          id: element.id,
                          name: element.name,
                          cnic: element.cnic,
                          passport: element.passport,
                          gender: element.gender,
                          dob: element.dob != undefined && element.dob != '' ? moment(element.dob).format("YYYY-MM-DD") : '',
                          relationship: element.relationship
                        })
                      }
                    } else {
                      if(element.id > 0) {
                        deleted_family_member_ids.push(element.id);
                      }
                    }
                  });

                  var formData = new FormData();
                  formData.append('policy_id', self.quotationDetails.customer_quotation_id);
                  formData.append('spouse', JSON.stringify(allSpouse));
                  formData.append('child', JSON.stringify(allChild));
                  deleted_family_member_ids.forEach(element => {
                    formData.append('deleted_family_member_ids[]', element);
                  });

                  self.showLoader = true;
                  promises.push(axios.post('customer/store_family', formData).then(function (resp) {
                    if(resp.data.code == 200) {
                    } else {
                      self.showLoader = false;
                      $toast.error(resp.data.message, { position: 'top-right' });
                      return Promise.reject(resp);
                    }
                  }).catch(function (error) {
                    self.showLoader = false;
                    if(error.data.errors != undefined) {
                      error.data.errors.forEach(element => {
                        $toast.error(element.message, { position: 'top-right' });
                      });
                    } else {
                      $toast.error(error.data.message, { position: 'top-right' });
                    }
                    return Promise.reject(error);
                  }));
                }

                Promise.all(promises).then(() => {
                  self.showLoader = false;
                  if(self.requireSelfInspectionImages) {
                    self.uploadInformationStep = self.uploadInformationStep + 1;
                  } else {
                    if(self.showDocuments) {
                      self.uploadInformationStep = self.uploadInformationStep + 2;
                    } else {
                      self.submitStepThreeInformation();
                    }
                  }
                });
              } else {
                self.showLoader = false;
                if(self.requireSelfInspectionImages) {
                  self.uploadInformationStep = self.uploadInformationStep + 1;
                } else {
                  if(self.showDocuments) {
                    self.uploadInformationStep = self.uploadInformationStep + 2;
                  } else {
                    self.submitStepThreeInformation();
                  }
                }
              }
            }
          } else {
            self.showLoader = false;
            $toast.error(resp.data.message, { position: 'top-right' });
            return false;
          }
        }).catch(function (error) {
          self.showLoader = false;
          if(error.data.errors != undefined) {
            error.data.errors.forEach(element => {
              $toast.error(element.message, { position: 'top-right' });
            });
          } else {
            $toast.error(error.data.message, { position: 'top-right' });
          }
        });
      },
      uploadStepThreeMotorImages (e, field_name) {
        let self = this;
        if(e.target.files.length > 0) {
          var selectedFiles = e.target.files;
        } else {
          return false;
        }

        self.stepThreeMotorImagesErrors = [];
        if(selectedFiles[0]['type'].split('/')[0] != 'image') {
          $toast.error('Only image files are accepted', { position: 'top-right' });
        } else if (selectedFiles[0].size > 5000000) {
          $toast.error('Upload file less than 5Mb', { position: 'top-right' });
          return false;
        } else {
          self.stepThreeMotorImages[field_name] = [];
          self.stepThreeMotorImages[field_name].push(selectedFiles[0]);

          const file = e.target.files[0];
          var url = URL.createObjectURL(file);
          $('#_'+field_name).attr('src', url);
          self.stepThreeMotorImagesPath[field_name].push(url);
        }

      },
      uploadSelfInspectionImages(e, field_name, max_limit) {
        let self = this;
        if(e.target.files.length > 0) {
          var selectedFiles = e.target.files;
        } else {
          return false;
        }

        self.selfInspectionImagesErrors = [];
        for (let i = 0; i < selectedFiles.length; i++) {
          if(selectedFiles[i]['type'].split('/')[0] != 'image') {
            $toast.error('Only image files are accepted', { position: 'top-right' });
          } else if (selectedFiles[i].size > 5000000) {
            $toast.error('Upload file less than 5Mb', { position: 'top-right' });
            return false;
          } else {
            if(self.selfInspectionDynamicDocuments[field_name].length >= max_limit) {
              $toast.error('Only ' + max_limit + ' files allowed', { position: 'top-right' });
            } else {
              self.selfInspectionDynamicDocuments[field_name].push(selectedFiles[i]);
            }
          }
        }
      },
      removeSelfInspectionImages(index, fieldName) {
        const self = this;
        self.selfInspectionImagesErrors = [];
        self.selfInspectionDynamicDocuments[fieldName].splice(index, 1);
        self.selfInspectionDynamicDocuments.push({test: 'test'});
        self.selfInspectionDynamicDocuments.splice(-1,1);
      },
      validateSelfInspectionImages() {
        const self = this;
        self.selfInspectionImagesErrors = [];
        self.stepThreeMotorImagesErrors = [];
        Object.entries(self.selfInspectionSections).forEach(([key, section]) => {
          if(section.image_type == 'car') {
            // Object.entries(self.stepThreeMotorImages).forEach(([key1, field]) => {
            //   if(field.length <= 0) {
            //     self.stepThreeMotorImagesErrors.push({
            //       field: key1,
            //       message: key1.replace(/_/g,' ') + ' image required'
            //     });
            //   }
            // });
            //
            // if (self.stepThreeMotorImagesErrors.length > 0) {
            //   return false;
            // }

            Object.entries(self.stepThreeMotorImages).forEach(([key2, value]) => {
              if(value.length > 0) {
                self.selfInspectionDynamicDocuments[section.field_name].push(value[0]);
              }
            });
          }
        });

        Object.entries(self.selfInspectionSections).forEach(([key3, section1]) => {
          if(self.selfInspectionDynamicDocuments[section1.field_name].length < section1.min_images && section1.is_required) {
            if(section1.field_name == 'vehicle_images') {
              $toast.error('Minimum ' + section1.min_images + ' ' + section1.field_name.replace(/_/g,' ') + ' required', { position: 'top-right' });
            } else {
              $toast.error('Minimum ' + section1.min_images + ' ' + section1.field_name.replace(/_/g,' ') + ' images required', { position: 'top-right' });
            }

            self.selfInspectionImagesErrors.push({
              field: section1.field_name,
              message: section1.field_name.replace(/_/g,' ') + ' images required'
            });
          }
        });

        if(self.selfInspectionImagesErrors.length > 0) {
          return false;
        }

        if(self.showDocuments) {
          self.uploadInformationStep = self.uploadInformationStep + 1;
        } else {
          self.submitStepThreeInformation();
        }
      },
      uploadStepThreeImages(e, field_name, max_limit) {
        let self = this;
        if(e.target.files.length > 0) {
          var selectedFiles = e.target.files;
        } else {
          return false;
        }

        self.stepThreeDocumentsErrors = [];
        if(field_name == 'signature_document') {
          self.stepThreeDynamicDocuments[field_name] = [];
        }
        for (let i = 0; i < selectedFiles.length; i++) {
          if(selectedFiles[i]['type'].split('/')[0] != 'image') {
            $toast.error('Only image files are accepted', { position: 'top-right' });
          } else if (selectedFiles[i].size > 5000000) {
            $toast.error('Upload file less than 5Mb', { position: 'top-right' });
            return false;
          } else {
            if(self.stepThreeDynamicDocuments[field_name].length >= max_limit) {
              $toast.error('Only ' + max_limit + ' files allowed', { position: 'top-right' });
            } else {
              self.stepThreeDynamicDocuments[field_name].push(selectedFiles[i]);
            }
          }
        }

        self.stepThreeDocumentSections.push({test: 'test'});
        self.stepThreeDocumentSections.splice(-1,1);
      },
      removeStepThreeUploadedImage(index, fieldName) {
        const self = this;
        self.stepThreeDocumentsErrors = []
        self.stepThreeDynamicDocuments[fieldName].splice(index, 1);
        self.stepThreeDocumentSections.push({test: 'test'});
        self.stepThreeDocumentSections.splice(-1,1);
      },
      async submitStepThreeInformation() {
        const self = this;

        if(self.showDocuments) {
          self.stepThreeDocumentsErrors = []
          Object.entries(self.stepThreeDynamicDocuments).forEach(([key, value]) => {
            if (value.length == 0) {
              let field = self.stepThreeDocumentSections.filter(x => x.field_name == key)[0]
              if(field.required) {
                self.stepThreeDocumentsErrors.push({
                  field: key,
                  message: key.replace(/_/g,' ') + ' required'
                });
              }
            }
          });
        }

        let result = Object.values(self.declaration).every(v => v === true);
        if(!result) {
          $toast.error('Please accept all declaration statements to proceed', { position: 'top-right' })
          return false;
        }

        if (self.stepThreeDocumentsErrors.length > 0) {
          return false;
        }

        let stepThreeDynamicFieldsFinal = {};
        Object.entries(self.stepThreeDynamicFields).forEach(([key, value]) => {
          Object.entries(self.stepThreeSections).forEach(([key1, section]) => {
            Object.entries(section.custom_fields).forEach(([key2, secField]) => {
              if (secField.field_name == key) {
                if(secField.type.toLowerCase() == 'date') {
                  stepThreeDynamicFieldsFinal[key] = moment(value).format("YYYY-MM-DD");
                } else {
                  stepThreeDynamicFieldsFinal[key] = value;
                }
              }
            })
          });
        });

        var formData = new FormData();
        formData.append('customer_quotation_id', self.quotationDetails.customer_quotation_id);
        formData.append('subclass_id', self.selectedSubclassId);

        Object.entries(stepThreeDynamicFieldsFinal).forEach(([key, value]) => {
          formData.append(key, value);
        });

        if(self.showDocuments) {
          Object.entries(self.stepThreeDynamicDocuments).forEach(([key, value]) => {
            if (key == 'signature_document') {
              let doc = value[0];
              formData.append('signature', doc);
            } else {
              value.forEach(element => {
                formData.append(key + '[]', element);
              });
            }
          });
        }

        if(self.classType == 'motor' && self.requireSelfInspectionImages) {
          Object.entries(self.stepThreeMotorImages).forEach(([key, value]) => {
            value.forEach(element => {
              formData.append('images[]', element);
            });
          });
        }

        self.showLoader = true;
        await axios.post('customer/quotation_additional_information', formData, { headers: { 'Content-Type': 'multipart/form-data' } }).then(function (resp) {
          if(resp.data.code == 200) {
            self.mobileNumberVerified = false;
            self.getPaymentMethods();
          } else {
            self.showLoader = false;
            $toast.error(resp.data.message, { position: 'top-right' });
            return false;
          }
        }).catch(function (error) {
          self.showLoader = false;
          if(error.data.errors != undefined) {
            error.data.errors.forEach(element => {
              $toast.error(element.message, { position: 'top-right' });
            });
          } else {
            $toast.error(error.data.message, { position: 'top-right' });
          }
        });
      },
      async getPaymentMethods() {
        const self = this;
        var formData = new FormData();
        formData.append('customer_quotation_id', self.quotationDetails.customer_quotation_id);
        formData.append('subclass_id', self.selectedSubclassId);

        self.showLoader = true;
        await axios.post('customer/payment_gateways', formData).then(function (resp) {
          if(resp.data.code == 200) {
            self.getPlanPromos();
            if(resp.data.data.payment_methods.length > 0) {
              self.paymentMethods = resp.data.data.payment_methods;
              //self.selectedPaymentMethod = self.paymentMethods[0].payment_method;
            }
            if(!self.quotationPaymentStatus) {
              self.updateStep(1);
              self.showLoader = false;
            } else {
              self.showLoader = true;
              self.stepThreePaymentMethod();
            }
          } else {
            self.showLoader = false;
            $toast.error(resp.data.message, { position: 'top-right' });
            return false;
          }
        }).catch(function (error) {
          self.showLoader = false;
          if(error.data.errors != undefined) {
            error.data.errors.forEach(element => {
              $toast.error(element.message, { position: 'top-right' });
            });
          } else {
            $toast.error(error.data.message, { position: 'top-right' });
          }
        });
      },
      async getPlanPromos() {
        const self = this;
        let plan_id = self.selectedProduct.plan_id;
        await axios.post('customer/user_plan_promos', { plan_id: plan_id }).then(function (resp) {
          if(resp.data.code == 200) {
            self.planPromos = resp.data.data;
          } else {
            self.showLoader = false;
            $toast.error(resp.data.message, { position: 'top-right' });
            return false;
          }
        }).catch(function (error) {
          self.showLoader = false;
          if(error.data.errors != undefined) {
            error.data.errors.forEach(element => {
              $toast.error(element.message, { position: 'top-right' });
            });
          } else {
            $toast.error(error.data.message, { position: 'top-right' });
          }
        });
      },
      async processPromoCode(val) {
        const self = this;
        if(val == 1) {
          if(self.promoCode == '') {
            $toast.error('Enter Promo Code!', { position: 'top-right' });
            return false;
          }
          var formData = new FormData();
          formData.append('customer_quotation_id', self.quotationDetails.customer_quotation_id);
          formData.append('promo_code', self.promoCode);
          formData.append('amount', self.calculatedProductPrice);

          self.showLoader = true;
          await axios.post('apply_promo', formData).then(function (resp) {
            self.showLoader = false;
            if(resp.data.code == 200) {
              self.promoCodeDiscountType = resp.data.data.discount_type;
              self.promoCodeDiscount = resp.data.data.discount;
              self.promoCodeDiscountAmount = parseInt(resp.data.data.discount_price);
              self.calculatedProductPriceWithDiscount = self.calculatedProductPrice - self.promoCodeDiscountAmount;
              self.promoCodeApplied = true;
            } else {
              $toast.error(resp.data.message, { position: 'top-right' });
              self.promoCodeDiscountType = '';
              self.promoCodeDiscount = 0;
              self.promoCodeDiscountAmount = 0;
              self.calculatedProductPriceWithDiscount = 0;
              self.promoCodeApplied = false;
              return false;
            }
          }).catch(function (error) {
            self.showLoader = false;
            if(error.data.errors != undefined) {
              error.data.errors.forEach(element => {
                $toast.error(element.message, { position: 'top-right' });
              });
            } else {
              $toast.error(error.data.message, { position: 'top-right' });
            }
          });
        } else {
          self.promoCodeApplied = false;
          self.promoCode = '';
          self.promoCodeDiscountType = '';
          self.promoCodeDiscount = 0;
          self.promoCodeDiscountAmount = 0;
          self.calculatedProductPriceWithDiscount = 0;
        }
      },
      choosePaymentMethod(methodName) {
        const self = this;
        self.selectedPaymentMethod = methodName;
      },
      uploadChequeImages(e) {
        let self = this;
        if(e.target.files.length > 0) {
          var selectedFiles = e.target.files;
        } else {
          return false;
        }

        for (let i = 0; i < selectedFiles.length; i++) {
          if(selectedFiles[i]['type'].split('/')[0] != 'image') {
            $toast.error('Only image files are accepted', { position: 'top-right' });
          } else if (selectedFiles[i].size > 5000000) {
            $toast.error('Upload file less than 5Mb', { position: 'top-right' });
            return false;
          } else {
            if(self.chequeImages.length >= 2) {
              $toast.error('Max 2 files allowed', { position: 'top-right' });
            } else {
              self.chequeImages.push(selectedFiles[i]);
            }
          }
        }
      },
      removeUploadedChequeImage(index) {
        const self = this;
        self.chequeImages.splice(index, 1)
      },
      ContinuePaymentMethod() {
        const self = this;

        if(self.selectedPaymentMethod == '') {
          $toast.error('Please Select payment Method!', { position: 'top-right' });
          return false;
        }

        if(self.selectedPaymentMethod.toLowerCase() == 'cheque') {
          Object.entries(self.cheque).forEach(([key, value]) => {
            if (value === '') {
              self.chequePaymentMethodErrors.push({
                field: key,
                message: key.replace(/_/g,' ') + ' required'
              })
            }
          });

          if (self.chequeImages.length == 0) {
            self.chequePaymentMethodErrors.push({
              field: 'cheque_image',
              message: 'Image required'
            })
          }

          if(self.chequePaymentMethodErrors.length > 0) {
            self.showLoader = false;
            self.selectedPaymentMethod = 'cheque'
            return false;
          }
        } else if (self.selectedPaymentMethod.toLowerCase() == 'cash') {

        } else if (self.selectedPaymentMethod.toLowerCase() == 'stripe') {

        } else if (self.selectedPaymentMethod.toLowerCase() == 'free') {

        } else if (self.selectedPaymentMethod.toLowerCase() == 'easypaisa') {
          self.easyPaisaMethodErrors = [];
          self.easyPaisaUrl = '';
          if(self.easypaisa.mobile_no == '') {
            self.easyPaisaMethodErrors.push({
              field: 'mobile_no',
              message: 'Mobile Number required'
            })
          }
          if(self.easypaisa.email == '') {
            self.easyPaisaMethodErrors.push({
              field: 'email',
              message: 'Email required'
            })
          }
          if(self.easypaisa.email != '') {
            const re = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
            let result = re.test(String(self.easypaisa.email).toLowerCase());
            if(!result) {
              self.easyPaisaMethodErrors.push({
                field: 'email',
                message: 'Invalid Email'
              });
            }
          }
          if(self.easyPaisaMethodErrors.length > 0) {
            return false;
          }
        }

        this.$swal.fire({
          text: "Would You Like To Pay",
          icon: '',
          showCancelButton: true,
          cancelButtonColor: '#d33',
          cancelButtonText: 'No',
          confirmButtonColor: '#f77c94',
          confirmButtonText: 'Yes'
        }).then((result) => {
          if (result.isConfirmed) {
            if(!self.mobileNumberVerified) {
              self.showMobileNumberVerificationModal();
              return false;
            } else {
              self.proceedPayment();
            }
          }
        });
      },
      async showMobileNumberVerificationModal() {
        const self = this;
        self.otpMobile = '';
        let fieldName = '';

        Object.entries(self.stepOneSections).forEach(([key1, section]) => {
          Object.entries(section.custom_fields).forEach(([key2, secField]) => {
            if (secField.inputType == 'mobile') {
              fieldName = secField.field_name;
            }
          })
        });

        if(fieldName != '') {
          self.otpMobile = self.stepOneDynamicFields[fieldName];
        } else {
          Object.entries(self.stepThreeSections).forEach(([key1, section]) => {
            Object.entries(section.custom_fields).forEach(([key2, secField]) => {
              if (secField.inputType == 'mobile') {
                fieldName = secField.field_name;
              }
            })
          });
        }

        if(fieldName != '') {
          self.otpMobile = self.stepThreeDynamicFields[fieldName];
        } else {
          $toast.error('Mobile Number Not Found!', { position: 'top-right' });
          return false;
        }

        var formData = new FormData();
        formData.append('customer_quotation_id', self.quotationDetails.customer_quotation_id);
        formData.append('mobile_no', self.otpMobile);

        await axios.post('customer/quotation/send_otp', formData).then(function (resp) {
          if(resp.data.code == 200) {
            $toast.success(resp.data.message, { position: 'top-right' });
            self.renderVerifyMobileModal = true;
            document.getElementById('VerifyMobileModal').style.display = 'block';
          } else {
            self.showLoader = false;
            $toast.error(resp.data.message, { position: 'top-right' });
            return false;
          }
        }).catch(function (error) {
          self.showLoader = false;
          if(error.data.errors != undefined) {
            error.data.errors.forEach(element => {
              $toast.error(element.message, { position: 'top-right' });
            });
          } else {
            $toast.error(error.data.message, { position: 'top-right' });
          }
        });
      },
      closeVerifyMobileModal() {
        const self = this;
        self.renderVerifyMobileModal = false;
        self.otpMobile = '';
        document.getElementById('VerifyMobileModal').style.display = 'none';
      },
      async updateMobileNumber(newNumber, oldNumber) {
        const self = this;
        let fieldName = '';

        Object.entries(self.stepOneSections).forEach(([key1, section]) => {
          Object.entries(section.custom_fields).forEach(([key2, secField]) => {
            if (secField.inputType == 'mobile') {
              fieldName = secField.field_name;
            }
          })
        });

        if(fieldName != '') {
          self.stepOneDynamicFields[fieldName] = newNumber;
        } else {
          Object.entries(self.stepThreeSections).forEach(([key1, section]) => {
            Object.entries(section.custom_fields).forEach(([key2, secField]) => {
              if (secField.inputType == 'mobile') {
                fieldName = secField.field_name;
              }
            })
          });
        }

        if(fieldName != '') {
          self.stepThreeDynamicFields[fieldName] = newNumber;
        } else {
          $toast.error('Mobile Number Not Found!', { position: 'top-right' });
          return false;
        }

        var formData = new FormData();
        formData.append('customer_quotation_id', self.quotationDetails.customer_quotation_id);
        formData.append(fieldName, newNumber);

        await axios.post('customer/quotation/update_data', formData).then(function (resp) {
          if(resp.data.code == 200) {
            $toast.success('Mobile Number Updated SuccessFully!!', { position: 'top-right' });
            var formData = new FormData();
            formData.append('customer_quotation_id', self.quotationDetails.customer_quotation_id);
            formData.append('mobile_no', newNumber);

            axios.post('customer/quotation/send_otp', formData).then(function (resp) {
              if(resp.data.code == 200) {
                $toast.success(resp.data.message, { position: 'top-right' });
                self.renderVerifyMobileModal = true;
                document.getElementById('VerifyMobileModal').style.display = 'block';
              } else {
                self.showLoader = false;
                $toast.error(resp.data.message, { position: 'top-right' });
                return false;
              }
            }).catch(function (error) {
              self.showLoader = false;
              if(error.response) {
                error.response.data.errors.forEach(element => {
                  $toast.error(element.message, { position: 'top-right' });
                });
              } else {
                $toast.error(error.data.message, { position: 'top-right' });
              }
            });
          } else {
            self.showLoader = false;

            Object.entries(self.stepOneSections).forEach(([key1, section]) => {
              Object.entries(section.custom_fields).forEach(([key2, secField]) => {
                if (secField.inputType == 'mobile') {
                  fieldName = secField.field_name;
                }
              })
            });

            if(fieldName != '') {
              self.stepOneDynamicFields[fieldName] = oldNumber;
            } else {
              Object.entries(self.stepThreeSections).forEach(([key1, section]) => {
                Object.entries(section.custom_fields).forEach(([key2, secField]) => {
                  if (secField.inputType == 'mobile') {
                    fieldName = secField.field_name;
                  }
                })
              });
            }

            if(fieldName != '') {
              self.stepThreeDynamicFields[fieldName] = oldNumber;
            } else {
              $toast.error('Mobile Number Not Found!', { position: 'top-right' });
              return false;
            }

            self.otpMobile = oldNumber;
            self.$root.$emit('updateModalMobileNumber', oldNumber);

            $toast.error(resp.data.message, { position: 'top-right' });
            return false;
          }
        }).catch(function (error) {
          self.showLoader = false;

          Object.entries(self.stepOneSections).forEach(([key1, section]) => {
            Object.entries(section.custom_fields).forEach(([key2, secField]) => {
              if (secField.inputType == 'mobile') {
                fieldName = secField.field_name;
              }
            })
          });

          if(fieldName != '') {
            self.stepOneDynamicFields[fieldName] = oldNumber;
          } else {
            Object.entries(self.stepThreeSections).forEach(([key1, section]) => {
              Object.entries(section.custom_fields).forEach(([key2, secField]) => {
                if (secField.inputType == 'mobile') {
                  fieldName = secField.field_name;
                }
              })
            });
          }

          if(fieldName != '') {
            self.stepThreeDynamicFields[fieldName] = oldNumber;
          } else {
            $toast.error('Mobile Number Not Found!', { position: 'top-right' });
            return false;
          }

          self.otpMobile = oldNumber;
          self.$root.$emit('updateModalMobileNumber', oldNumber);

          if(error.response) {
            error.response.data.errors.forEach(element => {
              $toast.error(element.message, { position: 'top-right' });
            });
          } else {
            $toast.error(error.data.message, { position: 'top-right' });
          }
        });
      },
      mobileNumberVerifiedPost() {
        const self = this;
        self.renderVerifyMobileModal = false;
        self.otpMobile = '';
        self.mobileNumberVerified = true;
        document.getElementById('VerifyMobileModal').style.display = 'none';
        self.proceedPayment();
      },
      proceedPayment() {
        const self = this;

        let transactionId = '';
        if(self.selectedPaymentMethod.toLowerCase() == 'cheque') {
          self.showLoader = true;
          self.proceedToCheckPayment(transactionId);
        } else if (self.selectedPaymentMethod.toLowerCase() == 'cash') {
          self.showLoader = true;
          self.proceedToCheckPayment(transactionId);
        } else if (self.selectedPaymentMethod.toLowerCase() == 'stripe') {
          self.stepOnePaymentMethod();
        } else if (self.selectedPaymentMethod.toLowerCase() == 'free') {
          self.showLoader = true;
          self.proceedToCheckPayment(transactionId);
        } else if (self.selectedPaymentMethod.toLowerCase() == 'easypaisa') {
          self.stepOneEasyPaisaPaymentMethod();
        }
      },
      async proceedToCheckPayment(transactionId) {
        const self = this;
        self.chequePaymentMethodErrors = [];
        self.cardPaymentMethodErrors = [];

        var formData = new FormData();
        formData.append('customer_quotation_id', self.quotationDetails.customer_quotation_id);
        formData.append('subclass_id', self.selectedSubclassId);
        formData.append('plan_id', self.selectedProduct.id);
        formData.append('original_price', self.calculatedProductPrice);
        if(self.promoCodeApplied) {
          formData.append('paid_amount', self.calculatedProductPriceWithDiscount);
          formData.append('promo_code', self.promoCode);
        } else {
          formData.append('paid_amount', self.calculatedProductPrice);
        }

        if(self.selectedPaymentMethod.toLowerCase() == 'cheque') {
          formData.append('payment_method', 'cheque');
          formData.append('cheque_no', self.cheque.cheque_no);
          formData.append('cheque_issue_date', self.cheque.cheque_issue_date);
          formData.append('cheque_images', self.chequeImages);
        } else if (self.selectedPaymentMethod.toLowerCase() == 'cash') {
          formData.append('payment_method', 'cash');
        } else if (self.selectedPaymentMethod.toLowerCase() == 'stripe') {
          formData.append('payment_method', 'credit_card');
          formData.append('transaction_id', transactionId);
        } else if (self.selectedPaymentMethod.toLowerCase() == 'free') {
          formData.append('payment_method', 'free');
        } else if (self.selectedPaymentMethod.toLowerCase() == 'easypaisa') {
          formData.append('payment_method', 'easypaisa');
          formData.append('transaction_id', transactionId);
        }

        self.showLoader = true;
        await axios.post('customer/check_payment_method', formData, { headers: { 'Content-Type': 'multipart/form-data' } }).then(function (resp) {
          if(resp.data.code == 200) {
            self.completeAcquisition();
          } else {
            self.showLoader = false;
            $toast.error(resp.data.message, { position: 'top-right' });
            return false;
          }
        }).catch(function (error) {
          self.showLoader = false;
          if(error.data.errors != undefined) {
            error.data.errors.forEach(element => {
              $toast.error(element.message, { position: 'top-right' });
            });
          } else {
            $toast.error(error.data.message, { position: 'top-right' });
          }
        });
      },
      async completeAcquisition() {
        const self = this;

        var formData = new FormData();
        formData.append('customer_quotation_id', self.quotationDetails.customer_quotation_id);
        formData.append('subclass_id', self.selectedSubclassId);
        formData.append(  'company_id', '1');

        self.showLoader = true;
        await axios.post('customer/register_policy', formData).then(function (resp) {
          self.showLoader = false;
          if(resp.data.code == 200) {
            self.promos = resp.data.data.promos;
            self.pdfLink = resp.data.data.pdf_link;
            self.submittedAcquisitionResponse.product = resp.data.data.product;
            self.submittedAcquisitionResponse.quotation = resp.data.data.quotation;
            self.updateStep(1);
          } else {
            self.showLoader = false;
            $toast.error(resp.data.message, { position: 'top-right' });
            return false;
          }
        }).catch(function (error) {
          self.showLoader = false;
          if(error.data.errors != undefined) {
            error.data.errors.forEach(element => {
              $toast.error(element.message, { position: 'top-right' });
            });
          } else {
            $toast.error(error.data.message, { position: 'top-right' });
          }
        });
      },
      flushPolicyDetails() {
        const self = this;
        self.$store.commit('resetQuotationData');
        self.showSubmitted = true;
      },
      updateStep(step) {
        const self = this;
        if (step == 1) {
          self.nav_step = self.nav_step + 1;
        } else if (step == -1) {
          self.nav_step = self.nav_step - 1;
        } else {
          self.nav_step = self.nav_step + step;
        }
      }
    }
  };
</script>



// WEBPACK FOOTER //
// src/views/AbandonedCart/AbandonedRenew.vue